export type Maybe<T> = T | null | undefined;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any,
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any,
  /** The `ObjectId` scalar type represents an object id encoded either as a string or an object in the form of { _id: string } */
  ObjectId: any,
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any,
  Upload: any,
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any,
};


export type Accessory = {
  __typename?: 'Accessory',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  type?: Maybe<AccessoryType>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export enum AccessoryType {
  Radio = 'radio',
  AccessCard = 'accessCard',
  InterimBadge = 'interimBadge',
  RemoteControl = 'remoteControl'
}

export type Accomodation = {
  __typename?: 'Accomodation',
  accomodationType?: Maybe<AccomodationType>,
  accomodation?: Maybe<Lodging>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  note?: Maybe<Scalars['String']>,
  additionalAccomodation?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type AccomodationObjectFilterType = {
  accomodationType?: Maybe<AccomodationTypeFilter>,
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  note?: Maybe<StringFilter>,
  additionalAccomodation?: Maybe<StringFilter>,
  bookingStatus?: Maybe<BookingStatusFilter>,
  opr?: Maybe<OprExists>,
};

export enum AccomodationType {
  NoPreference = 'noPreference',
  NoAccomodation = 'noAccomodation',
  AccomodationWithPreference = 'accomodationWithPreference'
}

/** Filter type for AccomodationType scalar */
export type AccomodationTypeFilter = {
  /** $eq */
  EQ?: Maybe<AccomodationType>,
  /** $gt */
  GT?: Maybe<AccomodationType>,
  /** $gte */
  GTE?: Maybe<AccomodationType>,
  /** $in */
  IN?: Maybe<Array<Maybe<AccomodationType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<AccomodationType>>>,
  /** $lt */
  LT?: Maybe<AccomodationType>,
  /** $lte */
  LTE?: Maybe<AccomodationType>,
  /** $ne */
  NE?: Maybe<AccomodationType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<AccomodationType>>>,
  /** $not */
  NOT?: Maybe<AccomodationTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<AccomodationType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<AccomodationType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<AccomodationType>,
};

/** Filter type for $not of AccomodationType scalar */
export type AccomodationTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<AccomodationType>,
  /** $gt */
  GT?: Maybe<AccomodationType>,
  /** $gte */
  GTE?: Maybe<AccomodationType>,
  /** $in */
  IN?: Maybe<Array<Maybe<AccomodationType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<AccomodationType>>>,
  /** $lt */
  LT?: Maybe<AccomodationType>,
  /** $lte */
  LTE?: Maybe<AccomodationType>,
  /** $ne */
  NE?: Maybe<AccomodationType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<AccomodationType>>>,
};

/** 
 * Whether or not a certain ProvingType is available to choose
 * from when creating a Proving
 **/
export type ActiveProvingTypesSetting = GlobalSetting & {
  __typename?: 'ActiveProvingTypesSetting',
  _id: Scalars['ID'],
  type: GlobalSettingType,
  typeSettings: Array<ProvingTypeSetting>,
};

export type Blob = {
  __typename?: 'Blob',
  uri: Scalars['ID'],
  containerUri: Scalars['String'],
  name: Scalars['String'],
};

export type BlobInput = {
  uri: Scalars['String'],
  containerUri: Scalars['String'],
  name: Scalars['String'],
};

export enum BookingStatus {
  NotRequired = 'notRequired',
  Open = 'open',
  WorkInProgress = 'workInProgress',
  Finished = 'finished',
  FleetVehicle = 'fleetVehicle'
}

/** Filter type for BookingStatus scalar */
export type BookingStatusFilter = {
  /** $eq */
  EQ?: Maybe<BookingStatus>,
  /** $gt */
  GT?: Maybe<BookingStatus>,
  /** $gte */
  GTE?: Maybe<BookingStatus>,
  /** $in */
  IN?: Maybe<Array<Maybe<BookingStatus>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<BookingStatus>>>,
  /** $lt */
  LT?: Maybe<BookingStatus>,
  /** $lte */
  LTE?: Maybe<BookingStatus>,
  /** $ne */
  NE?: Maybe<BookingStatus>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<BookingStatus>>>,
  /** $not */
  NOT?: Maybe<BookingStatusNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<BookingStatus>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<BookingStatus>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<BookingStatus>,
};

/** Filter type for $not of BookingStatus scalar */
export type BookingStatusNotFilter = {
  /** $eq */
  EQ?: Maybe<BookingStatus>,
  /** $gt */
  GT?: Maybe<BookingStatus>,
  /** $gte */
  GTE?: Maybe<BookingStatus>,
  /** $in */
  IN?: Maybe<Array<Maybe<BookingStatus>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<BookingStatus>>>,
  /** $lt */
  LT?: Maybe<BookingStatus>,
  /** $lte */
  LTE?: Maybe<BookingStatus>,
  /** $ne */
  NE?: Maybe<BookingStatus>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<BookingStatus>>>,
};

/** Filter type for Boolean scalar */
export type BooleanFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Boolean']>,
  /** $gt */
  GT?: Maybe<Scalars['Boolean']>,
  /** $gte */
  GTE?: Maybe<Scalars['Boolean']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Boolean']>,
  /** $lte */
  LTE?: Maybe<Scalars['Boolean']>,
  /** $ne */
  NE?: Maybe<Scalars['Boolean']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
  /** $not */
  NOT?: Maybe<BooleanNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['Boolean']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['Boolean']>,
};

/** Filter type for $not of Boolean scalar */
export type BooleanNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Boolean']>,
  /** $gt */
  GT?: Maybe<Scalars['Boolean']>,
  /** $gte */
  GTE?: Maybe<Scalars['Boolean']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Boolean']>,
  /** $lte */
  LTE?: Maybe<Scalars['Boolean']>,
  /** $ne */
  NE?: Maybe<Scalars['Boolean']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Boolean']>>>,
};

export type Building = {
  __typename?: 'Building',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  type?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  offices: Array<Office>,
};

export enum CarType {
  None = 'none',
  Compact = 'compact',
  MidSize = 'midSize',
  FullSize = 'fullSize',
  Estate = 'estate',
  Minibus = 'minibus'
}

/** Filter type for CarType scalar */
export type CarTypeFilter = {
  /** $eq */
  EQ?: Maybe<CarType>,
  /** $gt */
  GT?: Maybe<CarType>,
  /** $gte */
  GTE?: Maybe<CarType>,
  /** $in */
  IN?: Maybe<Array<Maybe<CarType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<CarType>>>,
  /** $lt */
  LT?: Maybe<CarType>,
  /** $lte */
  LTE?: Maybe<CarType>,
  /** $ne */
  NE?: Maybe<CarType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<CarType>>>,
  /** $not */
  NOT?: Maybe<CarTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<CarType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<CarType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<CarType>,
};

/** Filter type for $not of CarType scalar */
export type CarTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<CarType>,
  /** $gt */
  GT?: Maybe<CarType>,
  /** $gte */
  GTE?: Maybe<CarType>,
  /** $in */
  IN?: Maybe<Array<Maybe<CarType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<CarType>>>,
  /** $lt */
  LT?: Maybe<CarType>,
  /** $lte */
  LTE?: Maybe<CarType>,
  /** $ne */
  NE?: Maybe<CarType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<CarType>>>,
};

export type ChargingInfrastructure = {
  __typename?: 'ChargingInfrastructure',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId: Scalars['String'],
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type ChargingInfrastructureInsertType = {
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId: Scalars['String'],
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type ChargingInfrastructureObjectFilterType = {
  _id?: Maybe<StringFilter>,
  title?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  parentId?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  unit?: Maybe<StringFilter>,
  costPerUnit?: Maybe<FloatFilter>,
  opr?: Maybe<OprExists>,
};

export type ChargingInfrastructureSetListObjectType = {
  _id?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  parentId?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type ChargingInfrastructureSetOnInsertType = {
  _id?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  parentId?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export enum CheckType {
  Wiki = 'Wiki',
  News = 'News',
  All = 'All'
}

export type ColdCell = {
  __typename?: 'ColdCell',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  type?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type Convolute = Node & {
  __typename?: 'Convolute',
  _id: Scalars['ID'],
  type: ConvoluteType,
  activeRuleset?: Maybe<GdprRule>,
  modifiedBy?: Maybe<User>,
  modified?: Maybe<Scalars['DateTime']>,
};

export type ConvoluteFilterType = {
  _id?: Maybe<IdFilter>,
  type?: Maybe<ConvoluteTypeFilter>,
  activeRuleset?: Maybe<GdprRuleObjectFilterType>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  OR?: Maybe<Array<Maybe<ConvoluteFilterType>>>,
  AND?: Maybe<Array<Maybe<ConvoluteFilterType>>>,
  NOR?: Maybe<Array<Maybe<ConvoluteFilterType>>>,
};

export type ConvoluteInput = {
  type: ConvoluteType,
  activeRuleset?: Maybe<Scalars['ObjectId']>,
};

export type ConvoluteSortType = {
  _id?: Maybe<SortType>,
  type?: Maybe<SortType>,
  activeRuleset?: Maybe<GdprRuleSortType>,
  modifiedBy?: Maybe<UserSortType>,
  modified?: Maybe<SortType>,
};

export enum ConvoluteType {
  ProvingConvolute = 'provingConvolute',
  NewsConvolute = 'newsConvolute',
  CoreDataConvolute = 'coreDataConvolute'
}

/** Filter type for ConvoluteType scalar */
export type ConvoluteTypeFilter = {
  /** $eq */
  EQ?: Maybe<ConvoluteType>,
  /** $gt */
  GT?: Maybe<ConvoluteType>,
  /** $gte */
  GTE?: Maybe<ConvoluteType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ConvoluteType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ConvoluteType>>>,
  /** $lt */
  LT?: Maybe<ConvoluteType>,
  /** $lte */
  LTE?: Maybe<ConvoluteType>,
  /** $ne */
  NE?: Maybe<ConvoluteType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ConvoluteType>>>,
  /** $not */
  NOT?: Maybe<ConvoluteTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<ConvoluteType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<ConvoluteType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<ConvoluteType>,
};

/** Filter type for $not of ConvoluteType scalar */
export type ConvoluteTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<ConvoluteType>,
  /** $gt */
  GT?: Maybe<ConvoluteType>,
  /** $gte */
  GTE?: Maybe<ConvoluteType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ConvoluteType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ConvoluteType>>>,
  /** $lt */
  LT?: Maybe<ConvoluteType>,
  /** $lte */
  LTE?: Maybe<ConvoluteType>,
  /** $ne */
  NE?: Maybe<ConvoluteType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ConvoluteType>>>,
};

export type CostDistributionInput = {
  testTracks?: Maybe<Array<ResourceCostDistributionInput>>,
  workstations?: Maybe<Array<ResourceCostDistributionInput>>,
  liftingPlatforms?: Maybe<Array<ResourceCostDistributionInput>>,
  garages?: Maybe<Array<ResourceCostDistributionInput>>,
  coldcells?: Maybe<Array<ResourceCostDistributionInput>>,
  accomodations?: Maybe<Array<ResourceCostDistributionInput>>,
  radios?: Maybe<Array<ResourceCostDistributionInput>>,
  fuelCards?: Maybe<Array<ResourceCostDistributionInput>>,
  accessCards?: Maybe<Array<ResourceCostDistributionInput>>,
};

export type CostDistributionReportInput = {
  provingGround: Scalars['String'],
  dateFrom: Scalars['Date'],
  dateTo: Scalars['Date'],
  generalCostEnabled?: Maybe<Scalars['Boolean']>,
  generalCost?: Maybe<Scalars['Float']>,
  useResourceBooking?: Maybe<Scalars['Boolean']>,
  costDistribution?: Maybe<CostDistributionInput>,
};

export type DangerousGood = Node & {
  __typename?: 'DangerousGood',
  _id: Scalars['ID'],
  unNumber: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  createdBy?: Maybe<User>,
  created?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<User>,
  modified?: Maybe<Scalars['DateTime']>,
  _deleted?: Maybe<Scalars['Boolean']>,
};

export type DangerousGoodFilterType = {
  _id?: Maybe<IdFilter>,
  unNumber?: Maybe<StringFilter>,
  description?: Maybe<StringFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  created?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  _deleted?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<DangerousGoodFilterType>>>,
  AND?: Maybe<Array<Maybe<DangerousGoodFilterType>>>,
  NOR?: Maybe<Array<Maybe<DangerousGoodFilterType>>>,
};

export type DangerousGoodIncType = {
  createdBy?: Maybe<UserIncType>,
  modifiedBy?: Maybe<UserIncType>,
};

export type DangerousGoodInsertType = {
  _id?: Maybe<Scalars['ID']>,
  unNumber: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  _deleted?: Maybe<Scalars['Boolean']>,
};

export type DangerousGoodObjectFilterType = {
  _id?: Maybe<IdFilter>,
  unNumber?: Maybe<StringFilter>,
  description?: Maybe<StringFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  created?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  _deleted?: Maybe<BooleanFilter>,
  opr?: Maybe<OprExists>,
};

export type DangerousGoodSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  unNumber?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  createdBy?: Maybe<UserSetOnInsertType>,
  created?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<UserSetOnInsertType>,
  modified?: Maybe<Scalars['DateTime']>,
  _deleted?: Maybe<Scalars['Boolean']>,
};

export type DangerousGoodSetType = {
  _id?: Maybe<Scalars['ID']>,
  unNumber?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  createdBy?: Maybe<UserSetObjectType>,
  created?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<UserSetObjectType>,
  modified?: Maybe<Scalars['DateTime']>,
  _deleted?: Maybe<Scalars['Boolean']>,
};

export type DangerousGoodSortType = {
  _id?: Maybe<SortType>,
  unNumber?: Maybe<SortType>,
  description?: Maybe<SortType>,
  createdBy?: Maybe<UserSortType>,
  created?: Maybe<SortType>,
  modifiedBy?: Maybe<UserSortType>,
  modified?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
};

export type DangerousGoodUpdateType = {
  setOnInsert?: Maybe<DangerousGoodSetOnInsertType>,
  set?: Maybe<DangerousGoodSetType>,
  inc?: Maybe<DangerousGoodIncType>,
};


/** Filter type for Date scalar */
export type DateFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Date']>,
  /** $gt */
  GT?: Maybe<Scalars['Date']>,
  /** $gte */
  GTE?: Maybe<Scalars['Date']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Date']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Date']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Date']>,
  /** $lte */
  LTE?: Maybe<Scalars['Date']>,
  /** $ne */
  NE?: Maybe<Scalars['Date']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Date']>>>,
  /** $not */
  NOT?: Maybe<DateNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['Date']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['Date']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['Date']>,
};

/** Filter type for $not of Date scalar */
export type DateNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Date']>,
  /** $gt */
  GT?: Maybe<Scalars['Date']>,
  /** $gte */
  GTE?: Maybe<Scalars['Date']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Date']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Date']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Date']>,
  /** $lte */
  LTE?: Maybe<Scalars['Date']>,
  /** $ne */
  NE?: Maybe<Scalars['Date']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Date']>>>,
};


/** Filter type for DateTime scalar */
export type DateTimeFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['DateTime']>,
  /** $gt */
  GT?: Maybe<Scalars['DateTime']>,
  /** $gte */
  GTE?: Maybe<Scalars['DateTime']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
  /** $lt */
  LT?: Maybe<Scalars['DateTime']>,
  /** $lte */
  LTE?: Maybe<Scalars['DateTime']>,
  /** $ne */
  NE?: Maybe<Scalars['DateTime']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
  /** $not */
  NOT?: Maybe<DateTimeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['DateTime']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['DateTime']>,
};

/** Filter type for $not of DateTime scalar */
export type DateTimeNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['DateTime']>,
  /** $gt */
  GT?: Maybe<Scalars['DateTime']>,
  /** $gte */
  GTE?: Maybe<Scalars['DateTime']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
  /** $lt */
  LT?: Maybe<Scalars['DateTime']>,
  /** $lte */
  LTE?: Maybe<Scalars['DateTime']>,
  /** $ne */
  NE?: Maybe<Scalars['DateTime']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['DateTime']>>>,
};

export type Department = Node & {
  __typename?: 'Department',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  department: Scalars['String'],
  headOfDepartment: User,
  persons?: Maybe<Array<Person>>,
};

export type DepartmentFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  department?: Maybe<StringFilter>,
  headOfDepartment?: Maybe<UserObjectFilterType>,
  OR?: Maybe<Array<Maybe<DepartmentFilterType>>>,
  AND?: Maybe<Array<Maybe<DepartmentFilterType>>>,
  NOR?: Maybe<Array<Maybe<DepartmentFilterType>>>,
};

export type DepartmentInsertInput = {
  department: Scalars['String'],
  headOfDepartment: Scalars['ObjectId'],
};

export type DepartmentSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  department?: Maybe<SortType>,
  headOfDepartment?: Maybe<UserSortType>,
};

export type DepartmentUpdateInput = {
  department: Scalars['String'],
  headOfDepartment: Scalars['ObjectId'],
};

export enum Empty {
  Nope = 'NOPE'
}

export type EqVehicle = {
  __typename?: 'EQVehicle',
  _id: Scalars['ID'],
  id?: Maybe<Scalars['String']>,
  eqNr?: Maybe<Scalars['String']>,
  internalLabel?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  modelYear?: Maybe<Scalars['String']>,
  category?: Maybe<Scalars['String']>,
  constructionPhase?: Maybe<Scalars['String']>,
  vin?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  typeDescription?: Maybe<Scalars['String']>,
  derivative?: Maybe<Scalars['String']>,
};

export type EqVehicleFilterType = {
  _id?: Maybe<IdFilter>,
  id?: Maybe<StringFilter>,
  eqNr?: Maybe<StringFilter>,
  internalLabel?: Maybe<StringFilter>,
  label?: Maybe<StringFilter>,
  licensePlate?: Maybe<StringFilter>,
  modelYear?: Maybe<StringFilter>,
  category?: Maybe<StringFilter>,
  constructionPhase?: Maybe<StringFilter>,
  vin?: Maybe<StringFilter>,
  type?: Maybe<StringFilter>,
  typeDescription?: Maybe<StringFilter>,
  derivative?: Maybe<StringFilter>,
  OR?: Maybe<Array<Maybe<EqVehicleFilterType>>>,
  AND?: Maybe<Array<Maybe<EqVehicleFilterType>>>,
  NOR?: Maybe<Array<Maybe<EqVehicleFilterType>>>,
};

export type EqVehicleInput = {
  id?: Maybe<Scalars['String']>,
  eqNr: Scalars['String'],
  internalLabel?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  modelYear?: Maybe<Scalars['String']>,
  category?: Maybe<Scalars['String']>,
  constructionPhase?: Maybe<Scalars['String']>,
  vin?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  typeDescription?: Maybe<Scalars['String']>,
  derivative?: Maybe<Scalars['String']>,
};

export type EqVehicleModelInfo = {
  __typename?: 'EqVehicleModelInfo',
  type: Scalars['String'],
  typeDescription?: Maybe<Scalars['String']>,
};

export type EqVehicleSortType = {
  _id?: Maybe<SortType>,
  id?: Maybe<SortType>,
  eqNr?: Maybe<SortType>,
  internalLabel?: Maybe<SortType>,
  label?: Maybe<SortType>,
  licensePlate?: Maybe<SortType>,
  modelYear?: Maybe<SortType>,
  category?: Maybe<SortType>,
  constructionPhase?: Maybe<SortType>,
  vin?: Maybe<SortType>,
  type?: Maybe<SortType>,
  typeDescription?: Maybe<SortType>,
  derivative?: Maybe<SortType>,
};

export type ExcelImportResult = {
  __typename?: 'ExcelImportResult',
  total: Scalars['Int'],
  created: Scalars['Int'],
  modified: Scalars['Int'],
};

export type ExternalVehicle = Vehicle & {
  __typename?: 'ExternalVehicle',
  _id: Scalars['ID'],
  type: VehicleType,
  unknown: Scalars['Boolean'],
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  transport?: Maybe<Transport>,
  model?: Maybe<Scalars['String']>,
  group?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  licensePlateType?: Maybe<LicensePlateType>,
  vin?: Maybe<Scalars['String']>,
  labelExternal?: Maybe<Scalars['String']>,
  exportedToSAP?: Maybe<Scalars['Boolean']>,
  _changes?: Maybe<ProvingChangeTracking>,
};

export type Ferry = {
  __typename?: 'Ferry',
  outward?: Maybe<FerryConnection>,
  return?: Maybe<FerryConnection>,
  dateTo?: Maybe<Scalars['Date']>,
  timeTo?: Maybe<Scalars['String']>,
  dateFrom?: Maybe<Scalars['Date']>,
  timeFrom?: Maybe<Scalars['String']>,
  note?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type FerryConnection = {
  __typename?: 'FerryConnection',
  _id: Scalars['String'],
  title: Scalars['String'],
  type: Scalars['String'],
  inactive: Scalars['Boolean'],
  origin?: Maybe<Scalars['String']>,
  destination?: Maybe<Scalars['String']>,
};

export type FerryObjectFilterType = {
  dateTo?: Maybe<DateFilter>,
  timeTo?: Maybe<StringFilter>,
  dateFrom?: Maybe<DateFilter>,
  timeFrom?: Maybe<StringFilter>,
  note?: Maybe<StringFilter>,
  bookingStatus?: Maybe<BookingStatusFilter>,
  opr?: Maybe<OprExists>,
};

/** 
 * Used for files stored in a Blob, that need to be available globally (!!).
 * Don't use for other stuff, use FileTemplate collection instead.
 **/
export type FileSetting = GlobalSetting & {
  __typename?: 'FileSetting',
  _id: Scalars['ID'],
  type: GlobalSettingType,
  file: Blob,
};

export type FileTemplate = Node & {
  __typename?: 'FileTemplate',
  _id: Scalars['ID'],
  created: Scalars['DateTime'],
  createdBy: User,
  modified: Scalars['DateTime'],
  modifiedBy: User,
  fileName: Scalars['String'],
  uri: Scalars['String'],
  type: FileTemplateType,
  cellMapping?: Maybe<Scalars['String']>,
  provingGround?: Maybe<ProvingGround>,
};

export type FileTemplateFilterType = {
  _id?: Maybe<IdFilter>,
  created?: Maybe<DateTimeFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  fileName?: Maybe<StringFilter>,
  uri?: Maybe<StringFilter>,
  type?: Maybe<FileTemplateTypeFilter>,
  cellMapping?: Maybe<StringFilter>,
  provingGround?: Maybe<ProvingGroundObjectFilterType>,
  OR?: Maybe<Array<Maybe<FileTemplateFilterType>>>,
  AND?: Maybe<Array<Maybe<FileTemplateFilterType>>>,
  NOR?: Maybe<Array<Maybe<FileTemplateFilterType>>>,
};

export type FileTemplateInsertInput = {
  fileName: Scalars['String'],
  uri: Scalars['String'],
  type: FileTemplateType,
  cellMapping?: Maybe<Scalars['String']>,
  provingGround?: Maybe<Scalars['ObjectId']>,
};

export type FileTemplateSortType = {
  _id?: Maybe<SortType>,
  created?: Maybe<SortType>,
  createdBy?: Maybe<UserSortType>,
  modified?: Maybe<SortType>,
  modifiedBy?: Maybe<UserSortType>,
  fileName?: Maybe<SortType>,
  uri?: Maybe<SortType>,
  type?: Maybe<SortType>,
  cellMapping?: Maybe<SortType>,
  provingGround?: Maybe<ProvingGroundSortType>,
};

export enum FileTemplateType {
  NotAssigned = 'notAssigned',
  InternalMemo = 'internalMemo',
  ArrivalSheet = 'arrivalSheet',
  ApplicationForm = 'applicationForm',
  TemporaryPass = 'temporaryPass',
  PassActivation = 'passActivation',
  PermanentDriveAuthorization = 'permanentDriveAuthorization',
  SingleDriveAuthorization = 'singleDriveAuthorization',
  DvEquipment = 'dvEquipment',
  PartsTransport = 'partsTransport',
  DriverTraining = 'driverTraining'
}

/** Filter type for FileTemplateType scalar */
export type FileTemplateTypeFilter = {
  /** $eq */
  EQ?: Maybe<FileTemplateType>,
  /** $gt */
  GT?: Maybe<FileTemplateType>,
  /** $gte */
  GTE?: Maybe<FileTemplateType>,
  /** $in */
  IN?: Maybe<Array<Maybe<FileTemplateType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<FileTemplateType>>>,
  /** $lt */
  LT?: Maybe<FileTemplateType>,
  /** $lte */
  LTE?: Maybe<FileTemplateType>,
  /** $ne */
  NE?: Maybe<FileTemplateType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<FileTemplateType>>>,
  /** $not */
  NOT?: Maybe<FileTemplateTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<FileTemplateType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<FileTemplateType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<FileTemplateType>,
};

/** Filter type for $not of FileTemplateType scalar */
export type FileTemplateTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<FileTemplateType>,
  /** $gt */
  GT?: Maybe<FileTemplateType>,
  /** $gte */
  GTE?: Maybe<FileTemplateType>,
  /** $in */
  IN?: Maybe<Array<Maybe<FileTemplateType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<FileTemplateType>>>,
  /** $lt */
  LT?: Maybe<FileTemplateType>,
  /** $lte */
  LTE?: Maybe<FileTemplateType>,
  /** $ne */
  NE?: Maybe<FileTemplateType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<FileTemplateType>>>,
};

export type FileTemplateUpdateInput = {
  type?: Maybe<FileTemplateType>,
  cellMapping?: Maybe<Scalars['String']>,
  provingGround?: Maybe<Scalars['String']>,
};

export enum FileType {
  Word = 'word',
  Excel = 'excel'
}

/** Filter type for FileType scalar */
export type FileTypeFilter = {
  /** $eq */
  EQ?: Maybe<FileType>,
  /** $gt */
  GT?: Maybe<FileType>,
  /** $gte */
  GTE?: Maybe<FileType>,
  /** $in */
  IN?: Maybe<Array<Maybe<FileType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<FileType>>>,
  /** $lt */
  LT?: Maybe<FileType>,
  /** $lte */
  LTE?: Maybe<FileType>,
  /** $ne */
  NE?: Maybe<FileType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<FileType>>>,
  /** $not */
  NOT?: Maybe<FileTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<FileType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<FileType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<FileType>,
};

/** Filter type for $not of FileType scalar */
export type FileTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<FileType>,
  /** $gt */
  GT?: Maybe<FileType>,
  /** $gte */
  GTE?: Maybe<FileType>,
  /** $in */
  IN?: Maybe<Array<Maybe<FileType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<FileType>>>,
  /** $lt */
  LT?: Maybe<FileType>,
  /** $lte */
  LTE?: Maybe<FileType>,
  /** $ne */
  NE?: Maybe<FileType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<FileType>>>,
};

export type FixedRates = {
  __typename?: 'FixedRates',
  participantPerDay?: Maybe<Scalars['Float']>,
  vehiclePerDay?: Maybe<Scalars['Float']>,
  feePerDay?: Maybe<Scalars['Float']>,
  serviceTeamPerDay?: Maybe<Scalars['Float']>,
  workshopPerDay?: Maybe<Scalars['Float']>,
  coldcellPerDay?: Maybe<Scalars['Float']>,
  allowancePerDay?: Maybe<Scalars['Float']>,
  hotelPerNight?: Maybe<Scalars['Float']>,
  compactRentalPerDay?: Maybe<Scalars['Float']>,
  midSizeRentalPerDay?: Maybe<Scalars['Float']>,
  fullSizeRentalPerDay?: Maybe<Scalars['Float']>,
  estateRentalPerDay?: Maybe<Scalars['Float']>,
  minibusRentalPerDay?: Maybe<Scalars['Float']>,
  flightPerRoute?: Maybe<Scalars['Float']>,
  ferryPerParticipant?: Maybe<Scalars['Float']>,
  ferryPerVehicle?: Maybe<Scalars['Float']>,
  useParticipantPerDay?: Maybe<Scalars['Boolean']>,
  useVehiclePerDay?: Maybe<Scalars['Boolean']>,
  useFeePerDay?: Maybe<Scalars['Boolean']>,
  useServiceTeamPerDay?: Maybe<Scalars['Boolean']>,
  useWorkshopPerDay?: Maybe<Scalars['Boolean']>,
  useColdcellPerDay?: Maybe<Scalars['Boolean']>,
  useAllowancePerDay?: Maybe<Scalars['Boolean']>,
  useHotelPerNight?: Maybe<Scalars['Boolean']>,
  useCompactRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMidSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFullSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useEstateRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMinibusRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFlightPerRoute?: Maybe<Scalars['Boolean']>,
  useFerryPerParticipant?: Maybe<Scalars['Boolean']>,
  useFerryPerVehicle?: Maybe<Scalars['Boolean']>,
};

export type FixedRatesIncType = {
  participantPerDay?: Maybe<Scalars['Float']>,
  vehiclePerDay?: Maybe<Scalars['Float']>,
  feePerDay?: Maybe<Scalars['Float']>,
  serviceTeamPerDay?: Maybe<Scalars['Float']>,
  workshopPerDay?: Maybe<Scalars['Float']>,
  coldcellPerDay?: Maybe<Scalars['Float']>,
  allowancePerDay?: Maybe<Scalars['Float']>,
  hotelPerNight?: Maybe<Scalars['Float']>,
  compactRentalPerDay?: Maybe<Scalars['Float']>,
  midSizeRentalPerDay?: Maybe<Scalars['Float']>,
  fullSizeRentalPerDay?: Maybe<Scalars['Float']>,
  estateRentalPerDay?: Maybe<Scalars['Float']>,
  minibusRentalPerDay?: Maybe<Scalars['Float']>,
  flightPerRoute?: Maybe<Scalars['Float']>,
  ferryPerParticipant?: Maybe<Scalars['Float']>,
  ferryPerVehicle?: Maybe<Scalars['Float']>,
};

export type FixedRatesInsertType = {
  participantPerDay?: Maybe<Scalars['Float']>,
  vehiclePerDay?: Maybe<Scalars['Float']>,
  feePerDay?: Maybe<Scalars['Float']>,
  serviceTeamPerDay?: Maybe<Scalars['Float']>,
  workshopPerDay?: Maybe<Scalars['Float']>,
  coldcellPerDay?: Maybe<Scalars['Float']>,
  allowancePerDay?: Maybe<Scalars['Float']>,
  hotelPerNight?: Maybe<Scalars['Float']>,
  compactRentalPerDay?: Maybe<Scalars['Float']>,
  midSizeRentalPerDay?: Maybe<Scalars['Float']>,
  fullSizeRentalPerDay?: Maybe<Scalars['Float']>,
  estateRentalPerDay?: Maybe<Scalars['Float']>,
  minibusRentalPerDay?: Maybe<Scalars['Float']>,
  flightPerRoute?: Maybe<Scalars['Float']>,
  ferryPerParticipant?: Maybe<Scalars['Float']>,
  ferryPerVehicle?: Maybe<Scalars['Float']>,
  useParticipantPerDay?: Maybe<Scalars['Boolean']>,
  useVehiclePerDay?: Maybe<Scalars['Boolean']>,
  useFeePerDay?: Maybe<Scalars['Boolean']>,
  useServiceTeamPerDay?: Maybe<Scalars['Boolean']>,
  useWorkshopPerDay?: Maybe<Scalars['Boolean']>,
  useColdcellPerDay?: Maybe<Scalars['Boolean']>,
  useAllowancePerDay?: Maybe<Scalars['Boolean']>,
  useHotelPerNight?: Maybe<Scalars['Boolean']>,
  useCompactRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMidSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFullSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useEstateRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMinibusRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFlightPerRoute?: Maybe<Scalars['Boolean']>,
  useFerryPerParticipant?: Maybe<Scalars['Boolean']>,
  useFerryPerVehicle?: Maybe<Scalars['Boolean']>,
};

export type FixedRatesObjectFilterType = {
  participantPerDay?: Maybe<FloatFilter>,
  vehiclePerDay?: Maybe<FloatFilter>,
  feePerDay?: Maybe<FloatFilter>,
  serviceTeamPerDay?: Maybe<FloatFilter>,
  workshopPerDay?: Maybe<FloatFilter>,
  coldcellPerDay?: Maybe<FloatFilter>,
  allowancePerDay?: Maybe<FloatFilter>,
  hotelPerNight?: Maybe<FloatFilter>,
  compactRentalPerDay?: Maybe<FloatFilter>,
  midSizeRentalPerDay?: Maybe<FloatFilter>,
  fullSizeRentalPerDay?: Maybe<FloatFilter>,
  estateRentalPerDay?: Maybe<FloatFilter>,
  minibusRentalPerDay?: Maybe<FloatFilter>,
  flightPerRoute?: Maybe<FloatFilter>,
  ferryPerParticipant?: Maybe<FloatFilter>,
  ferryPerVehicle?: Maybe<FloatFilter>,
  useParticipantPerDay?: Maybe<BooleanFilter>,
  useVehiclePerDay?: Maybe<BooleanFilter>,
  useFeePerDay?: Maybe<BooleanFilter>,
  useServiceTeamPerDay?: Maybe<BooleanFilter>,
  useWorkshopPerDay?: Maybe<BooleanFilter>,
  useColdcellPerDay?: Maybe<BooleanFilter>,
  useAllowancePerDay?: Maybe<BooleanFilter>,
  useHotelPerNight?: Maybe<BooleanFilter>,
  useCompactRentalPerDay?: Maybe<BooleanFilter>,
  useMidSizeRentalPerDay?: Maybe<BooleanFilter>,
  useFullSizeRentalPerDay?: Maybe<BooleanFilter>,
  useEstateRentalPerDay?: Maybe<BooleanFilter>,
  useMinibusRentalPerDay?: Maybe<BooleanFilter>,
  useFlightPerRoute?: Maybe<BooleanFilter>,
  useFerryPerParticipant?: Maybe<BooleanFilter>,
  useFerryPerVehicle?: Maybe<BooleanFilter>,
  opr?: Maybe<OprExists>,
};

export type FixedRatesSetObjectType = {
  participantPerDay?: Maybe<Scalars['Float']>,
  vehiclePerDay?: Maybe<Scalars['Float']>,
  feePerDay?: Maybe<Scalars['Float']>,
  serviceTeamPerDay?: Maybe<Scalars['Float']>,
  workshopPerDay?: Maybe<Scalars['Float']>,
  coldcellPerDay?: Maybe<Scalars['Float']>,
  allowancePerDay?: Maybe<Scalars['Float']>,
  hotelPerNight?: Maybe<Scalars['Float']>,
  compactRentalPerDay?: Maybe<Scalars['Float']>,
  midSizeRentalPerDay?: Maybe<Scalars['Float']>,
  fullSizeRentalPerDay?: Maybe<Scalars['Float']>,
  estateRentalPerDay?: Maybe<Scalars['Float']>,
  minibusRentalPerDay?: Maybe<Scalars['Float']>,
  flightPerRoute?: Maybe<Scalars['Float']>,
  ferryPerParticipant?: Maybe<Scalars['Float']>,
  ferryPerVehicle?: Maybe<Scalars['Float']>,
  useParticipantPerDay?: Maybe<Scalars['Boolean']>,
  useVehiclePerDay?: Maybe<Scalars['Boolean']>,
  useFeePerDay?: Maybe<Scalars['Boolean']>,
  useServiceTeamPerDay?: Maybe<Scalars['Boolean']>,
  useWorkshopPerDay?: Maybe<Scalars['Boolean']>,
  useColdcellPerDay?: Maybe<Scalars['Boolean']>,
  useAllowancePerDay?: Maybe<Scalars['Boolean']>,
  useHotelPerNight?: Maybe<Scalars['Boolean']>,
  useCompactRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMidSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFullSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useEstateRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMinibusRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFlightPerRoute?: Maybe<Scalars['Boolean']>,
  useFerryPerParticipant?: Maybe<Scalars['Boolean']>,
  useFerryPerVehicle?: Maybe<Scalars['Boolean']>,
  /** 
 * If set to true, the object would be overwriten entirely, including fields that
   * are not specified. Non-null validation rules will apply. Once set to true, any
   * child object will overwriten invariably of the value set to this field.
 **/
  _OVERWRITE?: Maybe<Scalars['Boolean']>,
};

export type FixedRatesSetOnInsertType = {
  participantPerDay?: Maybe<Scalars['Float']>,
  vehiclePerDay?: Maybe<Scalars['Float']>,
  feePerDay?: Maybe<Scalars['Float']>,
  serviceTeamPerDay?: Maybe<Scalars['Float']>,
  workshopPerDay?: Maybe<Scalars['Float']>,
  coldcellPerDay?: Maybe<Scalars['Float']>,
  allowancePerDay?: Maybe<Scalars['Float']>,
  hotelPerNight?: Maybe<Scalars['Float']>,
  compactRentalPerDay?: Maybe<Scalars['Float']>,
  midSizeRentalPerDay?: Maybe<Scalars['Float']>,
  fullSizeRentalPerDay?: Maybe<Scalars['Float']>,
  estateRentalPerDay?: Maybe<Scalars['Float']>,
  minibusRentalPerDay?: Maybe<Scalars['Float']>,
  flightPerRoute?: Maybe<Scalars['Float']>,
  ferryPerParticipant?: Maybe<Scalars['Float']>,
  ferryPerVehicle?: Maybe<Scalars['Float']>,
  useParticipantPerDay?: Maybe<Scalars['Boolean']>,
  useVehiclePerDay?: Maybe<Scalars['Boolean']>,
  useFeePerDay?: Maybe<Scalars['Boolean']>,
  useServiceTeamPerDay?: Maybe<Scalars['Boolean']>,
  useWorkshopPerDay?: Maybe<Scalars['Boolean']>,
  useColdcellPerDay?: Maybe<Scalars['Boolean']>,
  useAllowancePerDay?: Maybe<Scalars['Boolean']>,
  useHotelPerNight?: Maybe<Scalars['Boolean']>,
  useCompactRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMidSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFullSizeRentalPerDay?: Maybe<Scalars['Boolean']>,
  useEstateRentalPerDay?: Maybe<Scalars['Boolean']>,
  useMinibusRentalPerDay?: Maybe<Scalars['Boolean']>,
  useFlightPerRoute?: Maybe<Scalars['Boolean']>,
  useFerryPerParticipant?: Maybe<Scalars['Boolean']>,
  useFerryPerVehicle?: Maybe<Scalars['Boolean']>,
};

export type FixedRatesSortType = {
  participantPerDay?: Maybe<SortType>,
  vehiclePerDay?: Maybe<SortType>,
  feePerDay?: Maybe<SortType>,
  serviceTeamPerDay?: Maybe<SortType>,
  workshopPerDay?: Maybe<SortType>,
  coldcellPerDay?: Maybe<SortType>,
  allowancePerDay?: Maybe<SortType>,
  hotelPerNight?: Maybe<SortType>,
  compactRentalPerDay?: Maybe<SortType>,
  midSizeRentalPerDay?: Maybe<SortType>,
  fullSizeRentalPerDay?: Maybe<SortType>,
  estateRentalPerDay?: Maybe<SortType>,
  minibusRentalPerDay?: Maybe<SortType>,
  flightPerRoute?: Maybe<SortType>,
  ferryPerParticipant?: Maybe<SortType>,
  ferryPerVehicle?: Maybe<SortType>,
  useParticipantPerDay?: Maybe<SortType>,
  useVehiclePerDay?: Maybe<SortType>,
  useFeePerDay?: Maybe<SortType>,
  useServiceTeamPerDay?: Maybe<SortType>,
  useWorkshopPerDay?: Maybe<SortType>,
  useColdcellPerDay?: Maybe<SortType>,
  useAllowancePerDay?: Maybe<SortType>,
  useHotelPerNight?: Maybe<SortType>,
  useCompactRentalPerDay?: Maybe<SortType>,
  useMidSizeRentalPerDay?: Maybe<SortType>,
  useFullSizeRentalPerDay?: Maybe<SortType>,
  useEstateRentalPerDay?: Maybe<SortType>,
  useMinibusRentalPerDay?: Maybe<SortType>,
  useFlightPerRoute?: Maybe<SortType>,
  useFerryPerParticipant?: Maybe<SortType>,
  useFerryPerVehicle?: Maybe<SortType>,
};

export type Fleet = {
  __typename?: 'Fleet',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  type?: Maybe<Scalars['String']>,
  parentId?: Maybe<Scalars['String']>,
  parent?: Maybe<Building>,
};

export type Flight = {
  __typename?: 'Flight',
  flightType?: Maybe<FlightType>,
  note?: Maybe<Scalars['String']>,
  outboundData?: Maybe<FlightMetadata>,
  returnData?: Maybe<FlightMetadata>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type FlightMetadata = {
  __typename?: 'FlightMetadata',
  airline?: Maybe<Scalars['String']>,
  flightNumber?: Maybe<Scalars['String']>,
  departure?: Maybe<Scalars['Date']>,
  departureTime?: Maybe<Scalars['String']>,
};

export type FlightMetadataObjectFilterType = {
  airline?: Maybe<StringFilter>,
  flightNumber?: Maybe<StringFilter>,
  departure?: Maybe<DateFilter>,
  departureTime?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export type FlightObjectFilterType = {
  flightType?: Maybe<FlightTypeFilter>,
  note?: Maybe<StringFilter>,
  outboundData?: Maybe<FlightMetadataObjectFilterType>,
  returnData?: Maybe<FlightMetadataObjectFilterType>,
  bookingStatus?: Maybe<BookingStatusFilter>,
  opr?: Maybe<OprExists>,
};

export enum FlightType {
  NoFlight = 'noFlight',
  OutboundFlight = 'outboundFlight',
  ReturnFlight = 'returnFlight',
  Roundtrip = 'roundtrip'
}

/** Filter type for FlightType scalar */
export type FlightTypeFilter = {
  /** $eq */
  EQ?: Maybe<FlightType>,
  /** $gt */
  GT?: Maybe<FlightType>,
  /** $gte */
  GTE?: Maybe<FlightType>,
  /** $in */
  IN?: Maybe<Array<Maybe<FlightType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<FlightType>>>,
  /** $lt */
  LT?: Maybe<FlightType>,
  /** $lte */
  LTE?: Maybe<FlightType>,
  /** $ne */
  NE?: Maybe<FlightType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<FlightType>>>,
  /** $not */
  NOT?: Maybe<FlightTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<FlightType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<FlightType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<FlightType>,
};

/** Filter type for $not of FlightType scalar */
export type FlightTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<FlightType>,
  /** $gt */
  GT?: Maybe<FlightType>,
  /** $gte */
  GTE?: Maybe<FlightType>,
  /** $in */
  IN?: Maybe<Array<Maybe<FlightType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<FlightType>>>,
  /** $lt */
  LT?: Maybe<FlightType>,
  /** $lte */
  LTE?: Maybe<FlightType>,
  /** $ne */
  NE?: Maybe<FlightType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<FlightType>>>,
};

/** Filter type for Float scalar */
export type FloatFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Float']>,
  /** $gt */
  GT?: Maybe<Scalars['Float']>,
  /** $gte */
  GTE?: Maybe<Scalars['Float']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Float']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Float']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Float']>,
  /** $lte */
  LTE?: Maybe<Scalars['Float']>,
  /** $ne */
  NE?: Maybe<Scalars['Float']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Float']>>>,
  /** $not */
  NOT?: Maybe<FloatNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['Float']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['Float']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['Float']>,
};

/** Filter type for $not of Float scalar */
export type FloatNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Float']>,
  /** $gt */
  GT?: Maybe<Scalars['Float']>,
  /** $gte */
  GTE?: Maybe<Scalars['Float']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Float']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Float']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Float']>,
  /** $lte */
  LTE?: Maybe<Scalars['Float']>,
  /** $ne */
  NE?: Maybe<Scalars['Float']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Float']>>>,
};

export type Forms = {
  __typename?: 'Forms',
  temporaryPass?: Maybe<GeneratedDocument>,
  passActivation?: Maybe<GeneratedDocument>,
  permanentDriveAuthorization?: Maybe<GeneratedDocument>,
  singleDriveAuthorization?: Maybe<GeneratedDocument>,
  dvEquipment?: Maybe<GeneratedDocument>,
  partsTransport?: Maybe<GeneratedDocument>,
  driverTraining?: Maybe<GeneratedDocument>,
};

export type FormsObjectFilterType = {
  temporaryPass?: Maybe<GeneratedDocumentObjectFilterType>,
  passActivation?: Maybe<GeneratedDocumentObjectFilterType>,
  permanentDriveAuthorization?: Maybe<GeneratedDocumentObjectFilterType>,
  singleDriveAuthorization?: Maybe<GeneratedDocumentObjectFilterType>,
  dvEquipment?: Maybe<GeneratedDocumentObjectFilterType>,
  partsTransport?: Maybe<GeneratedDocumentObjectFilterType>,
  driverTraining?: Maybe<GeneratedDocumentObjectFilterType>,
  opr?: Maybe<OprExists>,
};

export type Fuel = {
  __typename?: 'Fuel',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId: Scalars['String'],
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type FuelInsertType = {
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId: Scalars['String'],
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type FuelObjectFilterType = {
  _id?: Maybe<StringFilter>,
  title?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  parentId?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  unit?: Maybe<StringFilter>,
  costPerUnit?: Maybe<FloatFilter>,
  opr?: Maybe<OprExists>,
};

export type FuelSetListObjectType = {
  _id?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  parentId?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type FuelSetOnInsertType = {
  _id?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  parentId?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type Garage = {
  __typename?: 'Garage',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  type?: Maybe<Scalars['String']>,
  parentId?: Maybe<Scalars['String']>,
  parent?: Maybe<Building>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  liftingPlatforms: Array<LiftingPlatform>,
};

export type GdprRule = Node & {
  __typename?: 'GDPRRule',
  _id: Scalars['ID'],
  ruleName: Scalars['String'],
  retentionPeriod?: Maybe<Scalars['Float']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  createdBy?: Maybe<User>,
  created?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<User>,
  modified?: Maybe<Scalars['DateTime']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type GdprRuleFilterType = {
  _id?: Maybe<IdFilter>,
  ruleName?: Maybe<StringFilter>,
  retentionPeriod?: Maybe<FloatFilter>,
  deletionPeriod?: Maybe<FloatFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  created?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  inactive?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<GdprRuleFilterType>>>,
  AND?: Maybe<Array<Maybe<GdprRuleFilterType>>>,
  NOR?: Maybe<Array<Maybe<GdprRuleFilterType>>>,
};

export type GdprRuleIncType = {
  retentionPeriod?: Maybe<Scalars['Float']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  createdBy?: Maybe<UserIncType>,
  modifiedBy?: Maybe<UserIncType>,
};

export type GdprRuleInsertType = {
  _id?: Maybe<Scalars['ID']>,
  ruleName: Scalars['String'],
  retentionPeriod?: Maybe<Scalars['Float']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  createdBy?: Maybe<UserInsertType>,
  created?: Maybe<Scalars['DateTime']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type GdprRuleObjectFilterType = {
  _id?: Maybe<IdFilter>,
  ruleName?: Maybe<StringFilter>,
  retentionPeriod?: Maybe<FloatFilter>,
  deletionPeriod?: Maybe<FloatFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  created?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  inactive?: Maybe<BooleanFilter>,
  opr?: Maybe<OprExists>,
};

export type GdprRuleSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  ruleName?: Maybe<Scalars['String']>,
  retentionPeriod?: Maybe<Scalars['Float']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  createdBy?: Maybe<UserSetOnInsertType>,
  created?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<UserSetOnInsertType>,
  modified?: Maybe<Scalars['DateTime']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type GdprRuleSetType = {
  _id?: Maybe<Scalars['ID']>,
  ruleName?: Maybe<Scalars['String']>,
  retentionPeriod?: Maybe<Scalars['Float']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  createdBy?: Maybe<UserSetObjectType>,
  created?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<UserSetObjectType>,
  modified?: Maybe<Scalars['DateTime']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type GdprRuleSortType = {
  _id?: Maybe<SortType>,
  ruleName?: Maybe<SortType>,
  retentionPeriod?: Maybe<SortType>,
  deletionPeriod?: Maybe<SortType>,
  createdBy?: Maybe<UserSortType>,
  created?: Maybe<SortType>,
  modifiedBy?: Maybe<UserSortType>,
  modified?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
};

export type GdprRuleUpdateType = {
  setOnInsert?: Maybe<GdprRuleSetOnInsertType>,
  set?: Maybe<GdprRuleSetType>,
  inc?: Maybe<GdprRuleIncType>,
};

export type GeneratedDocument = {
  __typename?: 'GeneratedDocument',
  uri: Scalars['String'],
  name: Scalars['String'],
  type?: Maybe<FileType>,
};

export type GeneratedDocumentInputType = {
  uri: Scalars['String'],
  name: Scalars['String'],
  type?: Maybe<FileType>,
};

export type GeneratedDocumentObjectFilterType = {
  uri?: Maybe<StringFilter>,
  name?: Maybe<StringFilter>,
  type?: Maybe<FileTypeFilter>,
  opr?: Maybe<OprExists>,
};

export type GeneratedDocumentSortType = {
  uri?: Maybe<SortType>,
  name?: Maybe<SortType>,
  type?: Maybe<SortType>,
};

export type GlobalMessage = {
  __typename?: 'GlobalMessage',
  isActive: Scalars['Boolean'],
  message?: Maybe<Scalars['String']>,
};

export type GlobalMessageInput = {
  isActive: Scalars['Boolean'],
  message?: Maybe<Scalars['String']>,
};

export type GlobalMessageSetting = GlobalSetting & {
  __typename?: 'GlobalMessageSetting',
  _id: Scalars['ID'],
  type: GlobalSettingType,
  globalMessage?: Maybe<GlobalMessage>,
};

export type GlobalSetting = {
  _id: Scalars['ID'],
  type: GlobalSettingType,
};

export type GlobalSettingInput = {
  type: GlobalSettingType,
  options?: Maybe<Array<Scalars['String']>>,
  typeSettings?: Maybe<Array<ProvingTypeSettingInput>>,
  value?: Maybe<Scalars['String']>,
  file?: Maybe<BlobInput>,
  globalMessage?: Maybe<GlobalMessageInput>,
};

export enum GlobalSettingType {
  VehicleTypes = 'vehicleTypes',
  DeclineReasons = 'declineReasons',
  DocumentTypes = 'documentTypes',
  ActiveProvingTypes = 'activeProvingTypes',
  DvtWvtCheck = 'dvtWvtCheck',
  HeadOfProvingCheck = 'headOfProvingCheck',
  MultiSelectEditorCheck = 'multiSelectEditorCheck',
  MultiSelectResponsibleCheck = 'multiSelectResponsibleCheck',
  MultiSelectSubstituteCheck = 'multiSelectSubstituteCheck',
  AdminsOnlyResponsibleCheck = 'adminsOnlyResponsibleCheck',
  AdminsOnlySubstituteCheck = 'adminsOnlySubstituteCheck',
  EnableGroupsCheck = 'enableGroupsCheck',
  HasIncompleteBookingsCheck = 'hasIncompleteBookingsCheck',
  DeletionPeriod = 'deletionPeriod',
  ExcelOverviewTemplate = 'excelOverviewTemplate',
  CostDistributionTemplate = 'costDistributionTemplate',
  GlobalMessage = 'globalMessage'
}

export type HeadOfProving = {
  __typename?: 'HeadOfProving',
  isHeadOfProving?: Maybe<Scalars['Boolean']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
};

export type HeadOfProvingObjectFilterType = {
  isHeadOfProving?: Maybe<BooleanFilter>,
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  opr?: Maybe<OprExists>,
};

/** Filter type for ID scalar */
export type IdFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['ID']>,
  /** $gt */
  GT?: Maybe<Scalars['ID']>,
  /** $gte */
  GTE?: Maybe<Scalars['ID']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['ID']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['ID']>>>,
  /** $lt */
  LT?: Maybe<Scalars['ID']>,
  /** $lte */
  LTE?: Maybe<Scalars['ID']>,
  /** $ne */
  NE?: Maybe<Scalars['ID']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['ID']>>>,
  /** $not */
  NOT?: Maybe<IdNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['ID']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['ID']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['ID']>,
};

/** Filter type for $not of ID scalar */
export type IdNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['ID']>,
  /** $gt */
  GT?: Maybe<Scalars['ID']>,
  /** $gte */
  GTE?: Maybe<Scalars['ID']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['ID']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['ID']>>>,
  /** $lt */
  LT?: Maybe<Scalars['ID']>,
  /** $lte */
  LTE?: Maybe<Scalars['ID']>,
  /** $ne */
  NE?: Maybe<Scalars['ID']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type InternalMemo = {
  __typename?: 'InternalMemo',
  mailingList?: Maybe<Array<User>>,
  memo?: Maybe<GeneratedDocument>,
  testRecipient?: Maybe<User>,
  state?: Maybe<InternalMemoState>,
  sentOn?: Maybe<Scalars['DateTime']>,
};

export type InternalMemoInputType = {
  mailingList?: Maybe<Array<Scalars['ObjectId']>>,
  memo?: Maybe<GeneratedDocumentInputType>,
  testRecipient?: Maybe<Scalars['ObjectId']>,
  state?: Maybe<InternalMemoState>,
  sentOn?: Maybe<Scalars['DateTime']>,
};

export type InternalMemoObjectFilterType = {
  memo?: Maybe<GeneratedDocumentObjectFilterType>,
  state?: Maybe<InternalMemoStateFilter>,
  sentOn?: Maybe<DateTimeFilter>,
  opr?: Maybe<OprExists>,
};

export type InternalMemoSortType = {
  memo?: Maybe<GeneratedDocumentSortType>,
  state?: Maybe<SortType>,
  sentOn?: Maybe<SortType>,
};

export enum InternalMemoState {
  NotSent = 'notSent',
  Sent = 'sent'
}

/** Filter type for InternalMemoState scalar */
export type InternalMemoStateFilter = {
  /** $eq */
  EQ?: Maybe<InternalMemoState>,
  /** $gt */
  GT?: Maybe<InternalMemoState>,
  /** $gte */
  GTE?: Maybe<InternalMemoState>,
  /** $in */
  IN?: Maybe<Array<Maybe<InternalMemoState>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<InternalMemoState>>>,
  /** $lt */
  LT?: Maybe<InternalMemoState>,
  /** $lte */
  LTE?: Maybe<InternalMemoState>,
  /** $ne */
  NE?: Maybe<InternalMemoState>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<InternalMemoState>>>,
  /** $not */
  NOT?: Maybe<InternalMemoStateNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<InternalMemoState>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<InternalMemoState>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<InternalMemoState>,
};

/** Filter type for $not of InternalMemoState scalar */
export type InternalMemoStateNotFilter = {
  /** $eq */
  EQ?: Maybe<InternalMemoState>,
  /** $gt */
  GT?: Maybe<InternalMemoState>,
  /** $gte */
  GTE?: Maybe<InternalMemoState>,
  /** $in */
  IN?: Maybe<Array<Maybe<InternalMemoState>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<InternalMemoState>>>,
  /** $lt */
  LT?: Maybe<InternalMemoState>,
  /** $lte */
  LTE?: Maybe<InternalMemoState>,
  /** $ne */
  NE?: Maybe<InternalMemoState>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<InternalMemoState>>>,
};

export type InternalVehicle = Vehicle & {
  __typename?: 'InternalVehicle',
  _id: Scalars['ID'],
  type: VehicleType,
  unknown: Scalars['Boolean'],
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  transport?: Maybe<Transport>,
  model?: Maybe<Scalars['String']>,
  group?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  licensePlateType?: Maybe<LicensePlateType>,
  vin?: Maybe<Scalars['String']>,
  internalNumberUnknown: Scalars['Boolean'],
  eqVehicle?: Maybe<EqVehicle>,
  label?: Maybe<Scalars['String']>,
  exportedToSAP?: Maybe<Scalars['Boolean']>,
  _changes?: Maybe<ProvingChangeTracking>,
};

/** Filter type for Int scalar */
export type IntFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Int']>,
  /** $gt */
  GT?: Maybe<Scalars['Int']>,
  /** $gte */
  GTE?: Maybe<Scalars['Int']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Int']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Int']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Int']>,
  /** $lte */
  LTE?: Maybe<Scalars['Int']>,
  /** $ne */
  NE?: Maybe<Scalars['Int']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Int']>>>,
  /** $not */
  NOT?: Maybe<IntNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['Int']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['Int']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['Int']>,
};

/** Filter type for $not of Int scalar */
export type IntNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['Int']>,
  /** $gt */
  GT?: Maybe<Scalars['Int']>,
  /** $gte */
  GTE?: Maybe<Scalars['Int']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['Int']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['Int']>>>,
  /** $lt */
  LT?: Maybe<Scalars['Int']>,
  /** $lte */
  LTE?: Maybe<Scalars['Int']>,
  /** $ne */
  NE?: Maybe<Scalars['Int']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['Int']>>>,
};



export enum LicensePlateType {
  Known = 'known',
  Unknown = 'unknown',
  NoRegistration = 'noRegistration'
}

/** Filter type for LicensePlateType scalar */
export type LicensePlateTypeFilter = {
  /** $eq */
  EQ?: Maybe<LicensePlateType>,
  /** $gt */
  GT?: Maybe<LicensePlateType>,
  /** $gte */
  GTE?: Maybe<LicensePlateType>,
  /** $in */
  IN?: Maybe<Array<Maybe<LicensePlateType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<LicensePlateType>>>,
  /** $lt */
  LT?: Maybe<LicensePlateType>,
  /** $lte */
  LTE?: Maybe<LicensePlateType>,
  /** $ne */
  NE?: Maybe<LicensePlateType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<LicensePlateType>>>,
  /** $not */
  NOT?: Maybe<LicensePlateTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<LicensePlateType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<LicensePlateType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<LicensePlateType>,
};

/** Filter type for $not of LicensePlateType scalar */
export type LicensePlateTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<LicensePlateType>,
  /** $gt */
  GT?: Maybe<LicensePlateType>,
  /** $gte */
  GTE?: Maybe<LicensePlateType>,
  /** $in */
  IN?: Maybe<Array<Maybe<LicensePlateType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<LicensePlateType>>>,
  /** $lt */
  LT?: Maybe<LicensePlateType>,
  /** $lte */
  LTE?: Maybe<LicensePlateType>,
  /** $ne */
  NE?: Maybe<LicensePlateType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<LicensePlateType>>>,
};

export type LiftingPlatform = {
  __typename?: 'LiftingPlatform',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId?: Maybe<Scalars['String']>,
  parent?: Maybe<Garage>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export enum LinkType {
  Personal = 'personal',
  Shared = 'shared'
}

export type Lodging = {
  __typename?: 'Lodging',
  _id: Scalars['String'],
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  land?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  emailHRG?: Maybe<Scalars['String']>,
};

export type Mail = Node & {
  __typename?: 'Mail',
  _id: Scalars['ID'],
  folder: MailFolder,
  /** Mail Message ID https://tools.ietf.org/html/rfc2392 */
  messageId?: Maybe<Scalars['String']>,
  to: Array<MailAddress>,
  cc?: Maybe<Array<MailAddress>>,
  from?: Maybe<MailAddress>,
  sender?: Maybe<MailAddress>,
  subject?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  conversationId?: Maybe<Scalars['String']>,
  created?: Maybe<Scalars['DateTime']>,
  createdBy?: Maybe<Scalars['String']>,
  hasAttachments?: Maybe<Scalars['Boolean']>,
  isRead?: Maybe<Scalars['Boolean']>,
  sentAt?: Maybe<Scalars['DateTime']>,
  receivedAt?: Maybe<Scalars['DateTime']>,
  attachments?: Maybe<Array<MailAttachment>>,
  proving?: Maybe<Proving>,
};

export type MailAddress = {
  __typename?: 'MailAddress',
  address: Scalars['String'],
};

export type MailAddressInput = {
  address?: Maybe<Scalars['String']>,
};

export type MailAddressInsertType = {
  address: Scalars['String'],
};

export type MailAddressObjectFilterType = {
  address?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export type MailAddressSortType = {
  address?: Maybe<SortType>,
};

export type MailAttachment = {
  __typename?: 'MailAttachment',
  name: Scalars['String'],
  uri: Scalars['String'],
};

/** Only pass either name and uri OR name, file and base64. NEVER ALL OF IT */
export type MailAttachmentInput = {
  name: Scalars['String'],
  uri?: Maybe<Scalars['String']>,
  file?: Maybe<Scalars['Upload']>,
  base64?: Maybe<Scalars['String']>,
};

export type MailAttachmentObjectFilterType = {
  name?: Maybe<StringFilter>,
  uri?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export type MailFilterType = {
  _id?: Maybe<IdFilter>,
  folder?: Maybe<MailFolderFilter>,
  messageId?: Maybe<StringFilter>,
  to?: Maybe<MailAddressObjectFilterType>,
  cc?: Maybe<MailAddressObjectFilterType>,
  from?: Maybe<MailAddressObjectFilterType>,
  sender?: Maybe<MailAddressObjectFilterType>,
  subject?: Maybe<StringFilter>,
  body?: Maybe<StringFilter>,
  conversationId?: Maybe<StringFilter>,
  created?: Maybe<DateTimeFilter>,
  createdBy?: Maybe<StringFilter>,
  hasAttachments?: Maybe<BooleanFilter>,
  isRead?: Maybe<BooleanFilter>,
  sentAt?: Maybe<DateTimeFilter>,
  receivedAt?: Maybe<DateTimeFilter>,
  attachments?: Maybe<MailAttachmentObjectFilterType>,
  OR?: Maybe<Array<Maybe<MailFilterType>>>,
  AND?: Maybe<Array<Maybe<MailFilterType>>>,
  NOR?: Maybe<Array<Maybe<MailFilterType>>>,
};

export enum MailFolder {
  Inbox = 'inbox',
  Outbox = 'outbox',
  Sent = 'sent',
  Draft = 'draft'
}

/** Filter type for MailFolder scalar */
export type MailFolderFilter = {
  /** $eq */
  EQ?: Maybe<MailFolder>,
  /** $gt */
  GT?: Maybe<MailFolder>,
  /** $gte */
  GTE?: Maybe<MailFolder>,
  /** $in */
  IN?: Maybe<Array<Maybe<MailFolder>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<MailFolder>>>,
  /** $lt */
  LT?: Maybe<MailFolder>,
  /** $lte */
  LTE?: Maybe<MailFolder>,
  /** $ne */
  NE?: Maybe<MailFolder>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<MailFolder>>>,
  /** $not */
  NOT?: Maybe<MailFolderNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<MailFolder>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<MailFolder>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<MailFolder>,
};

/** Filter type for $not of MailFolder scalar */
export type MailFolderNotFilter = {
  /** $eq */
  EQ?: Maybe<MailFolder>,
  /** $gt */
  GT?: Maybe<MailFolder>,
  /** $gte */
  GTE?: Maybe<MailFolder>,
  /** $in */
  IN?: Maybe<Array<Maybe<MailFolder>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<MailFolder>>>,
  /** $lt */
  LT?: Maybe<MailFolder>,
  /** $lte */
  LTE?: Maybe<MailFolder>,
  /** $ne */
  NE?: Maybe<MailFolder>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<MailFolder>>>,
};

export type MailInsertType = {
  _id?: Maybe<Scalars['ID']>,
  folder: MailFolder,
  messageId?: Maybe<Scalars['String']>,
  to: Array<MailAddressInsertType>,
  cc?: Maybe<Array<MailAddressInsertType>>,
  from?: Maybe<MailAddressInsertType>,
  sender?: Maybe<MailAddressInsertType>,
  subject?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  conversationId?: Maybe<Scalars['String']>,
  hasAttachments?: Maybe<Scalars['Boolean']>,
  isRead?: Maybe<Scalars['Boolean']>,
  sentAt?: Maybe<Scalars['DateTime']>,
  receivedAt?: Maybe<Scalars['DateTime']>,
};

export type MailSortType = {
  _id?: Maybe<SortType>,
  folder?: Maybe<SortType>,
  messageId?: Maybe<SortType>,
  from?: Maybe<MailAddressSortType>,
  sender?: Maybe<MailAddressSortType>,
  subject?: Maybe<SortType>,
  body?: Maybe<SortType>,
  conversationId?: Maybe<SortType>,
  created?: Maybe<SortType>,
  createdBy?: Maybe<SortType>,
  hasAttachments?: Maybe<SortType>,
  isRead?: Maybe<SortType>,
  sentAt?: Maybe<SortType>,
  receivedAt?: Maybe<SortType>,
};

export type MailTemplate = Node & {
  __typename?: 'MailTemplate',
  _id: Scalars['ID'],
  name: Scalars['String'],
  provingGroundId?: Maybe<Scalars['String']>,
  provingGround?: Maybe<ProvingGround>,
  subject?: Maybe<Scalars['String']>,
  to?: Maybe<Scalars['String']>,
  cc?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  type: MailTemplateType,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MailTemplateFilterType = {
  _id?: Maybe<IdFilter>,
  name?: Maybe<StringFilter>,
  provingGroundId?: Maybe<StringFilter>,
  subject?: Maybe<StringFilter>,
  to?: Maybe<StringFilter>,
  cc?: Maybe<StringFilter>,
  body?: Maybe<StringFilter>,
  type?: Maybe<MailTemplateTypeFilter>,
  inactive?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<MailTemplateFilterType>>>,
  AND?: Maybe<Array<Maybe<MailTemplateFilterType>>>,
  NOR?: Maybe<Array<Maybe<MailTemplateFilterType>>>,
};

export type MailTemplateIncType = {
  /** 
 * IGNORE. Due to limitations of the package, objects with no incrementable
   * fields cannot be ommited. All input object types must have at least one field
 **/
  _FICTIVE_INC?: Maybe<Scalars['Int']>,
};

export type MailTemplateInsertType = {
  _id?: Maybe<Scalars['ID']>,
  name: Scalars['String'],
  provingGroundId?: Maybe<Scalars['String']>,
  subject?: Maybe<Scalars['String']>,
  to?: Maybe<Scalars['String']>,
  cc?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  type: MailTemplateType,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MailTemplateRendered = {
  __typename?: 'MailTemplateRendered',
  to?: Maybe<Array<Scalars['String']>>,
  cc?: Maybe<Array<Scalars['String']>>,
  subject?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
};

export type MailTemplateSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  name?: Maybe<Scalars['String']>,
  provingGroundId?: Maybe<Scalars['String']>,
  subject?: Maybe<Scalars['String']>,
  to?: Maybe<Scalars['String']>,
  cc?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  type?: Maybe<MailTemplateType>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MailTemplateSetType = {
  _id?: Maybe<Scalars['ID']>,
  name?: Maybe<Scalars['String']>,
  provingGroundId?: Maybe<Scalars['String']>,
  subject?: Maybe<Scalars['String']>,
  to?: Maybe<Scalars['String']>,
  cc?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  type?: Maybe<MailTemplateType>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MailTemplateSortType = {
  _id?: Maybe<SortType>,
  name?: Maybe<SortType>,
  provingGroundId?: Maybe<SortType>,
  subject?: Maybe<SortType>,
  to?: Maybe<SortType>,
  cc?: Maybe<SortType>,
  body?: Maybe<SortType>,
  type?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
};

export enum MailTemplateType {
  /** General Mailtemplates (used in Provings) */
  General = 'general',
  /** Hotelbuchungen */
  HotelBookings = 'hotelBookings',
  /** Streckenhotelbuchungen */
  TrackHotelBookingsOutbound1 = 'trackHotelBookingsOutbound1',
  TrackHotelBookingsOutbound2 = 'trackHotelBookingsOutbound2',
  TrackHotelBookingsOutbound3 = 'trackHotelBookingsOutbound3',
  TrackHotelBookingsOutbound4 = 'trackHotelBookingsOutbound4',
  TrackHotelBookingsOutbound5 = 'trackHotelBookingsOutbound5',
  TrackHotelBookingsOutbound6 = 'trackHotelBookingsOutbound6',
  TrackHotelBookingsOutbound7 = 'trackHotelBookingsOutbound7',
  TrackHotelBookingsOutbound8 = 'trackHotelBookingsOutbound8',
  TrackHotelBookingsOutbound9 = 'trackHotelBookingsOutbound9',
  TrackHotelBookingsOutbound10 = 'trackHotelBookingsOutbound10',
  TrackHotelBookingsReturn1 = 'trackHotelBookingsReturn1',
  TrackHotelBookingsReturn2 = 'trackHotelBookingsReturn2',
  TrackHotelBookingsReturn3 = 'trackHotelBookingsReturn3',
  TrackHotelBookingsReturn4 = 'trackHotelBookingsReturn4',
  TrackHotelBookingsReturn5 = 'trackHotelBookingsReturn5',
  TrackHotelBookingsReturn6 = 'trackHotelBookingsReturn6',
  TrackHotelBookingsReturn7 = 'trackHotelBookingsReturn7',
  TrackHotelBookingsReturn8 = 'trackHotelBookingsReturn8',
  TrackHotelBookingsReturn9 = 'trackHotelBookingsReturn9',
  TrackHotelBookingsReturn10 = 'trackHotelBookingsReturn10',
  /** Template for tax requirements mail to the affected people */
  TaxRequirements = 'taxRequirements',
  /** Template for mail to the tax office concerning personnel changes */
  TaxOfficeChanges = 'taxOfficeChanges'
}

/** Filter type for MailTemplateType scalar */
export type MailTemplateTypeFilter = {
  /** $eq */
  EQ?: Maybe<MailTemplateType>,
  /** $gt */
  GT?: Maybe<MailTemplateType>,
  /** $gte */
  GTE?: Maybe<MailTemplateType>,
  /** $in */
  IN?: Maybe<Array<Maybe<MailTemplateType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<MailTemplateType>>>,
  /** $lt */
  LT?: Maybe<MailTemplateType>,
  /** $lte */
  LTE?: Maybe<MailTemplateType>,
  /** $ne */
  NE?: Maybe<MailTemplateType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<MailTemplateType>>>,
  /** $not */
  NOT?: Maybe<MailTemplateTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<MailTemplateType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<MailTemplateType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<MailTemplateType>,
};

/** Filter type for $not of MailTemplateType scalar */
export type MailTemplateTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<MailTemplateType>,
  /** $gt */
  GT?: Maybe<MailTemplateType>,
  /** $gte */
  GTE?: Maybe<MailTemplateType>,
  /** $in */
  IN?: Maybe<Array<Maybe<MailTemplateType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<MailTemplateType>>>,
  /** $lt */
  LT?: Maybe<MailTemplateType>,
  /** $lte */
  LTE?: Maybe<MailTemplateType>,
  /** $ne */
  NE?: Maybe<MailTemplateType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<MailTemplateType>>>,
};

export type MailTemplateUpdateType = {
  setOnInsert?: Maybe<MailTemplateSetOnInsertType>,
  set?: Maybe<MailTemplateSetType>,
  inc?: Maybe<MailTemplateIncType>,
};

export type MailUpdateInput = {
  proving?: Maybe<Scalars['String']>,
  folder?: Maybe<MailFolder>,
  sentAt?: Maybe<Scalars['DateTime']>,
  messageId?: Maybe<Scalars['String']>,
  conversationId?: Maybe<Scalars['String']>,
  to?: Maybe<Array<MailAddressInput>>,
  cc?: Maybe<Array<MailAddressInput>>,
  attachments?: Maybe<Array<MailAttachmentInput>>,
  subject?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  isRead?: Maybe<Scalars['Boolean']>,
};

export type MaintenanceArea = Node & {
  __typename?: 'MaintenanceArea',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  maintenanceArea: Scalars['String'],
  department: Scalars['String'],
  maintenanceHead?: Maybe<Array<User>>,
  modified?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<User>,
  created?: Maybe<Scalars['DateTime']>,
  createdBy?: Maybe<User>,
  inactive?: Maybe<Scalars['Boolean']>,
  annotation?: Maybe<Scalars['String']>,
};

export type MaintenanceAreaFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  maintenanceArea?: Maybe<StringFilter>,
  department?: Maybe<StringFilter>,
  maintenanceHead?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  created?: Maybe<DateTimeFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  inactive?: Maybe<BooleanFilter>,
  annotation?: Maybe<StringFilter>,
  OR?: Maybe<Array<Maybe<MaintenanceAreaFilterType>>>,
  AND?: Maybe<Array<Maybe<MaintenanceAreaFilterType>>>,
  NOR?: Maybe<Array<Maybe<MaintenanceAreaFilterType>>>,
};

export type MaintenanceAreaInsertInput = {
  maintenanceArea: Scalars['String'],
  department: Scalars['String'],
  maintenanceHead?: Maybe<Array<Scalars['ObjectId']>>,
  inactive?: Maybe<Scalars['Boolean']>,
  annotation?: Maybe<Scalars['String']>,
};

export type MaintenanceAreaSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  maintenanceArea?: Maybe<SortType>,
  department?: Maybe<SortType>,
  modified?: Maybe<SortType>,
  modifiedBy?: Maybe<UserSortType>,
  created?: Maybe<SortType>,
  createdBy?: Maybe<UserSortType>,
  inactive?: Maybe<SortType>,
  annotation?: Maybe<SortType>,
};

export type MaintenanceAreaUpdateInput = {
  maintenanceArea: Scalars['String'],
  department: Scalars['String'],
  maintenanceHead?: Maybe<Array<Scalars['ObjectId']>>,
  inactive?: Maybe<Scalars['Boolean']>,
  annotation?: Maybe<Scalars['String']>,
};

export type Material = Node & {
  __typename?: 'Material',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  containerType?: Maybe<Scalars['String']>,
  label: Scalars['String'],
  nettoWeight?: Maybe<Scalars['String']>,
  length?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MaterialFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  containerType?: Maybe<StringFilter>,
  label?: Maybe<StringFilter>,
  nettoWeight?: Maybe<StringFilter>,
  length?: Maybe<IntFilter>,
  width?: Maybe<IntFilter>,
  height?: Maybe<IntFilter>,
  inactive?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<MaterialFilterType>>>,
  AND?: Maybe<Array<Maybe<MaterialFilterType>>>,
  NOR?: Maybe<Array<Maybe<MaterialFilterType>>>,
};

export type MaterialIncType = {
  length?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
};

export type MaterialInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  containerType?: Maybe<Scalars['String']>,
  label: Scalars['String'],
  nettoWeight?: Maybe<Scalars['String']>,
  length?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MaterialSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  containerType?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  nettoWeight?: Maybe<Scalars['String']>,
  length?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MaterialSetType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  containerType?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  nettoWeight?: Maybe<Scalars['String']>,
  length?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type MaterialSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  containerType?: Maybe<SortType>,
  label?: Maybe<SortType>,
  nettoWeight?: Maybe<SortType>,
  length?: Maybe<SortType>,
  width?: Maybe<SortType>,
  height?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
};

export type MaterialsTransport = {
  __typename?: 'MaterialsTransport',
  transportType: TransportType,
  outboundTransportSender?: Maybe<SenderRecipient>,
  outboundTransportSenderTime?: Maybe<Scalars['String']>,
  outboundTransportSenderDate?: Maybe<Scalars['Date']>,
  outboundTransportRecipient?: Maybe<SenderRecipient>,
  outboundTransportRecipientTime?: Maybe<Scalars['String']>,
  outboundTransportRecipientDate?: Maybe<Scalars['Date']>,
  returnTransportSender?: Maybe<SenderRecipient>,
  returnTransportSenderTime?: Maybe<Scalars['String']>,
  returnTransportSenderDate?: Maybe<Scalars['Date']>,
  returnTransportRecipient?: Maybe<SenderRecipient>,
  returnTransportRecipientTime?: Maybe<Scalars['String']>,
  returnTransportRecipientDate?: Maybe<Scalars['Date']>,
};

export type MaterialsTransportInputType = {
  transportType: TransportType,
  outboundTransportSender?: Maybe<Scalars['ObjectId']>,
  outboundTransportSenderTime?: Maybe<Scalars['String']>,
  outboundTransportSenderDate?: Maybe<Scalars['Date']>,
  outboundTransportRecipient?: Maybe<Scalars['ObjectId']>,
  outboundTransportRecipientTime?: Maybe<Scalars['String']>,
  outboundTransportRecipientDate?: Maybe<Scalars['Date']>,
  returnTransportSender?: Maybe<Scalars['ObjectId']>,
  returnTransportSenderTime?: Maybe<Scalars['String']>,
  returnTransportSenderDate?: Maybe<Scalars['Date']>,
  returnTransportRecipient?: Maybe<Scalars['ObjectId']>,
  returnTransportRecipientTime?: Maybe<Scalars['String']>,
  returnTransportRecipientDate?: Maybe<Scalars['Date']>,
};

export type MaterialsTransportObjectFilterType = {
  transportType?: Maybe<TransportTypeFilter>,
  outboundTransportSenderTime?: Maybe<StringFilter>,
  outboundTransportSenderDate?: Maybe<DateFilter>,
  outboundTransportRecipientTime?: Maybe<StringFilter>,
  outboundTransportRecipientDate?: Maybe<DateFilter>,
  returnTransportSenderTime?: Maybe<StringFilter>,
  returnTransportSenderDate?: Maybe<DateFilter>,
  returnTransportRecipientTime?: Maybe<StringFilter>,
  returnTransportRecipientDate?: Maybe<DateFilter>,
  opr?: Maybe<OprExists>,
};

export type MaterialsTransportSortType = {
  transportType?: Maybe<SortType>,
  outboundTransportSenderTime?: Maybe<SortType>,
  outboundTransportSenderDate?: Maybe<SortType>,
  outboundTransportRecipientTime?: Maybe<SortType>,
  outboundTransportRecipientDate?: Maybe<SortType>,
  returnTransportSenderTime?: Maybe<SortType>,
  returnTransportSenderDate?: Maybe<SortType>,
  returnTransportRecipientTime?: Maybe<SortType>,
  returnTransportRecipientDate?: Maybe<SortType>,
};

export type MaterialUpdateType = {
  setOnInsert?: Maybe<MaterialSetOnInsertType>,
  set?: Maybe<MaterialSetType>,
  inc?: Maybe<MaterialIncType>,
};

export type Mutation = {
  __typename?: 'Mutation',
  _empty?: Maybe<Empty>,
  uploadBlob: Blob,
  copyBlob: Blob,
  moveBlob: Blob,
  deleteBlob: Scalars['String'],
  downloadBlobLink: Scalars['String'],
  createOrUpdateConvolute: Convolute,
  createDangerousGood: DangerousGood,
  updateDangerousGood: Array<DangerousGood>,
  deleteDangerousGood: Array<DangerousGood>,
  createDepartment: Department,
  updateDepartment: Department,
  deleteDepartment: Array<Department>,
  addOrUpdateEqVehicles: Scalars['Int'],
  createFileTemplate: FileTemplate,
  updateFileTemplate: FileTemplate,
  deleteFileTemplates: Array<FileTemplate>,
  generateFileFromTemplate: Blob,
  generateCostDistribution: Scalars['String'],
  createGDPRRule: GdprRule,
  updateGDPRRule: Array<GdprRule>,
  deleteGDPRRule: Array<GdprRule>,
  createOrUpdateSetting: GlobalSetting,
  createMail: Mail,
  updateMail: Mail,
  deleteMail?: Maybe<Scalars['Int']>,
  deleteMails?: Maybe<Scalars['Int']>,
  addMailAttachments: Mail,
  updateMailTemplate: Array<MailTemplate>,
  createMailTemplate: MailTemplate,
  deleteMailTemplate: Array<MailTemplate>,
  generateMailFromTemplate: MailTemplateRendered,
  createMaintenanceArea: MaintenanceArea,
  updateMaintenanceArea: MaintenanceArea,
  deleteMaintenanceAreas: Array<MaintenanceArea>,
  updateMaterial: Array<Material>,
  createMaterial: Material,
  deleteMaterial: Array<Material>,
  createNews: News,
  updateNews: News,
  deleteNews: Array<News>,
  updateOrderId: Array<OrderId>,
  createOrderId: OrderId,
  deleteOrderId: Array<OrderId>,
  createOrUpdateFromCsv: ExcelImportResult,
  addParticipants: Array<Participant>,
  updateParticipants: Array<Participant>,
  deleteParticipants: Array<Participant>,
  updateParticipantChanges?: Maybe<Scalars['Boolean']>,
  generateMyCalendarLink: Scalars['String'],
  addSignature: Scalars['String'],
  updateUsers: Scalars['Int'],
  updateProving: Proving,
  updateProvingStatus: Proving,
  createProving: Proving,
  deleteProving: Scalars['String'],
  excelOverview: Scalars['String'],
  resolveProvingChange: ProvingChange,
  resolveProvingChanges: Array<ProvingChange>,
  addProvingDocuments: Array<Maybe<ProvingDocument>>,
  updateProvingDocuments: Array<Maybe<ProvingDocument>>,
  deleteProvingDocuments: Array<Maybe<ProvingDocument>>,
  updateProvingGround: Array<ProvingGround>,
  createProvingGround: ProvingGround,
  deleteProvingGround: Array<ProvingGround>,
  addProvingMaterial: Scalars['ID'],
  addProvingMaterials: Array<ProvingMaterial>,
  updateProvingMaterial?: Maybe<Array<Scalars['ID']>>,
  deleteProvingMaterial: Array<ProvingMaterial>,
  exportMaterialsToSAP: Scalars['Boolean'],
  updateResource: Array<Resource>,
  createResource: Resource,
  deleteResource: Array<Resource>,
  addResourceBooking: Array<ResourceBooking>,
  updateResourceBooking: Array<ResourceBooking>,
  deleteResourceBookings?: Maybe<Scalars['Boolean']>,
  addResourceRequirement: Array<ResourceRequirement>,
  updateResourceRequirement: Array<ResourceRequirement>,
  deleteResourceRequirements?: Maybe<Scalars['Boolean']>,
  updateSenderRecipient: Array<SenderRecipient>,
  createSenderRecipient: SenderRecipient,
  deleteSenderRecipient: Array<SenderRecipient>,
  updateWikiCheck: UserWikiCheck,
  addVehicle: Vehicle,
  addVehicles: Array<Vehicle>,
  updateVehicles: Array<Vehicle>,
  deleteVehicles: Array<Vehicle>,
  exportToSAP: Scalars['Boolean'],
  createWiki: Wiki,
  updateWiki: Wiki,
  deleteWikis: Array<Wiki>,
  updateWorker: Array<Worker>,
  createWorker: Worker,
  deleteWorker: Array<Worker>,
};


export type MutationUploadBlobArgs = {
  parentId?: Maybe<Scalars['ID']>,
  parentType: Scalars['String'],
  file: Scalars['Upload']
};


export type MutationCopyBlobArgs = {
  sourceUri: Scalars['String'],
  targetContainer: Scalars['String'],
  targetName: Scalars['String']
};


export type MutationMoveBlobArgs = {
  sourceUri: Scalars['String'],
  targetContainer: Scalars['String'],
  targetName: Scalars['String']
};


export type MutationDeleteBlobArgs = {
  uri: Scalars['ID']
};


export type MutationDownloadBlobLinkArgs = {
  uri: Scalars['String'],
  linkType?: Maybe<LinkType>,
  expiresIn?: Scalars['Int']
};


export type MutationCreateOrUpdateConvoluteArgs = {
  input: ConvoluteInput
};


export type MutationCreateDangerousGoodArgs = {
  input?: Maybe<DangerousGoodInsertType>
};


export type MutationUpdateDangerousGoodArgs = {
  filter?: Maybe<DangerousGoodFilterType>,
  update?: Maybe<DangerousGoodUpdateType>
};


export type MutationDeleteDangerousGoodArgs = {
  filter?: Maybe<DangerousGoodFilterType>
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInsertInput
};


export type MutationUpdateDepartmentArgs = {
  id: Scalars['ID'],
  update: DepartmentUpdateInput
};


export type MutationDeleteDepartmentArgs = {
  ids: Array<Scalars['ID']>
};


export type MutationAddOrUpdateEqVehiclesArgs = {
  inputs: Array<EqVehicleInput>
};


export type MutationCreateFileTemplateArgs = {
  input: FileTemplateInsertInput
};


export type MutationUpdateFileTemplateArgs = {
  id: Scalars['ID'],
  update: FileTemplateUpdateInput
};


export type MutationDeleteFileTemplatesArgs = {
  ids: Array<Scalars['ID']>
};


export type MutationGenerateFileFromTemplateArgs = {
  templateUri: Scalars['String'],
  mapping: Scalars['String'],
  provingId: Scalars['String'],
  isTestDoc?: Scalars['Boolean']
};


export type MutationGenerateCostDistributionArgs = {
  input: CostDistributionReportInput
};


export type MutationCreateGdprRuleArgs = {
  input?: Maybe<GdprRuleInsertType>
};


export type MutationUpdateGdprRuleArgs = {
  filter?: Maybe<GdprRuleFilterType>,
  update?: Maybe<GdprRuleUpdateType>
};


export type MutationDeleteGdprRuleArgs = {
  filter?: Maybe<GdprRuleFilterType>
};


export type MutationCreateOrUpdateSettingArgs = {
  input: GlobalSettingInput
};


export type MutationCreateMailArgs = {
  provingId?: Maybe<Scalars['String']>,
  attachments?: Maybe<Array<MailAttachmentInput>>,
  fireEvent?: Maybe<Scalars['Boolean']>,
  input?: Maybe<MailInsertType>
};


export type MutationUpdateMailArgs = {
  id?: Maybe<Scalars['ID']>,
  update?: Maybe<MailUpdateInput>
};


export type MutationDeleteMailArgs = {
  filter?: Maybe<MailFilterType>
};


export type MutationDeleteMailsArgs = {
  ids: Array<Scalars['String']>
};


export type MutationAddMailAttachmentsArgs = {
  mailId: Scalars['String'],
  attachments: Array<MailAttachmentInput>
};


export type MutationUpdateMailTemplateArgs = {
  filter?: Maybe<MailTemplateFilterType>,
  update?: Maybe<MailTemplateUpdateType>
};


export type MutationCreateMailTemplateArgs = {
  input?: Maybe<MailTemplateInsertType>
};


export type MutationDeleteMailTemplateArgs = {
  filter?: Maybe<MailTemplateFilterType>
};


export type MutationGenerateMailFromTemplateArgs = {
  templateId: Scalars['ID'],
  provingId?: Maybe<Scalars['ID']>,
  context?: Maybe<Scalars['JSON']>
};


export type MutationCreateMaintenanceAreaArgs = {
  input: MaintenanceAreaInsertInput
};


export type MutationUpdateMaintenanceAreaArgs = {
  id: Scalars['ID'],
  update: MaintenanceAreaUpdateInput
};


export type MutationDeleteMaintenanceAreasArgs = {
  ids: Array<Scalars['ID']>
};


export type MutationUpdateMaterialArgs = {
  filter?: Maybe<MaterialFilterType>,
  update?: Maybe<MaterialUpdateType>
};


export type MutationCreateMaterialArgs = {
  input?: Maybe<MaterialInsertType>
};


export type MutationDeleteMaterialArgs = {
  filter?: Maybe<MaterialFilterType>
};


export type MutationCreateNewsArgs = {
  input: NewsCreateInput
};


export type MutationUpdateNewsArgs = {
  id: Scalars['ID'],
  input: NewsUpdateInput
};


export type MutationDeleteNewsArgs = {
  ids: Array<Scalars['ID']>
};


export type MutationUpdateOrderIdArgs = {
  filter?: Maybe<OrderIdFilterType>,
  update?: Maybe<OrderIdUpdateType>
};


export type MutationCreateOrderIdArgs = {
  input?: Maybe<OrderIdInsertType>
};


export type MutationDeleteOrderIdArgs = {
  filter?: Maybe<OrderIdFilterType>
};


export type MutationCreateOrUpdateFromCsvArgs = {
  uri: Scalars['String']
};


export type MutationAddParticipantsArgs = {
  provingId: Scalars['ID'],
  input: ParticipantsAddInput
};


export type MutationUpdateParticipantsArgs = {
  provingId: Scalars['ID'],
  batch: Array<ParticipantBatchInput>
};


export type MutationDeleteParticipantsArgs = {
  provingId: Scalars['ID'],
  idsToDelete: Array<Scalars['String']>
};


export type MutationUpdateParticipantChangesArgs = {
  updates: Array<ParticipantChangeUpdate>
};


export type MutationAddSignatureArgs = {
  input: Scalars['String']
};


export type MutationUpdateUsersArgs = {
  users: Array<PersonUpdate>
};


export type MutationUpdateProvingArgs = {
  id: Scalars['String'],
  update: ProvingUpdateType
};


export type MutationUpdateProvingStatusArgs = {
  id: Scalars['String'],
  status: Scalars['Int'],
  editor?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  declineReason?: Maybe<Scalars['String']>
};


export type MutationCreateProvingArgs = {
  input: ProvingInsertType
};


export type MutationDeleteProvingArgs = {
  id: Scalars['String'],
  deletePersons?: Maybe<Scalars['Boolean']>
};


export type MutationExcelOverviewArgs = {
  id: Scalars['String']
};


export type MutationResolveProvingChangeArgs = {
  changeId: Scalars['String'],
  action: ProvingChangeAction
};


export type MutationResolveProvingChangesArgs = {
  changeIds: Array<Scalars['String']>,
  action: ProvingChangeAction
};


export type MutationAddProvingDocumentsArgs = {
  provingId: Scalars['String'],
  input: Array<Maybe<ProvingDocumentAdd>>
};


export type MutationUpdateProvingDocumentsArgs = {
  provingId: Scalars['String'],
  input: Array<Maybe<ProvingDocumentUpdate>>
};


export type MutationDeleteProvingDocumentsArgs = {
  provingId: Scalars['String'],
  documentIds: Array<Maybe<Scalars['String']>>
};


export type MutationUpdateProvingGroundArgs = {
  filter?: Maybe<ProvingGroundFilterType>,
  update?: Maybe<ProvingGroundUpdateType>
};


export type MutationCreateProvingGroundArgs = {
  input?: Maybe<ProvingGroundInsertType>
};


export type MutationDeleteProvingGroundArgs = {
  filter?: Maybe<ProvingGroundFilterType>
};


export type MutationAddProvingMaterialArgs = {
  provingId: Scalars['ID'],
  input: ProvingMaterialInput
};


export type MutationAddProvingMaterialsArgs = {
  provingId: Scalars['ID'],
  inputs: Array<ProvingMaterialInput>
};


export type MutationUpdateProvingMaterialArgs = {
  provingId: Scalars['ID'],
  batch: Array<ProvingMaterialBatchInput>
};


export type MutationDeleteProvingMaterialArgs = {
  provingId: Scalars['ID'],
  idsToDelete: Array<Scalars['String']>
};


export type MutationExportMaterialsToSapArgs = {
  provingId: Scalars['String'],
  materialIds: Array<Scalars['String']>,
  outboundTransportSender?: Maybe<Scalars['String']>,
  outboundTransportRecipient?: Maybe<Scalars['String']>,
  returnTransportSender?: Maybe<Scalars['String']>,
  returnTransportRecipient?: Maybe<Scalars['String']>,
  outboundTransport?: Maybe<Scalars['Boolean']>,
  returnTransport?: Maybe<Scalars['Boolean']>
};


export type MutationUpdateResourceArgs = {
  filter?: Maybe<ResourceFilterType>,
  update?: Maybe<ResourceUpdateType>
};


export type MutationCreateResourceArgs = {
  input?: Maybe<ResourceInsertType>
};


export type MutationDeleteResourceArgs = {
  filter?: Maybe<ResourceFilterType>
};


export type MutationAddResourceBookingArgs = {
  provingId: Scalars['ID'],
  input: Array<ResourceBookingAddInput>
};


export type MutationUpdateResourceBookingArgs = {
  provingId: Scalars['ID'],
  batch: Array<ResourceBookingBatchInput>
};


export type MutationDeleteResourceBookingsArgs = {
  provingId: Scalars['ID'],
  idsToDelete: Array<Scalars['String']>
};


export type MutationAddResourceRequirementArgs = {
  provingId: Scalars['ID'],
  input: ResourceRequirementAddInput
};


export type MutationUpdateResourceRequirementArgs = {
  provingId: Scalars['ID'],
  batch: Array<ResourceRequirementBatchInput>
};


export type MutationDeleteResourceRequirementsArgs = {
  provingId: Scalars['ID'],
  idsToDelete: Array<Scalars['String']>
};


export type MutationUpdateSenderRecipientArgs = {
  filter?: Maybe<SenderRecipientFilterType>,
  update?: Maybe<SenderRecipientUpdateType>
};


export type MutationCreateSenderRecipientArgs = {
  input?: Maybe<SenderRecipientInsertType>
};


export type MutationDeleteSenderRecipientArgs = {
  filter?: Maybe<SenderRecipientFilterType>
};


export type MutationUpdateWikiCheckArgs = {
  update: WikiCheckUpdate
};


export type MutationAddVehicleArgs = {
  provingId: Scalars['String'],
  input: VehicleInsertInput
};


export type MutationAddVehiclesArgs = {
  provingId: Scalars['String'],
  inputs: Array<VehicleInsertInput>
};


export type MutationUpdateVehiclesArgs = {
  provingId: Scalars['String'],
  batch: Array<VehicleBatchInput>
};


export type MutationDeleteVehiclesArgs = {
  provingId: Scalars['String'],
  idsToDelete: Array<Scalars['String']>
};


export type MutationExportToSapArgs = {
  provingId: Scalars['String'],
  vehicleId: Scalars['String'],
  outboundTransportSender?: Maybe<Scalars['String']>,
  outboundTransportRecipient?: Maybe<Scalars['String']>,
  returnTransportSender?: Maybe<Scalars['String']>,
  returnTransportRecipient?: Maybe<Scalars['String']>
};


export type MutationCreateWikiArgs = {
  input: WikiCreateInput
};


export type MutationUpdateWikiArgs = {
  id: Scalars['ID'],
  update: WikiUpdateInput
};


export type MutationDeleteWikisArgs = {
  ids: Array<Scalars['ID']>
};


export type MutationUpdateWorkerArgs = {
  filter?: Maybe<WorkerFilterType>,
  update?: Maybe<WorkerUpdateType>
};


export type MutationCreateWorkerArgs = {
  input?: Maybe<WorkerInsertType>
};


export type MutationDeleteWorkerArgs = {
  filter?: Maybe<WorkerFilterType>
};

export type News = Node & {
  __typename?: 'News',
  _id: Scalars['ID'],
  title: Scalars['String'],
  provingGround: Array<ProvingGround>,
  description?: Maybe<Scalars['String']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  created?: Maybe<Scalars['DateTime']>,
  modified?: Maybe<Scalars['DateTime']>,
  inactive?: Maybe<Scalars['Boolean']>,
  files?: Maybe<Array<Scalars['String']>>,
  _deleted?: Maybe<Scalars['Boolean']>,
};

export type NewsCreateInput = {
  title: Scalars['String'],
  provingGround: Array<Scalars['ObjectId']>,
  description?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  uploadFiles?: Maybe<Array<Maybe<Scalars['Upload']>>>,
};

export type NewsFilterType = {
  _id?: Maybe<IdFilter>,
  title?: Maybe<StringFilter>,
  description?: Maybe<StringFilter>,
  deletionPeriod?: Maybe<FloatFilter>,
  deletionRule?: Maybe<StringFilter>,
  body?: Maybe<StringFilter>,
  created?: Maybe<DateTimeFilter>,
  modified?: Maybe<DateTimeFilter>,
  inactive?: Maybe<BooleanFilter>,
  files?: Maybe<StringFilter>,
  _deleted?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<NewsFilterType>>>,
  AND?: Maybe<Array<Maybe<NewsFilterType>>>,
  NOR?: Maybe<Array<Maybe<NewsFilterType>>>,
};

export type NewsSortType = {
  _id?: Maybe<SortType>,
  title?: Maybe<SortType>,
  description?: Maybe<SortType>,
  deletionPeriod?: Maybe<SortType>,
  deletionRule?: Maybe<SortType>,
  body?: Maybe<SortType>,
  created?: Maybe<SortType>,
  modified?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
};

export type NewsUpdateInput = {
  title: Scalars['String'],
  provingGround: Array<Scalars['ObjectId']>,
  description?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  uploadFiles?: Maybe<Array<Maybe<Scalars['Upload']>>>,
  files?: Maybe<Array<Scalars['String']>>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type Nmf = {
  __typename?: 'Nmf',
  requirement?: Maybe<Scalars['Boolean']>,
  release?: Maybe<Scalars['Boolean']>,
  transport?: Maybe<Scalars['Boolean']>,
  informed?: Maybe<Scalars['Boolean']>,
};

export type NmfInputType = {
  requirement?: Maybe<Scalars['Boolean']>,
  release?: Maybe<Scalars['Boolean']>,
  transport?: Maybe<Scalars['Boolean']>,
  informed?: Maybe<Scalars['Boolean']>,
};

export type NmfObjectFilterType = {
  requirement?: Maybe<BooleanFilter>,
  release?: Maybe<BooleanFilter>,
  transport?: Maybe<BooleanFilter>,
  informed?: Maybe<BooleanFilter>,
  opr?: Maybe<OprExists>,
};

export type NmfSortType = {
  requirement?: Maybe<SortType>,
  release?: Maybe<SortType>,
  transport?: Maybe<SortType>,
  informed?: Maybe<SortType>,
};

export type Node = {
  _id: Scalars['ID'],
};


/** Filter type for ObjectId scalar */
export type ObjectIdFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['ObjectId']>,
  /** $gt */
  GT?: Maybe<Scalars['ObjectId']>,
  /** $gte */
  GTE?: Maybe<Scalars['ObjectId']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  /** $lt */
  LT?: Maybe<Scalars['ObjectId']>,
  /** $lte */
  LTE?: Maybe<Scalars['ObjectId']>,
  /** $ne */
  NE?: Maybe<Scalars['ObjectId']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  /** $not */
  NOT?: Maybe<ObjectIdNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['ObjectId']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['ObjectId']>,
};

/** Filter type for $not of ObjectId scalar */
export type ObjectIdNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['ObjectId']>,
  /** $gt */
  GT?: Maybe<Scalars['ObjectId']>,
  /** $gte */
  GTE?: Maybe<Scalars['ObjectId']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  /** $lt */
  LT?: Maybe<Scalars['ObjectId']>,
  /** $lte */
  LTE?: Maybe<Scalars['ObjectId']>,
  /** $ne */
  NE?: Maybe<Scalars['ObjectId']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
};

export type Office = {
  __typename?: 'Office',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId: Scalars['String'],
  parent: Building,
  type?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  workstations: Array<Workstation>,
};

export enum Opr {
  Eql = 'EQL',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  All = 'ALL',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE',
  Nin = 'NIN'
}

export enum OprExists {
  Exists = 'EXISTS',
  NotExists = 'NOT_EXISTS'
}

/** 
 * Anything that has a list of options to choose from.
 * (Dropdowns, Picker, etc.)
 **/
export type OptionsSetting = GlobalSetting & {
  __typename?: 'OptionsSetting',
  _id: Scalars['ID'],
  type: GlobalSettingType,
  options: Array<Scalars['String']>,
};

export type OrderId = Node & {
  __typename?: 'OrderId',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  value: Scalars['String'],
  validTo: Scalars['Date'],
  validFrom: Scalars['Date'],
  modified: Scalars['DateTime'],
  modifiedBy?: Maybe<User>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type OrderIdDistribution = {
  __typename?: 'OrderIdDistribution',
  _id?: Maybe<Scalars['String']>,
  orderId: Scalars['String'],
  percentage?: Maybe<Scalars['Int']>,
  annotation?: Maybe<Scalars['String']>,
};

export type OrderIdDistributionInputType = {
  _id?: Maybe<Scalars['String']>,
  orderId: Scalars['String'],
  percentage?: Maybe<Scalars['Int']>,
  annotation?: Maybe<Scalars['String']>,
};

export type OrderIdDistributionObjectFilterType = {
  _id?: Maybe<StringFilter>,
  orderId?: Maybe<StringFilter>,
  percentage?: Maybe<IntFilter>,
  annotation?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export type OrderIdFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  value?: Maybe<StringFilter>,
  validTo?: Maybe<DateFilter>,
  validFrom?: Maybe<DateFilter>,
  modified?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  inactive?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<OrderIdFilterType>>>,
  AND?: Maybe<Array<Maybe<OrderIdFilterType>>>,
  NOR?: Maybe<Array<Maybe<OrderIdFilterType>>>,
};

export type OrderIdIncType = {
  modifiedBy?: Maybe<UserIncType>,
};

export type OrderIdInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  value: Scalars['String'],
  validTo: Scalars['Date'],
  validFrom: Scalars['Date'],
  inactive?: Maybe<Scalars['Boolean']>,
};

export type OrderIdSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  value?: Maybe<Scalars['String']>,
  validTo?: Maybe<Scalars['Date']>,
  validFrom?: Maybe<Scalars['Date']>,
  modified?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<UserSetOnInsertType>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type OrderIdSetType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  value?: Maybe<Scalars['String']>,
  validTo?: Maybe<Scalars['Date']>,
  validFrom?: Maybe<Scalars['Date']>,
  modified?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<UserSetObjectType>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type OrderIdSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  value?: Maybe<SortType>,
  validTo?: Maybe<SortType>,
  validFrom?: Maybe<SortType>,
  modified?: Maybe<SortType>,
  modifiedBy?: Maybe<UserSortType>,
  inactive?: Maybe<SortType>,
};

export type OrderIdUpdateType = {
  setOnInsert?: Maybe<OrderIdSetOnInsertType>,
  set?: Maybe<OrderIdSetType>,
  inc?: Maybe<OrderIdIncType>,
};

export type PaginationType = {
  limit?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
};

export type Participant = Node & {
  __typename?: 'Participant',
  _id: Scalars['ID'],
  changeTimeStamp?: Maybe<Scalars['DateTime']>,
  changedBy?: Maybe<User>,
  person?: Maybe<Person>,
  headOfProving?: Maybe<HeadOfProving>,
  unknownPerson?: Maybe<UnknownPerson>,
  note?: Maybe<Scalars['String']>,
  orderId?: Maybe<Scalars['String']>,
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  percentage?: Maybe<Scalars['Int']>,
  flight?: Maybe<Flight>,
  accomodation?: Maybe<Accomodation>,
  trackHotelRequired?: Maybe<Scalars['Boolean']>,
  trackHotels?: Maybe<TrackHotels>,
  rentalCar?: Maybe<RentalCar>,
  group?: Maybe<Scalars['String']>,
  temporaryPass?: Maybe<Scalars['Boolean']>,
  passActivation?: Maybe<Scalars['Boolean']>,
  permanentDriveAuthorization?: Maybe<Scalars['Boolean']>,
  singleDriveAuthorization?: Maybe<Scalars['Boolean']>,
  dvEquipment?: Maybe<Scalars['Boolean']>,
  partsTransport?: Maybe<Scalars['Boolean']>,
  driverTraining?: Maybe<Scalars['Boolean']>,
  ferry?: Maybe<Ferry>,
  nordschleife?: Maybe<Scalars['Boolean']>,
  nordschleifeBookingStatus?: Maybe<BookingStatus>,
  forms?: Maybe<Forms>,
  proving?: Maybe<Proving>,
  documents?: Maybe<Array<ProvingDocument>>,
  displayName?: Maybe<Scalars['String']>,
  _changes?: Maybe<ProvingChangeTracking>,
};

export type ParticipantAccomodationInput = {
  accomodationType?: Maybe<AccomodationType>,
  accomodation?: Maybe<Scalars['String']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  note?: Maybe<Scalars['String']>,
  additionalAccomodation?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type ParticipantBatchInput = {
  _id: Scalars['String'],
  update: ParticipantUpdateInput,
};

export type ParticipantChange = Node & {
  __typename?: 'ParticipantChange',
  _id: Scalars['ID'],
  type: ParticipantChangeType,
  proving: Proving,
  user?: Maybe<Person>,
  fullName: Scalars['String'],
  department?: Maybe<Scalars['String']>,
  employeeId?: Maybe<Scalars['String']>,
  dateFrom: Scalars['Date'],
  dateTo: Scalars['Date'],
  oldDateFrom?: Maybe<Scalars['Date']>,
  oldDateTo?: Maybe<Scalars['Date']>,
  isSentToInvolvedPeople: Scalars['Boolean'],
  isSentToTaxOffice: Scalars['Boolean'],
};

export type ParticipantChangeFilterType = {
  _id?: Maybe<IdFilter>,
  type?: Maybe<ParticipantChangeTypeFilter>,
  fullName?: Maybe<StringFilter>,
  department?: Maybe<StringFilter>,
  employeeId?: Maybe<StringFilter>,
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  oldDateFrom?: Maybe<DateFilter>,
  oldDateTo?: Maybe<DateFilter>,
  isSentToInvolvedPeople?: Maybe<BooleanFilter>,
  isSentToTaxOffice?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<ParticipantChangeFilterType>>>,
  AND?: Maybe<Array<Maybe<ParticipantChangeFilterType>>>,
  NOR?: Maybe<Array<Maybe<ParticipantChangeFilterType>>>,
};

export type ParticipantChangeSortType = {
  _id?: Maybe<SortType>,
  type?: Maybe<SortType>,
  fullName?: Maybe<SortType>,
  department?: Maybe<SortType>,
  employeeId?: Maybe<SortType>,
  dateFrom?: Maybe<SortType>,
  dateTo?: Maybe<SortType>,
  oldDateFrom?: Maybe<SortType>,
  oldDateTo?: Maybe<SortType>,
  isSentToInvolvedPeople?: Maybe<SortType>,
  isSentToTaxOffice?: Maybe<SortType>,
};

export enum ParticipantChangeType {
  Added = 'added',
  Removed = 'removed',
  ChangedDateFrom = 'changedDateFrom',
  ChangedDateTo = 'changedDateTo'
}

/** Filter type for ParticipantChangeType scalar */
export type ParticipantChangeTypeFilter = {
  /** $eq */
  EQ?: Maybe<ParticipantChangeType>,
  /** $gt */
  GT?: Maybe<ParticipantChangeType>,
  /** $gte */
  GTE?: Maybe<ParticipantChangeType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ParticipantChangeType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ParticipantChangeType>>>,
  /** $lt */
  LT?: Maybe<ParticipantChangeType>,
  /** $lte */
  LTE?: Maybe<ParticipantChangeType>,
  /** $ne */
  NE?: Maybe<ParticipantChangeType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ParticipantChangeType>>>,
  /** $not */
  NOT?: Maybe<ParticipantChangeTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<ParticipantChangeType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<ParticipantChangeType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<ParticipantChangeType>,
};

/** Filter type for $not of ParticipantChangeType scalar */
export type ParticipantChangeTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<ParticipantChangeType>,
  /** $gt */
  GT?: Maybe<ParticipantChangeType>,
  /** $gte */
  GTE?: Maybe<ParticipantChangeType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ParticipantChangeType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ParticipantChangeType>>>,
  /** $lt */
  LT?: Maybe<ParticipantChangeType>,
  /** $lte */
  LTE?: Maybe<ParticipantChangeType>,
  /** $ne */
  NE?: Maybe<ParticipantChangeType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ParticipantChangeType>>>,
};

export type ParticipantChangeUpdate = {
  _id: Scalars['ID'],
  isSentToInvolvedPeople: Scalars['Boolean'],
  isSentToTaxOffice: Scalars['Boolean'],
};

export type ParticipantFerryInput = {
  outward?: Maybe<Scalars['String']>,
  return?: Maybe<Scalars['String']>,
  dateTo?: Maybe<Scalars['Date']>,
  timeTo?: Maybe<Scalars['String']>,
  dateFrom?: Maybe<Scalars['Date']>,
  timeFrom?: Maybe<Scalars['String']>,
  note?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type ParticipantFlightInput = {
  flightType?: Maybe<FlightType>,
  note?: Maybe<Scalars['String']>,
  outboundData?: Maybe<ParticipantFlightMetadataInput>,
  returnData?: Maybe<ParticipantFlightMetadataInput>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type ParticipantFlightMetadataInput = {
  airline?: Maybe<Scalars['String']>,
  flightNumber?: Maybe<Scalars['String']>,
  departure?: Maybe<Scalars['Date']>,
  departureTime?: Maybe<Scalars['String']>,
};

export type ParticipantFormsInput = {
  temporaryPass?: Maybe<GeneratedDocumentInputType>,
  passActivation?: Maybe<GeneratedDocumentInputType>,
  permanentDriveAuthorization?: Maybe<GeneratedDocumentInputType>,
  singleDriveAuthorization?: Maybe<GeneratedDocumentInputType>,
  dvEquipment?: Maybe<GeneratedDocumentInputType>,
  partsTransport?: Maybe<GeneratedDocumentInputType>,
  driverTraining?: Maybe<GeneratedDocumentInputType>,
};

export type ParticipantHeadOfProvingInput = {
  isHeadOfProving?: Maybe<Scalars['Boolean']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
};

export type ParticipantHotelInput = {
  _id?: Maybe<Scalars['String']>,
  index?: Maybe<Scalars['Int']>,
  hotel?: Maybe<Scalars['String']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  note?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type ParticipantInsertInput = {
  personId?: Maybe<Scalars['String']>,
  orderId?: Maybe<Scalars['String']>,
  percentage?: Maybe<Scalars['Int']>,
  unknownPerson?: Maybe<UnknownPersonInput>,
};

export type ParticipantObjectFilterType = {
  _id?: Maybe<IdFilter>,
  changeTimeStamp?: Maybe<DateTimeFilter>,
  headOfProving?: Maybe<HeadOfProvingObjectFilterType>,
  unknownPerson?: Maybe<UnknownPersonObjectFilterType>,
  note?: Maybe<StringFilter>,
  orderId?: Maybe<StringFilter>,
  dateTo?: Maybe<DateFilter>,
  dateFrom?: Maybe<DateFilter>,
  percentage?: Maybe<IntFilter>,
  flight?: Maybe<FlightObjectFilterType>,
  accomodation?: Maybe<AccomodationObjectFilterType>,
  trackHotelRequired?: Maybe<BooleanFilter>,
  trackHotels?: Maybe<TrackHotelsObjectFilterType>,
  rentalCar?: Maybe<RentalCarObjectFilterType>,
  group?: Maybe<StringFilter>,
  temporaryPass?: Maybe<BooleanFilter>,
  passActivation?: Maybe<BooleanFilter>,
  permanentDriveAuthorization?: Maybe<BooleanFilter>,
  singleDriveAuthorization?: Maybe<BooleanFilter>,
  dvEquipment?: Maybe<BooleanFilter>,
  partsTransport?: Maybe<BooleanFilter>,
  driverTraining?: Maybe<BooleanFilter>,
  ferry?: Maybe<FerryObjectFilterType>,
  nordschleife?: Maybe<BooleanFilter>,
  nordschleifeBookingStatus?: Maybe<BookingStatusFilter>,
  forms?: Maybe<FormsObjectFilterType>,
  opr?: Maybe<OprExists>,
};

export type ParticipantRentalCarInput = {
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  carType?: Maybe<CarType>,
  note?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type ParticipantsAddInput = {
  personType: PersonType,
  participants: Array<ParticipantInsertInput>,
};

export type ParticipantTrackHotelsInput = {
  outward?: Maybe<Array<ParticipantHotelInput>>,
  return?: Maybe<Array<ParticipantHotelInput>>,
};

export enum ParticipantType {
  User = 'user',
  External = 'external',
  Worker = 'worker',
  Supplier = 'supplier'
}

export type ParticipantUpdateInput = {
  _id?: Maybe<Scalars['String']>,
  changedBy?: Maybe<Scalars['ObjectId']>,
  changeTimeStamp?: Maybe<Scalars['DateTime']>,
  orderId?: Maybe<Scalars['String']>,
  personId?: Maybe<Scalars['String']>,
  headOfProving?: Maybe<ParticipantHeadOfProvingInput>,
  personType?: Maybe<PersonType>,
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  note?: Maybe<Scalars['String']>,
  percentage?: Maybe<Scalars['Int']>,
  flight?: Maybe<ParticipantFlightInput>,
  accomodation?: Maybe<ParticipantAccomodationInput>,
  trackHotelRequired?: Maybe<Scalars['Boolean']>,
  trackHotels?: Maybe<ParticipantTrackHotelsInput>,
  rentalCarRequired?: Maybe<Scalars['Boolean']>,
  rentalCar?: Maybe<ParticipantRentalCarInput>,
  group?: Maybe<Scalars['String']>,
  temporaryPass?: Maybe<Scalars['Boolean']>,
  passActivation?: Maybe<Scalars['Boolean']>,
  permanentDriveAuthorization?: Maybe<Scalars['Boolean']>,
  singleDriveAuthorization?: Maybe<Scalars['Boolean']>,
  dvEquipment?: Maybe<Scalars['Boolean']>,
  partsTransport?: Maybe<Scalars['Boolean']>,
  driverTraining?: Maybe<Scalars['Boolean']>,
  ferry?: Maybe<ParticipantFerryInput>,
  nordschleife?: Maybe<Scalars['Boolean']>,
  nordschleifeBookingStatus?: Maybe<BookingStatus>,
  forms?: Maybe<ParticipantFormsInput>,
};

export type Person = {
  _id: Scalars['ID'],
  type: PersonType,
  name: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  employeeId?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
};


export type PersonAvatarUrlArgs = {
  size?: Maybe<Scalars['Int']>
};

export enum PersonType {
  User = 'user',
  Worker = 'worker',
  Supplier = 'supplier',
  External = 'external'
}

/** Filter type for PersonType scalar */
export type PersonTypeFilter = {
  /** $eq */
  EQ?: Maybe<PersonType>,
  /** $gt */
  GT?: Maybe<PersonType>,
  /** $gte */
  GTE?: Maybe<PersonType>,
  /** $in */
  IN?: Maybe<Array<Maybe<PersonType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<PersonType>>>,
  /** $lt */
  LT?: Maybe<PersonType>,
  /** $lte */
  LTE?: Maybe<PersonType>,
  /** $ne */
  NE?: Maybe<PersonType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<PersonType>>>,
  /** $not */
  NOT?: Maybe<PersonTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<PersonType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<PersonType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<PersonType>,
};

/** Filter type for $not of PersonType scalar */
export type PersonTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<PersonType>,
  /** $gt */
  GT?: Maybe<PersonType>,
  /** $gte */
  GTE?: Maybe<PersonType>,
  /** $in */
  IN?: Maybe<Array<Maybe<PersonType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<PersonType>>>,
  /** $lt */
  LT?: Maybe<PersonType>,
  /** $lte */
  LTE?: Maybe<PersonType>,
  /** $ne */
  NE?: Maybe<PersonType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<PersonType>>>,
};

export type PersonUpdate = {
  _id: Scalars['ID'],
  upn?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  mobilePhone?: Maybe<Scalars['String']>,
  companyName?: Maybe<Scalars['String']>,
  extension?: Maybe<Scalars['String']>,
  employeeId?: Maybe<Scalars['String']>,
};

export type Proving = Node & {
  __typename?: 'Proving',
  _id: Scalars['ID'],
  id: Scalars['String'],
  _deleted?: Maybe<Scalars['Boolean']>,
  _snapshotTimestamp: Scalars['DateTime'],
  declineReason?: Maybe<Scalars['String']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  status: Scalars['Int'],
  title: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  dateTo: Scalars['Date'],
  dateFrom: Scalars['Date'],
  declined?: Maybe<Scalars['DateTime']>,
  declinedBy?: Maybe<User>,
  created: Scalars['DateTime'],
  createdBy: User,
  modified: Scalars['DateTime'],
  modifiedBy: User,
  department?: Maybe<Scalars['String']>,
  leadingDepartment?: Maybe<Scalars['String']>,
  responsible: Array<User>,
  deputy?: Maybe<Array<User>>,
  editor?: Maybe<Array<User>>,
  maintenanceHead?: Maybe<Array<User>>,
  resourceManager?: Maybe<Array<User>>,
  costCentre?: Maybe<Scalars['String']>,
  sumOfCosts?: Maybe<Scalars['Float']>,
  effectiveSumOfCosts?: Maybe<Scalars['Float']>,
  newMails?: Maybe<Scalars['Int']>,
  hrgEditor?: Maybe<Array<User>>,
  provingGround?: Maybe<ProvingGround>,
  vehicles?: Maybe<Array<Vehicle>>,
  orderIdDistribution?: Maybe<Array<OrderIdDistribution>>,
  participants?: Maybe<Array<Participant>>,
  resourceRequirements?: Maybe<Array<ResourceRequirement>>,
  resourceBookings?: Maybe<Array<ResourceBooking>>,
  mails?: Maybe<Array<Mail>>,
  internalMemo?: Maybe<InternalMemo>,
  arrivalSheet?: Maybe<GeneratedDocument>,
  applicationForm?: Maybe<GeneratedDocument>,
  documents?: Maybe<Array<ProvingDocument>>,
  materials?: Maybe<Array<ProvingMaterial>>,
  mailTemplates?: Maybe<Array<MailTemplate>>,
  nmf?: Maybe<Nmf>,
  specialUsage?: Maybe<SpecialUsage>,
  statusChange?: Maybe<ProvingChange>,
  type?: Maybe<ProvingType>,
  dvtWvtCheckDisabled?: Maybe<Scalars['Boolean']>,
  headOfProvingCheckDisabled?: Maybe<Scalars['Boolean']>,
  multiSelectEditorCheckEnabled?: Maybe<Scalars['Boolean']>,
  serviceTeamIsEditing?: Maybe<Scalars['Boolean']>,
  hrgIsEditing?: Maybe<Scalars['Boolean']>,
  multiSelectResponsibleCheckEnabled?: Maybe<Scalars['Boolean']>,
  multiSelectSubstituteCheckEnabled?: Maybe<Scalars['Boolean']>,
  adminsOnlyResponsibleCheckEnabled?: Maybe<Scalars['Boolean']>,
  adminsOnlySubstituteCheckEnabled?: Maybe<Scalars['Boolean']>,
  enableGroups?: Maybe<Scalars['Boolean']>,
  hasIncompleteBookings?: Maybe<Scalars['Boolean']>,
  authorization?: Maybe<ProvingAuthorization>,
  annotationParticipants?: Maybe<Scalars['String']>,
  annotationVehicles?: Maybe<Scalars['String']>,
  annotationResourceRequirements?: Maybe<Scalars['String']>,
  annotationResourceBookings?: Maybe<Scalars['String']>,
  annotationFiles?: Maybe<Scalars['String']>,
  annotationForms?: Maybe<Scalars['String']>,
  annotationMaterials?: Maybe<Scalars['String']>,
  materialsTransport?: Maybe<MaterialsTransport>,
  materialsExportedToSAP?: Maybe<Scalars['Boolean']>,
  supportNeeds?: Maybe<SupportNeeds>,
  relevance?: Maybe<Scalars['Int']>,
  matches?: Maybe<Array<Maybe<Scalars['String']>>>,
  pendingChanges?: Maybe<Array<ProvingChange>>,
  _changes?: Maybe<ProvingChangeTracking>,
};

export type ProvingAuthorization = {
  __typename?: 'ProvingAuthorization',
  role?: Maybe<ProvingUserRole>,
  permissions: Array<ProvingPermission>,
};

export type ProvingChange = Node & {
  __typename?: 'ProvingChange',
  _id: Scalars['ID'],
  provingId: Scalars['String'],
  status: ProvingChangeStatus,
  change: ProvingChangeDetails,
  created: Scalars['DateTime'],
  createdBy: User,
  resolved?: Maybe<Scalars['DateTime']>,
  resolvedBy?: Maybe<User>,
};

export enum ProvingChangeAction {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export type ProvingChangeDetails = {
  __typename?: 'ProvingChangeDetails',
  key: Scalars['String'],
  type: ProvingChangeOperation,
  path: Scalars['String'],
  value?: Maybe<Scalars['JSON']>,
  valueType?: Maybe<Scalars['String']>,
  oldValue?: Maybe<Scalars['JSON']>,
  relativePath?: Maybe<Scalars['String']>,
};

export enum ProvingChangeOperation {
  Add = 'ADD',
  Update = 'UPDATE',
  Remove = 'REMOVE'
}

export enum ProvingChangeStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type ProvingChangeTracking = {
  __typename?: 'ProvingChangeTracking',
  changes?: Maybe<Array<ProvingChange>>,
  changed: Scalars['Boolean'],
  changeType?: Maybe<ProvingChangeOperation>,
  rootChange?: Maybe<ProvingChange>,
};

export type ProvingDocument = Node & {
  __typename?: 'ProvingDocument',
  _id: Scalars['ID'],
  uri: Scalars['String'],
  name: Scalars['String'],
  type?: Maybe<Scalars['String']>,
  participantId?: Maybe<Scalars['String']>,
  binary?: Maybe<Scalars['String']>,
  block?: Maybe<Scalars['String']>,
  downloadLink?: Maybe<Scalars['String']>,
};


export type ProvingDocumentDownloadLinkArgs = {
  expiresIn?: Scalars['Int']
};

export type ProvingDocumentAdd = {
  name: Scalars['String'],
  uri: Scalars['String'],
  type?: Maybe<Scalars['String']>,
  participantId?: Maybe<Scalars['String']>,
  block?: Maybe<Scalars['String']>,
};

export type ProvingDocumentObjectFilterType = {
  _id?: Maybe<IdFilter>,
  uri?: Maybe<StringFilter>,
  name?: Maybe<StringFilter>,
  type?: Maybe<StringFilter>,
  participantId?: Maybe<StringFilter>,
  block?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export type ProvingDocumentUpdate = {
  documentId: Scalars['String'],
  type?: Maybe<Scalars['String']>,
  participantId?: Maybe<Scalars['String']>,
  block?: Maybe<Scalars['String']>,
};

export type ProvingFilterType = {
  _id?: Maybe<IdFilter>,
  id?: Maybe<StringFilter>,
  _deleted?: Maybe<BooleanFilter>,
  _snapshotTimestamp?: Maybe<DateTimeFilter>,
  declineReason?: Maybe<StringFilter>,
  deletionPeriod?: Maybe<FloatFilter>,
  deletionRule?: Maybe<StringFilter>,
  status?: Maybe<IntFilter>,
  title?: Maybe<StringFilter>,
  description?: Maybe<StringFilter>,
  dateTo?: Maybe<DateFilter>,
  dateFrom?: Maybe<DateFilter>,
  declined?: Maybe<DateTimeFilter>,
  created?: Maybe<DateTimeFilter>,
  modified?: Maybe<DateTimeFilter>,
  department?: Maybe<StringFilter>,
  leadingDepartment?: Maybe<StringFilter>,
  costCentre?: Maybe<StringFilter>,
  sumOfCosts?: Maybe<FloatFilter>,
  effectiveSumOfCosts?: Maybe<FloatFilter>,
  newMails?: Maybe<IntFilter>,
  vehicles?: Maybe<VehicleObjectFilterType>,
  orderIdDistribution?: Maybe<OrderIdDistributionObjectFilterType>,
  participants?: Maybe<ParticipantObjectFilterType>,
  resourceRequirements?: Maybe<ResourceRequirementObjectFilterType>,
  resourceBookings?: Maybe<ResourceBookingObjectFilterType>,
  internalMemo?: Maybe<InternalMemoObjectFilterType>,
  arrivalSheet?: Maybe<GeneratedDocumentObjectFilterType>,
  applicationForm?: Maybe<GeneratedDocumentObjectFilterType>,
  documents?: Maybe<ProvingDocumentObjectFilterType>,
  materials?: Maybe<ProvingMaterialObjectFilterType>,
  nmf?: Maybe<NmfObjectFilterType>,
  specialUsage?: Maybe<SpecialUsageObjectFilterType>,
  type?: Maybe<ProvingTypeFilter>,
  dvtWvtCheckDisabled?: Maybe<BooleanFilter>,
  headOfProvingCheckDisabled?: Maybe<BooleanFilter>,
  multiSelectEditorCheckEnabled?: Maybe<BooleanFilter>,
  serviceTeamIsEditing?: Maybe<BooleanFilter>,
  hrgIsEditing?: Maybe<BooleanFilter>,
  multiSelectResponsibleCheckEnabled?: Maybe<BooleanFilter>,
  multiSelectSubstituteCheckEnabled?: Maybe<BooleanFilter>,
  adminsOnlyResponsibleCheckEnabled?: Maybe<BooleanFilter>,
  adminsOnlySubstituteCheckEnabled?: Maybe<BooleanFilter>,
  enableGroups?: Maybe<BooleanFilter>,
  hasIncompleteBookings?: Maybe<BooleanFilter>,
  annotationParticipants?: Maybe<StringFilter>,
  annotationVehicles?: Maybe<StringFilter>,
  annotationResourceRequirements?: Maybe<StringFilter>,
  annotationResourceBookings?: Maybe<StringFilter>,
  annotationFiles?: Maybe<StringFilter>,
  annotationForms?: Maybe<StringFilter>,
  annotationMaterials?: Maybe<StringFilter>,
  materialsTransport?: Maybe<MaterialsTransportObjectFilterType>,
  materialsExportedToSAP?: Maybe<BooleanFilter>,
  relevance?: Maybe<IntFilter>,
  matches?: Maybe<StringFilter>,
  OR?: Maybe<Array<Maybe<ProvingFilterType>>>,
  AND?: Maybe<Array<Maybe<ProvingFilterType>>>,
  NOR?: Maybe<Array<Maybe<ProvingFilterType>>>,
};

export type ProvingGround = Node & {
  __typename?: 'ProvingGround',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  title: Scalars['String'],
  countryCode: Scalars['String'],
  abbr: Scalars['String'],
  specialNote?: Maybe<Scalars['String']>,
  inactive: Scalars['Boolean'],
  drivingLessons?: Maybe<Scalars['Boolean']>,
  hideFlight?: Maybe<Scalars['Boolean']>,
  hideFerryConnection?: Maybe<Scalars['Boolean']>,
  hideNordschleife?: Maybe<Scalars['Boolean']>,
  hideHotels?: Maybe<Scalars['Boolean']>,
  skipClearing?: Maybe<Scalars['Boolean']>,
  racewayHours?: Maybe<Scalars['Boolean']>,
  showNMF?: Maybe<Scalars['Boolean']>,
  showSpecialUsage?: Maybe<Scalars['Boolean']>,
  deleteEditor?: Maybe<Scalars['Boolean']>,
  licensePlateMandatory?: Maybe<Scalars['Boolean']>,
  participantsMandatory?: Maybe<Scalars['Boolean']>,
  vehiclesMandatory?: Maybe<Scalars['Boolean']>,
  accomodationsMandatory?: Maybe<Scalars['Boolean']>,
  useUsageTimespansOnly?: Maybe<Scalars['Boolean']>,
  vehicleTransportToDays?: Maybe<Scalars['Int']>,
  vehicleTransportFromDays?: Maybe<Scalars['Int']>,
  outboundTransportSenderId?: Maybe<Scalars['ObjectId']>,
  outboundTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  returnTransportSenderId?: Maybe<Scalars['ObjectId']>,
  returnTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  outboundTransportSender?: Maybe<SenderRecipient>,
  outboundTransportRecipient?: Maybe<SenderRecipient>,
  returnTransportSender?: Maybe<SenderRecipient>,
  returnTransportRecipient?: Maybe<SenderRecipient>,
  noteHeaderVehicles?: Maybe<Scalars['String']>,
  noteVehicles?: Maybe<Scalars['String']>,
  noteHeaderMaterials?: Maybe<Scalars['String']>,
  noteMaterials?: Maybe<Scalars['String']>,
  note1?: Maybe<Scalars['String']>,
  note2?: Maybe<Scalars['String']>,
  note3?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  clearingIds?: Maybe<Array<Scalars['ObjectId']>>,
  editorsIds?: Maybe<Array<Scalars['ObjectId']>>,
  resourceManagersIds?: Maybe<Array<Scalars['ObjectId']>>,
  authorizedEditorsIds?: Maybe<Array<Scalars['ObjectId']>>,
  clearing?: Maybe<Array<User>>,
  editors?: Maybe<Array<User>>,
  resourceManagers?: Maybe<Array<User>>,
  authorizedEditors?: Maybe<Array<User>>,
  buildings?: Maybe<Array<Building>>,
  offices?: Maybe<Array<Office>>,
  coldcells?: Maybe<Array<ColdCell>>,
  fleet?: Maybe<Array<Fleet>>,
  garages?: Maybe<Array<Garage>>,
  accessories?: Maybe<Array<Accessory>>,
  refuelling?: Maybe<Array<Refuelling>>,
  ferryConnections?: Maybe<Array<FerryConnection>>,
  testTracks?: Maybe<Array<TestTrack>>,
  fuels?: Maybe<Array<Fuel>>,
  chargingInfrastructures?: Maybe<Array<ChargingInfrastructure>>,
  lodgings?: Maybe<Array<Lodging>>,
  accomodations?: Maybe<Array<Lodging>>,
  workstations?: Maybe<Array<Workstation>>,
  liftingPlatforms?: Maybe<Array<LiftingPlatform>>,
  radios?: Maybe<Array<Accessory>>,
  accessCards?: Maybe<Array<Accessory>>,
  fuelCards?: Maybe<Array<Refuelling>>,
  fileTemplates?: Maybe<Array<FileTemplate>>,
  block1?: Maybe<Scalars['String']>,
  block2?: Maybe<Scalars['String']>,
  block3?: Maybe<Scalars['String']>,
  block4?: Maybe<Scalars['String']>,
  block5?: Maybe<Scalars['String']>,
  block6?: Maybe<Scalars['String']>,
  block7?: Maybe<Scalars['String']>,
  block8?: Maybe<Scalars['String']>,
  block9?: Maybe<Scalars['String']>,
  block10?: Maybe<Scalars['String']>,
  block1Note?: Maybe<Scalars['String']>,
  block2Note?: Maybe<Scalars['String']>,
  block3Note?: Maybe<Scalars['String']>,
  block4Note?: Maybe<Scalars['String']>,
  block5Note?: Maybe<Scalars['String']>,
  block6Note?: Maybe<Scalars['String']>,
  block7Note?: Maybe<Scalars['String']>,
  block8Note?: Maybe<Scalars['String']>,
  block9Note?: Maybe<Scalars['String']>,
  block10Note?: Maybe<Scalars['String']>,
  block1Files?: Maybe<Array<Scalars['String']>>,
  block2Files?: Maybe<Array<Scalars['String']>>,
  block3Files?: Maybe<Array<Scalars['String']>>,
  block4Files?: Maybe<Array<Scalars['String']>>,
  block5Files?: Maybe<Array<Scalars['String']>>,
  block6Files?: Maybe<Array<Scalars['String']>>,
  block7Files?: Maybe<Array<Scalars['String']>>,
  block8Files?: Maybe<Array<Scalars['String']>>,
  block9Files?: Maybe<Array<Scalars['String']>>,
  block10Files?: Maybe<Array<Scalars['String']>>,
  fixedRates?: Maybe<FixedRates>,
};


export type ProvingGroundAccessoriesArgs = {
  types?: Maybe<Array<Maybe<AccessoryType>>>
};


export type ProvingGroundRefuellingArgs = {
  types?: Maybe<Array<Maybe<RefuellingType>>>
};

export type ProvingGroundFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  title?: Maybe<StringFilter>,
  countryCode?: Maybe<StringFilter>,
  abbr?: Maybe<StringFilter>,
  specialNote?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  drivingLessons?: Maybe<BooleanFilter>,
  hideFlight?: Maybe<BooleanFilter>,
  hideFerryConnection?: Maybe<BooleanFilter>,
  hideNordschleife?: Maybe<BooleanFilter>,
  hideHotels?: Maybe<BooleanFilter>,
  skipClearing?: Maybe<BooleanFilter>,
  racewayHours?: Maybe<BooleanFilter>,
  showNMF?: Maybe<BooleanFilter>,
  showSpecialUsage?: Maybe<BooleanFilter>,
  deleteEditor?: Maybe<BooleanFilter>,
  licensePlateMandatory?: Maybe<BooleanFilter>,
  participantsMandatory?: Maybe<BooleanFilter>,
  vehiclesMandatory?: Maybe<BooleanFilter>,
  accomodationsMandatory?: Maybe<BooleanFilter>,
  useUsageTimespansOnly?: Maybe<BooleanFilter>,
  vehicleTransportToDays?: Maybe<IntFilter>,
  vehicleTransportFromDays?: Maybe<IntFilter>,
  outboundTransportSenderId?: Maybe<ObjectIdFilter>,
  outboundTransportRecipientId?: Maybe<ObjectIdFilter>,
  returnTransportSenderId?: Maybe<ObjectIdFilter>,
  returnTransportRecipientId?: Maybe<ObjectIdFilter>,
  noteHeaderVehicles?: Maybe<StringFilter>,
  noteVehicles?: Maybe<StringFilter>,
  noteHeaderMaterials?: Maybe<StringFilter>,
  noteMaterials?: Maybe<StringFilter>,
  note1?: Maybe<StringFilter>,
  note2?: Maybe<StringFilter>,
  note3?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  clearingIds?: Maybe<ObjectIdFilter>,
  editorsIds?: Maybe<ObjectIdFilter>,
  resourceManagersIds?: Maybe<ObjectIdFilter>,
  authorizedEditorsIds?: Maybe<ObjectIdFilter>,
  fuels?: Maybe<FuelObjectFilterType>,
  chargingInfrastructures?: Maybe<ChargingInfrastructureObjectFilterType>,
  block1?: Maybe<StringFilter>,
  block2?: Maybe<StringFilter>,
  block3?: Maybe<StringFilter>,
  block4?: Maybe<StringFilter>,
  block5?: Maybe<StringFilter>,
  block6?: Maybe<StringFilter>,
  block7?: Maybe<StringFilter>,
  block8?: Maybe<StringFilter>,
  block9?: Maybe<StringFilter>,
  block10?: Maybe<StringFilter>,
  block1Note?: Maybe<StringFilter>,
  block2Note?: Maybe<StringFilter>,
  block3Note?: Maybe<StringFilter>,
  block4Note?: Maybe<StringFilter>,
  block5Note?: Maybe<StringFilter>,
  block6Note?: Maybe<StringFilter>,
  block7Note?: Maybe<StringFilter>,
  block8Note?: Maybe<StringFilter>,
  block9Note?: Maybe<StringFilter>,
  block10Note?: Maybe<StringFilter>,
  block1Files?: Maybe<StringFilter>,
  block2Files?: Maybe<StringFilter>,
  block3Files?: Maybe<StringFilter>,
  block4Files?: Maybe<StringFilter>,
  block5Files?: Maybe<StringFilter>,
  block6Files?: Maybe<StringFilter>,
  block7Files?: Maybe<StringFilter>,
  block8Files?: Maybe<StringFilter>,
  block9Files?: Maybe<StringFilter>,
  block10Files?: Maybe<StringFilter>,
  fixedRates?: Maybe<FixedRatesObjectFilterType>,
  OR?: Maybe<Array<Maybe<ProvingGroundFilterType>>>,
  AND?: Maybe<Array<Maybe<ProvingGroundFilterType>>>,
  NOR?: Maybe<Array<Maybe<ProvingGroundFilterType>>>,
};

export type ProvingGroundIncType = {
  vehicleTransportToDays?: Maybe<Scalars['Int']>,
  vehicleTransportFromDays?: Maybe<Scalars['Int']>,
  fixedRates?: Maybe<FixedRatesIncType>,
};

export type ProvingGroundInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  title: Scalars['String'],
  countryCode: Scalars['String'],
  abbr: Scalars['String'],
  specialNote?: Maybe<Scalars['String']>,
  inactive: Scalars['Boolean'],
  drivingLessons?: Maybe<Scalars['Boolean']>,
  hideFlight?: Maybe<Scalars['Boolean']>,
  hideFerryConnection?: Maybe<Scalars['Boolean']>,
  hideNordschleife?: Maybe<Scalars['Boolean']>,
  hideHotels?: Maybe<Scalars['Boolean']>,
  skipClearing?: Maybe<Scalars['Boolean']>,
  racewayHours?: Maybe<Scalars['Boolean']>,
  showNMF?: Maybe<Scalars['Boolean']>,
  showSpecialUsage?: Maybe<Scalars['Boolean']>,
  deleteEditor?: Maybe<Scalars['Boolean']>,
  licensePlateMandatory?: Maybe<Scalars['Boolean']>,
  participantsMandatory?: Maybe<Scalars['Boolean']>,
  vehiclesMandatory?: Maybe<Scalars['Boolean']>,
  accomodationsMandatory?: Maybe<Scalars['Boolean']>,
  useUsageTimespansOnly?: Maybe<Scalars['Boolean']>,
  vehicleTransportToDays?: Maybe<Scalars['Int']>,
  vehicleTransportFromDays?: Maybe<Scalars['Int']>,
  outboundTransportSenderId?: Maybe<Scalars['ObjectId']>,
  outboundTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  returnTransportSenderId?: Maybe<Scalars['ObjectId']>,
  returnTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  noteHeaderVehicles?: Maybe<Scalars['String']>,
  noteVehicles?: Maybe<Scalars['String']>,
  noteHeaderMaterials?: Maybe<Scalars['String']>,
  noteMaterials?: Maybe<Scalars['String']>,
  note1?: Maybe<Scalars['String']>,
  note2?: Maybe<Scalars['String']>,
  note3?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  clearingIds?: Maybe<Array<Scalars['ObjectId']>>,
  editorsIds?: Maybe<Array<Scalars['ObjectId']>>,
  resourceManagersIds?: Maybe<Array<Scalars['ObjectId']>>,
  authorizedEditorsIds?: Maybe<Array<Scalars['ObjectId']>>,
  fuels?: Maybe<Array<FuelInsertType>>,
  chargingInfrastructures?: Maybe<Array<ChargingInfrastructureInsertType>>,
  block1?: Maybe<Scalars['String']>,
  block2?: Maybe<Scalars['String']>,
  block3?: Maybe<Scalars['String']>,
  block4?: Maybe<Scalars['String']>,
  block5?: Maybe<Scalars['String']>,
  block6?: Maybe<Scalars['String']>,
  block7?: Maybe<Scalars['String']>,
  block8?: Maybe<Scalars['String']>,
  block9?: Maybe<Scalars['String']>,
  block10?: Maybe<Scalars['String']>,
  block1Note?: Maybe<Scalars['String']>,
  block2Note?: Maybe<Scalars['String']>,
  block3Note?: Maybe<Scalars['String']>,
  block4Note?: Maybe<Scalars['String']>,
  block5Note?: Maybe<Scalars['String']>,
  block6Note?: Maybe<Scalars['String']>,
  block7Note?: Maybe<Scalars['String']>,
  block8Note?: Maybe<Scalars['String']>,
  block9Note?: Maybe<Scalars['String']>,
  block10Note?: Maybe<Scalars['String']>,
  block1Files?: Maybe<Array<Scalars['String']>>,
  block2Files?: Maybe<Array<Scalars['String']>>,
  block3Files?: Maybe<Array<Scalars['String']>>,
  block4Files?: Maybe<Array<Scalars['String']>>,
  block5Files?: Maybe<Array<Scalars['String']>>,
  block6Files?: Maybe<Array<Scalars['String']>>,
  block7Files?: Maybe<Array<Scalars['String']>>,
  block8Files?: Maybe<Array<Scalars['String']>>,
  block9Files?: Maybe<Array<Scalars['String']>>,
  block10Files?: Maybe<Array<Scalars['String']>>,
  fixedRates?: Maybe<FixedRatesInsertType>,
};

export type ProvingGroundObjectFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  title?: Maybe<StringFilter>,
  countryCode?: Maybe<StringFilter>,
  abbr?: Maybe<StringFilter>,
  specialNote?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  drivingLessons?: Maybe<BooleanFilter>,
  hideFlight?: Maybe<BooleanFilter>,
  hideFerryConnection?: Maybe<BooleanFilter>,
  hideNordschleife?: Maybe<BooleanFilter>,
  hideHotels?: Maybe<BooleanFilter>,
  skipClearing?: Maybe<BooleanFilter>,
  racewayHours?: Maybe<BooleanFilter>,
  showNMF?: Maybe<BooleanFilter>,
  showSpecialUsage?: Maybe<BooleanFilter>,
  deleteEditor?: Maybe<BooleanFilter>,
  licensePlateMandatory?: Maybe<BooleanFilter>,
  participantsMandatory?: Maybe<BooleanFilter>,
  vehiclesMandatory?: Maybe<BooleanFilter>,
  accomodationsMandatory?: Maybe<BooleanFilter>,
  useUsageTimespansOnly?: Maybe<BooleanFilter>,
  vehicleTransportToDays?: Maybe<IntFilter>,
  vehicleTransportFromDays?: Maybe<IntFilter>,
  outboundTransportSenderId?: Maybe<ObjectIdFilter>,
  outboundTransportRecipientId?: Maybe<ObjectIdFilter>,
  returnTransportSenderId?: Maybe<ObjectIdFilter>,
  returnTransportRecipientId?: Maybe<ObjectIdFilter>,
  noteHeaderVehicles?: Maybe<StringFilter>,
  noteVehicles?: Maybe<StringFilter>,
  noteHeaderMaterials?: Maybe<StringFilter>,
  noteMaterials?: Maybe<StringFilter>,
  note1?: Maybe<StringFilter>,
  note2?: Maybe<StringFilter>,
  note3?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  clearingIds?: Maybe<ObjectIdFilter>,
  editorsIds?: Maybe<ObjectIdFilter>,
  resourceManagersIds?: Maybe<ObjectIdFilter>,
  authorizedEditorsIds?: Maybe<ObjectIdFilter>,
  fuels?: Maybe<FuelObjectFilterType>,
  chargingInfrastructures?: Maybe<ChargingInfrastructureObjectFilterType>,
  block1?: Maybe<StringFilter>,
  block2?: Maybe<StringFilter>,
  block3?: Maybe<StringFilter>,
  block4?: Maybe<StringFilter>,
  block5?: Maybe<StringFilter>,
  block6?: Maybe<StringFilter>,
  block7?: Maybe<StringFilter>,
  block8?: Maybe<StringFilter>,
  block9?: Maybe<StringFilter>,
  block10?: Maybe<StringFilter>,
  block1Note?: Maybe<StringFilter>,
  block2Note?: Maybe<StringFilter>,
  block3Note?: Maybe<StringFilter>,
  block4Note?: Maybe<StringFilter>,
  block5Note?: Maybe<StringFilter>,
  block6Note?: Maybe<StringFilter>,
  block7Note?: Maybe<StringFilter>,
  block8Note?: Maybe<StringFilter>,
  block9Note?: Maybe<StringFilter>,
  block10Note?: Maybe<StringFilter>,
  block1Files?: Maybe<StringFilter>,
  block2Files?: Maybe<StringFilter>,
  block3Files?: Maybe<StringFilter>,
  block4Files?: Maybe<StringFilter>,
  block5Files?: Maybe<StringFilter>,
  block6Files?: Maybe<StringFilter>,
  block7Files?: Maybe<StringFilter>,
  block8Files?: Maybe<StringFilter>,
  block9Files?: Maybe<StringFilter>,
  block10Files?: Maybe<StringFilter>,
  fixedRates?: Maybe<FixedRatesObjectFilterType>,
  opr?: Maybe<OprExists>,
};

export type ProvingGroundSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  title?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  specialNote?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  drivingLessons?: Maybe<Scalars['Boolean']>,
  hideFlight?: Maybe<Scalars['Boolean']>,
  hideFerryConnection?: Maybe<Scalars['Boolean']>,
  hideNordschleife?: Maybe<Scalars['Boolean']>,
  hideHotels?: Maybe<Scalars['Boolean']>,
  skipClearing?: Maybe<Scalars['Boolean']>,
  racewayHours?: Maybe<Scalars['Boolean']>,
  showNMF?: Maybe<Scalars['Boolean']>,
  showSpecialUsage?: Maybe<Scalars['Boolean']>,
  deleteEditor?: Maybe<Scalars['Boolean']>,
  licensePlateMandatory?: Maybe<Scalars['Boolean']>,
  participantsMandatory?: Maybe<Scalars['Boolean']>,
  vehiclesMandatory?: Maybe<Scalars['Boolean']>,
  accomodationsMandatory?: Maybe<Scalars['Boolean']>,
  useUsageTimespansOnly?: Maybe<Scalars['Boolean']>,
  vehicleTransportToDays?: Maybe<Scalars['Int']>,
  vehicleTransportFromDays?: Maybe<Scalars['Int']>,
  outboundTransportSenderId?: Maybe<Scalars['ObjectId']>,
  outboundTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  returnTransportSenderId?: Maybe<Scalars['ObjectId']>,
  returnTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  noteHeaderVehicles?: Maybe<Scalars['String']>,
  noteVehicles?: Maybe<Scalars['String']>,
  noteHeaderMaterials?: Maybe<Scalars['String']>,
  noteMaterials?: Maybe<Scalars['String']>,
  note1?: Maybe<Scalars['String']>,
  note2?: Maybe<Scalars['String']>,
  note3?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  clearingIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  editorsIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  resourceManagersIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  authorizedEditorsIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  fuels?: Maybe<Array<Maybe<FuelSetOnInsertType>>>,
  chargingInfrastructures?: Maybe<Array<Maybe<ChargingInfrastructureSetOnInsertType>>>,
  block1?: Maybe<Scalars['String']>,
  block2?: Maybe<Scalars['String']>,
  block3?: Maybe<Scalars['String']>,
  block4?: Maybe<Scalars['String']>,
  block5?: Maybe<Scalars['String']>,
  block6?: Maybe<Scalars['String']>,
  block7?: Maybe<Scalars['String']>,
  block8?: Maybe<Scalars['String']>,
  block9?: Maybe<Scalars['String']>,
  block10?: Maybe<Scalars['String']>,
  block1Note?: Maybe<Scalars['String']>,
  block2Note?: Maybe<Scalars['String']>,
  block3Note?: Maybe<Scalars['String']>,
  block4Note?: Maybe<Scalars['String']>,
  block5Note?: Maybe<Scalars['String']>,
  block6Note?: Maybe<Scalars['String']>,
  block7Note?: Maybe<Scalars['String']>,
  block8Note?: Maybe<Scalars['String']>,
  block9Note?: Maybe<Scalars['String']>,
  block10Note?: Maybe<Scalars['String']>,
  block1Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block2Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block3Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block4Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block5Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block6Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block7Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block8Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block9Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block10Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  fixedRates?: Maybe<FixedRatesSetOnInsertType>,
};

export type ProvingGroundSetType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  title?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  specialNote?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  drivingLessons?: Maybe<Scalars['Boolean']>,
  hideFlight?: Maybe<Scalars['Boolean']>,
  hideFerryConnection?: Maybe<Scalars['Boolean']>,
  hideNordschleife?: Maybe<Scalars['Boolean']>,
  hideHotels?: Maybe<Scalars['Boolean']>,
  skipClearing?: Maybe<Scalars['Boolean']>,
  racewayHours?: Maybe<Scalars['Boolean']>,
  showNMF?: Maybe<Scalars['Boolean']>,
  showSpecialUsage?: Maybe<Scalars['Boolean']>,
  deleteEditor?: Maybe<Scalars['Boolean']>,
  licensePlateMandatory?: Maybe<Scalars['Boolean']>,
  participantsMandatory?: Maybe<Scalars['Boolean']>,
  vehiclesMandatory?: Maybe<Scalars['Boolean']>,
  accomodationsMandatory?: Maybe<Scalars['Boolean']>,
  useUsageTimespansOnly?: Maybe<Scalars['Boolean']>,
  vehicleTransportToDays?: Maybe<Scalars['Int']>,
  vehicleTransportFromDays?: Maybe<Scalars['Int']>,
  outboundTransportSenderId?: Maybe<Scalars['ObjectId']>,
  outboundTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  returnTransportSenderId?: Maybe<Scalars['ObjectId']>,
  returnTransportRecipientId?: Maybe<Scalars['ObjectId']>,
  noteHeaderVehicles?: Maybe<Scalars['String']>,
  noteVehicles?: Maybe<Scalars['String']>,
  noteHeaderMaterials?: Maybe<Scalars['String']>,
  noteMaterials?: Maybe<Scalars['String']>,
  note1?: Maybe<Scalars['String']>,
  note2?: Maybe<Scalars['String']>,
  note3?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  clearingIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  editorsIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  resourceManagersIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  authorizedEditorsIds?: Maybe<Array<Maybe<Scalars['ObjectId']>>>,
  fuels?: Maybe<Array<Maybe<FuelSetListObjectType>>>,
  chargingInfrastructures?: Maybe<Array<Maybe<ChargingInfrastructureSetListObjectType>>>,
  block1?: Maybe<Scalars['String']>,
  block2?: Maybe<Scalars['String']>,
  block3?: Maybe<Scalars['String']>,
  block4?: Maybe<Scalars['String']>,
  block5?: Maybe<Scalars['String']>,
  block6?: Maybe<Scalars['String']>,
  block7?: Maybe<Scalars['String']>,
  block8?: Maybe<Scalars['String']>,
  block9?: Maybe<Scalars['String']>,
  block10?: Maybe<Scalars['String']>,
  block1Note?: Maybe<Scalars['String']>,
  block2Note?: Maybe<Scalars['String']>,
  block3Note?: Maybe<Scalars['String']>,
  block4Note?: Maybe<Scalars['String']>,
  block5Note?: Maybe<Scalars['String']>,
  block6Note?: Maybe<Scalars['String']>,
  block7Note?: Maybe<Scalars['String']>,
  block8Note?: Maybe<Scalars['String']>,
  block9Note?: Maybe<Scalars['String']>,
  block10Note?: Maybe<Scalars['String']>,
  block1Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block2Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block3Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block4Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block5Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block6Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block7Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block8Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block9Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  block10Files?: Maybe<Array<Maybe<Scalars['String']>>>,
  fixedRates?: Maybe<FixedRatesSetObjectType>,
};

export type ProvingGroundSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  title?: Maybe<SortType>,
  countryCode?: Maybe<SortType>,
  abbr?: Maybe<SortType>,
  specialNote?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
  drivingLessons?: Maybe<SortType>,
  hideFlight?: Maybe<SortType>,
  hideFerryConnection?: Maybe<SortType>,
  hideNordschleife?: Maybe<SortType>,
  hideHotels?: Maybe<SortType>,
  skipClearing?: Maybe<SortType>,
  racewayHours?: Maybe<SortType>,
  showNMF?: Maybe<SortType>,
  showSpecialUsage?: Maybe<SortType>,
  deleteEditor?: Maybe<SortType>,
  licensePlateMandatory?: Maybe<SortType>,
  participantsMandatory?: Maybe<SortType>,
  vehiclesMandatory?: Maybe<SortType>,
  accomodationsMandatory?: Maybe<SortType>,
  useUsageTimespansOnly?: Maybe<SortType>,
  vehicleTransportToDays?: Maybe<SortType>,
  vehicleTransportFromDays?: Maybe<SortType>,
  outboundTransportSenderId?: Maybe<SortType>,
  outboundTransportRecipientId?: Maybe<SortType>,
  returnTransportSenderId?: Maybe<SortType>,
  returnTransportRecipientId?: Maybe<SortType>,
  noteHeaderVehicles?: Maybe<SortType>,
  noteVehicles?: Maybe<SortType>,
  noteHeaderMaterials?: Maybe<SortType>,
  noteMaterials?: Maybe<SortType>,
  note1?: Maybe<SortType>,
  note2?: Maybe<SortType>,
  note3?: Maybe<SortType>,
  annotation?: Maybe<SortType>,
  block1?: Maybe<SortType>,
  block2?: Maybe<SortType>,
  block3?: Maybe<SortType>,
  block4?: Maybe<SortType>,
  block5?: Maybe<SortType>,
  block6?: Maybe<SortType>,
  block7?: Maybe<SortType>,
  block8?: Maybe<SortType>,
  block9?: Maybe<SortType>,
  block10?: Maybe<SortType>,
  block1Note?: Maybe<SortType>,
  block2Note?: Maybe<SortType>,
  block3Note?: Maybe<SortType>,
  block4Note?: Maybe<SortType>,
  block5Note?: Maybe<SortType>,
  block6Note?: Maybe<SortType>,
  block7Note?: Maybe<SortType>,
  block8Note?: Maybe<SortType>,
  block9Note?: Maybe<SortType>,
  block10Note?: Maybe<SortType>,
  fixedRates?: Maybe<FixedRatesSortType>,
};

export type ProvingGroundUpdateType = {
  setOnInsert?: Maybe<ProvingGroundSetOnInsertType>,
  set?: Maybe<ProvingGroundSetType>,
  inc?: Maybe<ProvingGroundIncType>,
};

export type ProvingInsertType = {
  type: ProvingType,
  title: Scalars['String'],
  description: Scalars['String'],
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  dateTo: Scalars['Date'],
  dateFrom: Scalars['Date'],
  provingGroundId: Scalars['String'],
  department: Scalars['String'],
  responsible: Array<Scalars['ObjectId']>,
  orderIdDistribution?: Maybe<Array<OrderIdDistributionInputType>>,
  supportNeeds?: Maybe<SupportNeedsInsertType>,
};

export type ProvingMaterial = Node & {
  __typename?: 'ProvingMaterial',
  _id: Scalars['ID'],
  material: Material,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  amount?: Maybe<Scalars['Int']>,
  transport?: Maybe<Transport>,
  orderId?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  group?: Maybe<Scalars['String']>,
  outboundExportedToSAP?: Maybe<Scalars['Boolean']>,
  returnExportedToSAP?: Maybe<Scalars['Boolean']>,
  isDangerousGood?: Maybe<Scalars['Boolean']>,
  dangerousGood?: Maybe<DangerousGood>,
  _changes?: Maybe<ProvingChangeTracking>,
};

export type ProvingMaterialBatchInput = {
  _id: Scalars['ID'],
  update: ProvingMaterialUpdateInput,
};

export type ProvingMaterialDangerousGoodInput = {
  unNumber: Scalars['String'],
  description?: Maybe<Scalars['String']>,
};

export type ProvingMaterialInput = {
  material?: Maybe<Scalars['ObjectId']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  amount?: Maybe<Scalars['Int']>,
  orderId?: Maybe<Scalars['String']>,
  transport?: Maybe<TransportInsertInput>,
  annotation?: Maybe<Scalars['String']>,
  isDangerousGood?: Maybe<Scalars['Boolean']>,
  dangerousGood?: Maybe<ProvingMaterialDangerousGoodInput>,
};

export type ProvingMaterialInsertInput = {
  materials: Array<ProvingMaterialInput>,
};

export type ProvingMaterialObjectFilterType = {
  _id?: Maybe<IdFilter>,
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  amount?: Maybe<IntFilter>,
  transport?: Maybe<TransportObjectFilterType>,
  orderId?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  group?: Maybe<StringFilter>,
  outboundExportedToSAP?: Maybe<BooleanFilter>,
  returnExportedToSAP?: Maybe<BooleanFilter>,
  isDangerousGood?: Maybe<BooleanFilter>,
  dangerousGood?: Maybe<DangerousGoodObjectFilterType>,
  opr?: Maybe<OprExists>,
};

export type ProvingMaterialUpdateInput = {
  amount?: Maybe<Scalars['Int']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  transport?: Maybe<TransportInsertInput>,
  orderId?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  group?: Maybe<Scalars['String']>,
  isDangerousGood?: Maybe<Scalars['Boolean']>,
  dangerousGood?: Maybe<ProvingMaterialDangerousGoodInput>,
};

export enum ProvingPermission {
  Read = 'read',
  Update = 'update',
  Delete = 'delete'
}

export type ProvingSortType = {
  _id?: Maybe<SortType>,
  id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  _snapshotTimestamp?: Maybe<SortType>,
  declineReason?: Maybe<SortType>,
  deletionPeriod?: Maybe<SortType>,
  deletionRule?: Maybe<SortType>,
  status?: Maybe<SortType>,
  title?: Maybe<SortType>,
  description?: Maybe<SortType>,
  dateTo?: Maybe<SortType>,
  dateFrom?: Maybe<SortType>,
  declined?: Maybe<SortType>,
  created?: Maybe<SortType>,
  modified?: Maybe<SortType>,
  department?: Maybe<SortType>,
  leadingDepartment?: Maybe<SortType>,
  costCentre?: Maybe<SortType>,
  sumOfCosts?: Maybe<SortType>,
  effectiveSumOfCosts?: Maybe<SortType>,
  newMails?: Maybe<SortType>,
  internalMemo?: Maybe<InternalMemoSortType>,
  arrivalSheet?: Maybe<GeneratedDocumentSortType>,
  applicationForm?: Maybe<GeneratedDocumentSortType>,
  nmf?: Maybe<NmfSortType>,
  specialUsage?: Maybe<SpecialUsageSortType>,
  type?: Maybe<SortType>,
  dvtWvtCheckDisabled?: Maybe<SortType>,
  headOfProvingCheckDisabled?: Maybe<SortType>,
  multiSelectEditorCheckEnabled?: Maybe<SortType>,
  serviceTeamIsEditing?: Maybe<SortType>,
  hrgIsEditing?: Maybe<SortType>,
  multiSelectResponsibleCheckEnabled?: Maybe<SortType>,
  multiSelectSubstituteCheckEnabled?: Maybe<SortType>,
  adminsOnlyResponsibleCheckEnabled?: Maybe<SortType>,
  adminsOnlySubstituteCheckEnabled?: Maybe<SortType>,
  enableGroups?: Maybe<SortType>,
  hasIncompleteBookings?: Maybe<SortType>,
  annotationParticipants?: Maybe<SortType>,
  annotationVehicles?: Maybe<SortType>,
  annotationResourceRequirements?: Maybe<SortType>,
  annotationResourceBookings?: Maybe<SortType>,
  annotationFiles?: Maybe<SortType>,
  annotationForms?: Maybe<SortType>,
  annotationMaterials?: Maybe<SortType>,
  materialsTransport?: Maybe<MaterialsTransportSortType>,
  materialsExportedToSAP?: Maybe<SortType>,
  relevance?: Maybe<SortType>,
};

export enum ProvingType {
  Normal = 'normal',
  Block = 'block',
  Continuous = 'continuous',
  BusinessTrip = 'businessTrip',
  GeVs = 'geVs'
}

/** Filter type for ProvingType scalar */
export type ProvingTypeFilter = {
  /** $eq */
  EQ?: Maybe<ProvingType>,
  /** $gt */
  GT?: Maybe<ProvingType>,
  /** $gte */
  GTE?: Maybe<ProvingType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ProvingType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ProvingType>>>,
  /** $lt */
  LT?: Maybe<ProvingType>,
  /** $lte */
  LTE?: Maybe<ProvingType>,
  /** $ne */
  NE?: Maybe<ProvingType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ProvingType>>>,
  /** $not */
  NOT?: Maybe<ProvingTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<ProvingType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<ProvingType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<ProvingType>,
};

/** Filter type for $not of ProvingType scalar */
export type ProvingTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<ProvingType>,
  /** $gt */
  GT?: Maybe<ProvingType>,
  /** $gte */
  GTE?: Maybe<ProvingType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ProvingType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ProvingType>>>,
  /** $lt */
  LT?: Maybe<ProvingType>,
  /** $lte */
  LTE?: Maybe<ProvingType>,
  /** $ne */
  NE?: Maybe<ProvingType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ProvingType>>>,
};

export type ProvingTypeSetting = {
  __typename?: 'ProvingTypeSetting',
  type: ProvingType,
  isActive: Scalars['Boolean'],
};

export type ProvingTypeSettingInput = {
  type: ProvingType,
  isActive: Scalars['Boolean'],
};

export type ProvingUpdateType = {
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  declineReason?: Maybe<Scalars['String']>,
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  declined?: Maybe<Scalars['DateTime']>,
  declinedBy?: Maybe<Scalars['ObjectId']>,
  department?: Maybe<Scalars['String']>,
  leadingDepartment?: Maybe<Scalars['String']>,
  responsible?: Maybe<Array<Scalars['ObjectId']>>,
  deputy?: Maybe<Array<Scalars['ObjectId']>>,
  editor?: Maybe<Array<Scalars['ObjectId']>>,
  maintenanceHead?: Maybe<Array<Scalars['ObjectId']>>,
  resourceManager?: Maybe<Array<Scalars['ObjectId']>>,
  costCentre?: Maybe<Scalars['String']>,
  sumOfCosts?: Maybe<Scalars['Float']>,
  effectiveSumOfCosts?: Maybe<Scalars['Float']>,
  newMails?: Maybe<Scalars['Int']>,
  hrgEditor?: Maybe<Array<Scalars['ObjectId']>>,
  orderIdDistribution?: Maybe<Array<OrderIdDistributionInputType>>,
  materials?: Maybe<Array<ProvingMaterialInput>>,
  internalMemo?: Maybe<InternalMemoInputType>,
  arrivalSheet?: Maybe<GeneratedDocumentInputType>,
  applicationForm?: Maybe<GeneratedDocumentInputType>,
  nmf?: Maybe<NmfInputType>,
  specialUsage?: Maybe<SpecialUsageInputType>,
  dvtWvtCheckDisabled?: Maybe<Scalars['Boolean']>,
  headOfProvingCheckDisabled?: Maybe<Scalars['Boolean']>,
  multiSelectEditorCheckEnabled?: Maybe<Scalars['Boolean']>,
  serviceTeamIsEditing?: Maybe<Scalars['Boolean']>,
  hrgIsEditing?: Maybe<Scalars['Boolean']>,
  multiSelectResponsibleCheckEnabled?: Maybe<Scalars['Boolean']>,
  multiSelectSubstituteCheckEnabled?: Maybe<Scalars['Boolean']>,
  adminsOnlyResponsibleCheckEnabled?: Maybe<Scalars['Boolean']>,
  adminsOnlySubstituteCheckEnabled?: Maybe<Scalars['Boolean']>,
  enableGroups?: Maybe<Scalars['Boolean']>,
  hasIncompleteBookings?: Maybe<Scalars['Boolean']>,
  annotationParticipants?: Maybe<Scalars['String']>,
  annotationVehicles?: Maybe<Scalars['String']>,
  annotationResourceRequirements?: Maybe<Scalars['String']>,
  annotationResourceBookings?: Maybe<Scalars['String']>,
  annotationFiles?: Maybe<Scalars['String']>,
  annotationForms?: Maybe<Scalars['String']>,
  annotationMaterials?: Maybe<Scalars['String']>,
  materialsTransport?: Maybe<MaterialsTransportInputType>,
  supportNeeds?: Maybe<SupportNeedsUpdateType>,
};

export enum ProvingUserRole {
  None = 'none',
  Editor = 'editor',
  Reader = 'reader',
  ProvingManager = 'provingManager',
  ResourceManager = 'resourceManager',
  Administrator = 'administrator',
  MaintenanceHead = 'maintenanceHead',
  ServiceTeam = 'serviceTeam'
}

export type Query = {
  __typename?: 'Query',
  _empty?: Maybe<Empty>,
  listBlobs?: Maybe<Array<Maybe<Blob>>>,
  convolute: Convolute,
  convolutes: Array<Convolute>,
  convoluteByType?: Maybe<Convolute>,
  dangerousGood?: Maybe<DangerousGood>,
  dangerousGoods: Array<DangerousGood>,
  department?: Maybe<Department>,
  departments: Array<Department>,
  departmentByHead?: Maybe<Department>,
  eqVehicle: EqVehicle,
  eqVehicles: Array<EqVehicle>,
  eqVehiclesByLabel: Array<EqVehicle>,
  eqVehicleModels: Array<EqVehicleModelInfo>,
  fileTemplate?: Maybe<FileTemplate>,
  fileTemplates: Array<FileTemplate>,
  gdprRule?: Maybe<GdprRule>,
  gdprRules: Array<GdprRule>,
  globalSettings: Array<GlobalSetting>,
  globalSetting: GlobalSetting,
  globalSettingByType?: Maybe<GlobalSetting>,
  mail?: Maybe<Mail>,
  mails: Array<Mail>,
  mailTemplate?: Maybe<MailTemplate>,
  mailTemplates: Array<MailTemplate>,
  maintenanceArea?: Maybe<MaintenanceArea>,
  maintenanceAreas: Array<MaintenanceArea>,
  allMaintenanceAreas: Array<Scalars['String']>,
  material?: Maybe<Material>,
  materials: Array<Material>,
  news?: Maybe<News>,
  multinews: Array<News>,
  orderId?: Maybe<OrderId>,
  orderIds: Array<OrderId>,
  participantChange?: Maybe<ParticipantChange>,
  participantChanges: Array<ParticipantChange>,
  principal?: Maybe<User>,
  user?: Maybe<User>,
  userByCalendarToken?: Maybe<User>,
  users: Array<Maybe<User>>,
  dbUser?: Maybe<User>,
  _dbUsers: Array<User>,
  proving?: Maybe<Proving>,
  provings: Array<Proving>,
  myBookings: Array<Proving>,
  cachedProvings: Array<Proving>,
  synergies: Array<Proving>,
  evaluateProving: Array<Proving>,
  provingChanges: Array<ProvingChange>,
  mailChanges: Array<ProvingChange>,
  acceptedProvingChanges: Array<ProvingChange>,
  provingGround?: Maybe<ProvingGround>,
  provingGrounds: Array<ProvingGround>,
  resourceCategories: Array<ResourceCategory>,
  resources: Array<Resource>,
  senderRecipient?: Maybe<SenderRecipient>,
  senderRecipients: Array<SenderRecipient>,
  wikiCheck?: Maybe<UserWikiCheck>,
  wiki?: Maybe<Wiki>,
  wikis: Array<Wiki>,
  evaluateWiki: Array<Wiki>,
  worker?: Maybe<Worker>,
  workers: Array<Worker>,
  workersByDepartment: Array<Scalars['String']>,
};


export type QueryListBlobsArgs = {
  parentId: Scalars['ID']
};


export type QueryConvoluteArgs = {
  id: Scalars['ID']
};


export type QueryConvolutesArgs = {
  filter?: Maybe<ConvoluteFilterType>,
  sort?: Maybe<ConvoluteSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryConvoluteByTypeArgs = {
  type: ConvoluteType
};


export type QueryDangerousGoodArgs = {
  id: Scalars['ID']
};


export type QueryDangerousGoodsArgs = {
  filter?: Maybe<DangerousGoodFilterType>,
  sort?: Maybe<DangerousGoodSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryDepartmentArgs = {
  _id: Scalars['ID']
};


export type QueryDepartmentsArgs = {
  filter?: Maybe<DepartmentFilterType>,
  sort?: Maybe<DepartmentSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryDepartmentByHeadArgs = {
  _id: Scalars['ID']
};


export type QueryEqVehicleArgs = {
  _id: Scalars['ID']
};


export type QueryEqVehiclesArgs = {
  model: Scalars['String']
};


export type QueryEqVehiclesByLabelArgs = {
  filter?: Maybe<EqVehicleFilterType>,
  sort?: Maybe<EqVehicleSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryFileTemplateArgs = {
  _id: Scalars['ID']
};


export type QueryFileTemplatesArgs = {
  filter?: Maybe<FileTemplateFilterType>,
  sort?: Maybe<FileTemplateSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryGdprRuleArgs = {
  id: Scalars['String']
};


export type QueryGdprRulesArgs = {
  filter?: Maybe<GdprRuleFilterType>,
  sort?: Maybe<GdprRuleSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryGlobalSettingArgs = {
  id: Scalars['ID']
};


export type QueryGlobalSettingByTypeArgs = {
  type: GlobalSettingType
};


export type QueryMailArgs = {
  _id: Scalars['ID']
};


export type QueryMailsArgs = {
  provingId?: Maybe<Scalars['String']>,
  filter?: Maybe<MailFilterType>,
  sort?: Maybe<MailSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryMailTemplateArgs = {
  _id: Scalars['ID']
};


export type QueryMailTemplatesArgs = {
  filter?: Maybe<MailTemplateFilterType>,
  sort?: Maybe<MailTemplateSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryMaintenanceAreaArgs = {
  _id: Scalars['ID']
};


export type QueryMaintenanceAreasArgs = {
  filter?: Maybe<MaintenanceAreaFilterType>,
  sort?: Maybe<MaintenanceAreaSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryMaterialArgs = {
  id: Scalars['String']
};


export type QueryMaterialsArgs = {
  filter?: Maybe<MaterialFilterType>,
  sort?: Maybe<MaterialSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryNewsArgs = {
  id: Scalars['String']
};


export type QueryMultinewsArgs = {
  filter?: Maybe<NewsFilterType>,
  sort?: Maybe<NewsSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryOrderIdArgs = {
  value: Scalars['String']
};


export type QueryOrderIdsArgs = {
  validOnly?: Scalars['Boolean'],
  filter?: Maybe<OrderIdFilterType>,
  sort?: Maybe<OrderIdSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryParticipantChangeArgs = {
  _id: Scalars['ID']
};


export type QueryParticipantChangesArgs = {
  filter?: Maybe<ParticipantChangeFilterType>,
  sort?: Maybe<ParticipantChangeSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryUserArgs = {
  id: Scalars['String']
};


export type QueryUserByCalendarTokenArgs = {
  token: Scalars['String']
};


export type QueryUsersArgs = {
  filter?: Maybe<Scalars['String']>
};


export type QueryDbUserArgs = {
  id: Scalars['String']
};


export type QueryProvingArgs = {
  id: Scalars['ID']
};


export type QueryProvingsArgs = {
  filter?: Maybe<ProvingFilterType>,
  sort?: Maybe<ProvingSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryCachedProvingsArgs = {
  filter?: Maybe<ProvingFilterType>,
  sort?: Maybe<ProvingSortType>,
  pagination?: Maybe<PaginationType>
};


export type QuerySynergiesArgs = {
  department?: Maybe<Scalars['String']>,
  vehicleType?: Maybe<Scalars['String']>,
  vehicleModel?: Maybe<Scalars['String']>,
  vehicleDerivative?: Maybe<Scalars['String']>,
  internalLabel?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  modelYear?: Maybe<Scalars['String']>,
  provingGround?: Maybe<Scalars['String']>,
  resource?: Maybe<Scalars['String']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>
};


export type QueryEvaluateProvingArgs = {
  person?: Maybe<Scalars['String']>
};


export type QueryMailChangesArgs = {
  provingId: Scalars['String'],
  participants: Array<Scalars['String']>,
  paths: Array<Scalars['String']>
};


export type QueryAcceptedProvingChangesArgs = {
  provingId: Scalars['String']
};


export type QueryProvingGroundArgs = {
  id: Scalars['String']
};


export type QueryProvingGroundsArgs = {
  filter?: Maybe<ProvingGroundFilterType>,
  sort?: Maybe<ProvingGroundSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryResourcesArgs = {
  filter?: Maybe<ResourceFilterType>,
  sort?: Maybe<ResourceSortType>,
  pagination?: Maybe<PaginationType>
};


export type QuerySenderRecipientArgs = {
  id: Scalars['String']
};


export type QuerySenderRecipientsArgs = {
  filter?: Maybe<SenderRecipientFilterType>,
  sort?: Maybe<SenderRecipientSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryWikiCheckArgs = {
  user: Scalars['String']
};


export type QueryWikiArgs = {
  _id: Scalars['ID']
};


export type QueryWikisArgs = {
  filter?: Maybe<WikiFilterType>,
  sort?: Maybe<WikiSortType>,
  pagination?: Maybe<PaginationType>
};


export type QueryEvaluateWikiArgs = {
  person?: Maybe<Scalars['String']>
};


export type QueryWorkerArgs = {
  id?: Maybe<Scalars['String']>
};


export type QueryWorkersArgs = {
  filter?: Maybe<WorkerFilterType>,
  sort?: Maybe<WorkerSortType>,
  pagination?: Maybe<PaginationType>
};

export type QueryOptions = {
  differentOutputType?: Maybe<Scalars['Boolean']>,
};

export type Refuelling = {
  __typename?: 'Refuelling',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  type?: Maybe<RefuellingType>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export enum RefuellingType {
  Fuel = 'fuel',
  FuelCard = 'fuelCard',
  ChargingInfrastructure = 'chargingInfrastructure',
  ChargingCard = 'chargingCard',
  MobileChargingStation = 'mobileChargingStation'
}

export type RentalCar = {
  __typename?: 'RentalCar',
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  carType?: Maybe<CarType>,
  note?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type RentalCarObjectFilterType = {
  dateTo?: Maybe<DateFilter>,
  dateFrom?: Maybe<DateFilter>,
  carType?: Maybe<CarTypeFilter>,
  note?: Maybe<StringFilter>,
  bookingStatus?: Maybe<BookingStatusFilter>,
  opr?: Maybe<OprExists>,
};

export type Resource = Node & {
  __typename?: 'Resource',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  type: Scalars['String'],
  legacyType?: Maybe<Scalars['String']>,
  category?: Maybe<Scalars['String']>,
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  rootId?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  notification?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  color?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  chassisNumber?: Maybe<Scalars['String']>,
  tuevSweden?: Maybe<Scalars['Boolean']>,
  tuevUntil?: Maybe<Scalars['String']>,
  origin?: Maybe<Scalars['String']>,
  destination?: Maybe<Scalars['String']>,
  location?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  land?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  contact?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  emailHRG?: Maybe<Scalars['String']>,
  active?: Maybe<Scalars['Boolean']>,
  external?: Maybe<Scalars['Boolean']>,
  usageTimespans?: Maybe<Array<UsageTimeSpan>>,
  parentId?: Maybe<Scalars['String']>,
  parent?: Maybe<Resource>,
};

export type ResourceBooking = Node & {
  __typename?: 'ResourceBooking',
  _id: Scalars['ID'],
  resource: Resource,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  status?: Maybe<ResourceBookingStatus>,
  usageTime?: Maybe<Scalars['Int']>,
  participantId?: Maybe<Scalars['String']>,
  _changes?: Maybe<ProvingChangeTracking>,
};

export type ResourceBookingAddInput = {
  resource: Scalars['String'],
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  orderIdDistribution?: Maybe<Array<OrderIdDistributionInputType>>,
  status?: Maybe<ResourceBookingStatus>,
  usageTime?: Maybe<Scalars['Int']>,
};

export type ResourceBookingBatchInput = {
  _id: Scalars['String'],
  update: ResourceBookingUpdateInput,
};

export type ResourceBookingObjectFilterType = {
  _id?: Maybe<IdFilter>,
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  orderId?: Maybe<StringFilter>,
  status?: Maybe<ResourceBookingStatusFilter>,
  usageTime?: Maybe<IntFilter>,
  participantId?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export enum ResourceBookingStatus {
  NotRequired = 'notRequired',
  Open = 'open',
  InProgress = 'inProgress',
  Finished = 'finished'
}

/** Filter type for ResourceBookingStatus scalar */
export type ResourceBookingStatusFilter = {
  /** $eq */
  EQ?: Maybe<ResourceBookingStatus>,
  /** $gt */
  GT?: Maybe<ResourceBookingStatus>,
  /** $gte */
  GTE?: Maybe<ResourceBookingStatus>,
  /** $in */
  IN?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
  /** $lt */
  LT?: Maybe<ResourceBookingStatus>,
  /** $lte */
  LTE?: Maybe<ResourceBookingStatus>,
  /** $ne */
  NE?: Maybe<ResourceBookingStatus>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
  /** $not */
  NOT?: Maybe<ResourceBookingStatusNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<ResourceBookingStatus>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<ResourceBookingStatus>,
};

/** Filter type for $not of ResourceBookingStatus scalar */
export type ResourceBookingStatusNotFilter = {
  /** $eq */
  EQ?: Maybe<ResourceBookingStatus>,
  /** $gt */
  GT?: Maybe<ResourceBookingStatus>,
  /** $gte */
  GTE?: Maybe<ResourceBookingStatus>,
  /** $in */
  IN?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
  /** $lt */
  LT?: Maybe<ResourceBookingStatus>,
  /** $lte */
  LTE?: Maybe<ResourceBookingStatus>,
  /** $ne */
  NE?: Maybe<ResourceBookingStatus>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ResourceBookingStatus>>>,
};

export type ResourceBookingUpdateInput = {
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  status?: Maybe<ResourceBookingStatus>,
  usageTime?: Maybe<Scalars['Int']>,
  participantId?: Maybe<Scalars['String']>,
};

export type ResourceCategory = {
  __typename?: 'ResourceCategory',
  _id: Scalars['String'],
  types: Array<Scalars['String']>,
};

export type ResourceCostDistributionInput = {
  resourceName: Scalars['String'],
  resource: Scalars['String'],
  cost: Scalars['Float'],
};

export type ResourceFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  type?: Maybe<StringFilter>,
  legacyType?: Maybe<StringFilter>,
  category?: Maybe<StringFilter>,
  title?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  rootId?: Maybe<StringFilter>,
  abbr?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  notification?: Maybe<StringFilter>,
  unit?: Maybe<StringFilter>,
  costPerUnit?: Maybe<FloatFilter>,
  color?: Maybe<StringFilter>,
  licensePlate?: Maybe<StringFilter>,
  chassisNumber?: Maybe<StringFilter>,
  tuevSweden?: Maybe<BooleanFilter>,
  tuevUntil?: Maybe<StringFilter>,
  origin?: Maybe<StringFilter>,
  destination?: Maybe<StringFilter>,
  location?: Maybe<StringFilter>,
  countryCode?: Maybe<StringFilter>,
  place?: Maybe<StringFilter>,
  address?: Maybe<StringFilter>,
  land?: Maybe<StringFilter>,
  phone?: Maybe<StringFilter>,
  fax?: Maybe<StringFilter>,
  contact?: Maybe<StringFilter>,
  email?: Maybe<StringFilter>,
  emailHRG?: Maybe<StringFilter>,
  active?: Maybe<BooleanFilter>,
  external?: Maybe<BooleanFilter>,
  usageTimespans?: Maybe<UsageTimeSpanObjectFilterType>,
  parentId?: Maybe<StringFilter>,
  OR?: Maybe<Array<Maybe<ResourceFilterType>>>,
  AND?: Maybe<Array<Maybe<ResourceFilterType>>>,
  NOR?: Maybe<Array<Maybe<ResourceFilterType>>>,
};

export type ResourceIncType = {
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type ResourceInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  type: Scalars['String'],
  legacyType?: Maybe<Scalars['String']>,
  category?: Maybe<Scalars['String']>,
  title: Scalars['String'],
  rootId?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  notification?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  color?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  chassisNumber?: Maybe<Scalars['String']>,
  tuevSweden?: Maybe<Scalars['Boolean']>,
  tuevUntil?: Maybe<Scalars['String']>,
  origin?: Maybe<Scalars['String']>,
  destination?: Maybe<Scalars['String']>,
  location?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  land?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  contact?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  emailHRG?: Maybe<Scalars['String']>,
  active?: Maybe<Scalars['Boolean']>,
  external?: Maybe<Scalars['Boolean']>,
  usageTimespans?: Maybe<Array<UsageTimeSpanInsertType>>,
  parentId?: Maybe<Scalars['String']>,
};

export type ResourceRequirement = Node & {
  __typename?: 'ResourceRequirement',
  _id: Scalars['ID'],
  resourceRequirementType: ResourceSelectionType,
  testTrack?: Maybe<TestTrack>,
  testTrackUsage?: Maybe<TestTrackUsage>,
  fuel?: Maybe<Fuel>,
  chargingInfrastructure?: Maybe<ChargingInfrastructure>,
  amount?: Maybe<Scalars['Int']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  racewayHours?: Maybe<Scalars['Int']>,
  orderIdDistribution?: Maybe<Array<OrderIdDistribution>>,
  status?: Maybe<ResourceRequirementStatus>,
  _changes?: Maybe<ProvingChangeTracking>,
};

export type ResourceRequirementAddInput = {
  resourceRequirementType: ResourceSelectionType,
  testTrack?: Maybe<Scalars['String']>,
  testTrackUsage?: Maybe<Scalars['String']>,
  fuel?: Maybe<Scalars['String']>,
  chargingInfrastructure?: Maybe<Scalars['String']>,
  amount?: Maybe<Scalars['Int']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  racewayHours?: Maybe<Scalars['Int']>,
  orderIdDistribution?: Maybe<Array<OrderIdDistributionInputType>>,
  status?: Maybe<ResourceRequirementStatus>,
};

export type ResourceRequirementBatchInput = {
  _id: Scalars['String'],
  update: ResourceRequirementUpdateInput,
};

export type ResourceRequirementObjectFilterType = {
  _id?: Maybe<IdFilter>,
  resourceRequirementType?: Maybe<ResourceSelectionTypeFilter>,
  amount?: Maybe<IntFilter>,
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  racewayHours?: Maybe<IntFilter>,
  orderIdDistribution?: Maybe<OrderIdDistributionObjectFilterType>,
  status?: Maybe<ResourceRequirementStatusFilter>,
  opr?: Maybe<OprExists>,
};

export enum ResourceRequirementStatus {
  NotRequired = 'notRequired',
  Open = 'open',
  InProgress = 'inProgress',
  Finished = 'finished'
}

/** Filter type for ResourceRequirementStatus scalar */
export type ResourceRequirementStatusFilter = {
  /** $eq */
  EQ?: Maybe<ResourceRequirementStatus>,
  /** $gt */
  GT?: Maybe<ResourceRequirementStatus>,
  /** $gte */
  GTE?: Maybe<ResourceRequirementStatus>,
  /** $in */
  IN?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
  /** $lt */
  LT?: Maybe<ResourceRequirementStatus>,
  /** $lte */
  LTE?: Maybe<ResourceRequirementStatus>,
  /** $ne */
  NE?: Maybe<ResourceRequirementStatus>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
  /** $not */
  NOT?: Maybe<ResourceRequirementStatusNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<ResourceRequirementStatus>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<ResourceRequirementStatus>,
};

/** Filter type for $not of ResourceRequirementStatus scalar */
export type ResourceRequirementStatusNotFilter = {
  /** $eq */
  EQ?: Maybe<ResourceRequirementStatus>,
  /** $gt */
  GT?: Maybe<ResourceRequirementStatus>,
  /** $gte */
  GTE?: Maybe<ResourceRequirementStatus>,
  /** $in */
  IN?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
  /** $lt */
  LT?: Maybe<ResourceRequirementStatus>,
  /** $lte */
  LTE?: Maybe<ResourceRequirementStatus>,
  /** $ne */
  NE?: Maybe<ResourceRequirementStatus>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ResourceRequirementStatus>>>,
};

export type ResourceRequirementUpdateInput = {
  amount?: Maybe<Scalars['Int']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  racewayHours?: Maybe<Scalars['Int']>,
  orderIdDistribution?: Maybe<Array<OrderIdDistributionInputType>>,
  status?: Maybe<ResourceRequirementStatus>,
  resourceRequirementType?: Maybe<ResourceSelectionType>,
  chargingInfrastructure?: Maybe<Scalars['String']>,
  fuel?: Maybe<Scalars['String']>,
  testTrack?: Maybe<Scalars['String']>,
  testTrackUsage?: Maybe<Scalars['String']>,
};

export enum ResourceSelectionType {
  Workstation = 'workstation',
  Garage = 'garage',
  LiftingPlatform = 'liftingPlatform',
  GroundWorkStation = 'groundWorkStation',
  ColdCell = 'coldCell',
  TestTrack = 'testTrack',
  ParkingSpace = 'parkingSpace',
  AccessCard = 'accessCard',
  FuelCard = 'fuelCard',
  Radio = 'radio',
  TestTrackUsage = 'testTrackUsage',
  Fuel = 'fuel',
  ChargingInfrastructure = 'chargingInfrastructure'
}

/** Filter type for ResourceSelectionType scalar */
export type ResourceSelectionTypeFilter = {
  /** $eq */
  EQ?: Maybe<ResourceSelectionType>,
  /** $gt */
  GT?: Maybe<ResourceSelectionType>,
  /** $gte */
  GTE?: Maybe<ResourceSelectionType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ResourceSelectionType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ResourceSelectionType>>>,
  /** $lt */
  LT?: Maybe<ResourceSelectionType>,
  /** $lte */
  LTE?: Maybe<ResourceSelectionType>,
  /** $ne */
  NE?: Maybe<ResourceSelectionType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ResourceSelectionType>>>,
  /** $not */
  NOT?: Maybe<ResourceSelectionTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<ResourceSelectionType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<ResourceSelectionType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<ResourceSelectionType>,
};

/** Filter type for $not of ResourceSelectionType scalar */
export type ResourceSelectionTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<ResourceSelectionType>,
  /** $gt */
  GT?: Maybe<ResourceSelectionType>,
  /** $gte */
  GTE?: Maybe<ResourceSelectionType>,
  /** $in */
  IN?: Maybe<Array<Maybe<ResourceSelectionType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<ResourceSelectionType>>>,
  /** $lt */
  LT?: Maybe<ResourceSelectionType>,
  /** $lte */
  LTE?: Maybe<ResourceSelectionType>,
  /** $ne */
  NE?: Maybe<ResourceSelectionType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<ResourceSelectionType>>>,
};

export type ResourceSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  type?: Maybe<Scalars['String']>,
  legacyType?: Maybe<Scalars['String']>,
  category?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  rootId?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  notification?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  color?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  chassisNumber?: Maybe<Scalars['String']>,
  tuevSweden?: Maybe<Scalars['Boolean']>,
  tuevUntil?: Maybe<Scalars['String']>,
  origin?: Maybe<Scalars['String']>,
  destination?: Maybe<Scalars['String']>,
  location?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  land?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  contact?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  emailHRG?: Maybe<Scalars['String']>,
  active?: Maybe<Scalars['Boolean']>,
  external?: Maybe<Scalars['Boolean']>,
  usageTimespans?: Maybe<Array<Maybe<UsageTimeSpanSetOnInsertType>>>,
  parentId?: Maybe<Scalars['String']>,
};

export type ResourceSetType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  type?: Maybe<Scalars['String']>,
  legacyType?: Maybe<Scalars['String']>,
  category?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  rootId?: Maybe<Scalars['String']>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  notification?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  color?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  chassisNumber?: Maybe<Scalars['String']>,
  tuevSweden?: Maybe<Scalars['Boolean']>,
  tuevUntil?: Maybe<Scalars['String']>,
  origin?: Maybe<Scalars['String']>,
  destination?: Maybe<Scalars['String']>,
  location?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  land?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  contact?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  emailHRG?: Maybe<Scalars['String']>,
  active?: Maybe<Scalars['Boolean']>,
  external?: Maybe<Scalars['Boolean']>,
  usageTimespans?: Maybe<Array<Maybe<UsageTimeSpanSetListObjectType>>>,
  parentId?: Maybe<Scalars['String']>,
};

export type ResourceSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  type?: Maybe<SortType>,
  legacyType?: Maybe<SortType>,
  category?: Maybe<SortType>,
  title?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
  rootId?: Maybe<SortType>,
  abbr?: Maybe<SortType>,
  annotation?: Maybe<SortType>,
  notification?: Maybe<SortType>,
  unit?: Maybe<SortType>,
  costPerUnit?: Maybe<SortType>,
  color?: Maybe<SortType>,
  licensePlate?: Maybe<SortType>,
  chassisNumber?: Maybe<SortType>,
  tuevSweden?: Maybe<SortType>,
  tuevUntil?: Maybe<SortType>,
  origin?: Maybe<SortType>,
  destination?: Maybe<SortType>,
  location?: Maybe<SortType>,
  countryCode?: Maybe<SortType>,
  place?: Maybe<SortType>,
  address?: Maybe<SortType>,
  land?: Maybe<SortType>,
  phone?: Maybe<SortType>,
  fax?: Maybe<SortType>,
  contact?: Maybe<SortType>,
  email?: Maybe<SortType>,
  emailHRG?: Maybe<SortType>,
  active?: Maybe<SortType>,
  external?: Maybe<SortType>,
  parentId?: Maybe<SortType>,
};

export type ResourceUpdateType = {
  setOnInsert?: Maybe<ResourceSetOnInsertType>,
  set?: Maybe<ResourceSetType>,
  inc?: Maybe<ResourceIncType>,
};

export type SenderRecipient = Node & {
  __typename?: 'SenderRecipient',
  _id: Scalars['ID'],
  _deleted?: Maybe<Scalars['Boolean']>,
  supplierNumber: Scalars['String'],
  countryCode?: Maybe<Scalars['String']>,
  name: Scalars['String'],
  place: Scalars['String'],
  postCode: Scalars['String'],
  street: Scalars['String'],
  phone?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type SenderRecipientFilterType = {
  _id?: Maybe<IdFilter>,
  _deleted?: Maybe<BooleanFilter>,
  supplierNumber?: Maybe<StringFilter>,
  countryCode?: Maybe<StringFilter>,
  name?: Maybe<StringFilter>,
  place?: Maybe<StringFilter>,
  postCode?: Maybe<StringFilter>,
  street?: Maybe<StringFilter>,
  phone?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<SenderRecipientFilterType>>>,
  AND?: Maybe<Array<Maybe<SenderRecipientFilterType>>>,
  NOR?: Maybe<Array<Maybe<SenderRecipientFilterType>>>,
};

export type SenderRecipientIncType = {
  /** 
 * IGNORE. Due to limitations of the package, objects with no incrementable
   * fields cannot be ommited. All input object types must have at least one field
 **/
  _FICTIVE_INC?: Maybe<Scalars['Int']>,
};

export type SenderRecipientInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  supplierNumber: Scalars['String'],
  countryCode?: Maybe<Scalars['String']>,
  name: Scalars['String'],
  place: Scalars['String'],
  postCode: Scalars['String'],
  street: Scalars['String'],
  phone?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type SenderRecipientSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  supplierNumber?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  postCode?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type SenderRecipientSetType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  supplierNumber?: Maybe<Scalars['String']>,
  countryCode?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  place?: Maybe<Scalars['String']>,
  postCode?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type SenderRecipientSortType = {
  _id?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  supplierNumber?: Maybe<SortType>,
  countryCode?: Maybe<SortType>,
  name?: Maybe<SortType>,
  place?: Maybe<SortType>,
  postCode?: Maybe<SortType>,
  street?: Maybe<SortType>,
  phone?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
};

export type SenderRecipientUpdateType = {
  setOnInsert?: Maybe<SenderRecipientSetOnInsertType>,
  set?: Maybe<SenderRecipientSetType>,
  inc?: Maybe<SenderRecipientIncType>,
};

/** 
 * Used for a setting that only has a single value
 * (e.g. the label of a checkbox)
 **/
export type SingleValueSetting = GlobalSetting & {
  __typename?: 'SingleValueSetting',
  _id: Scalars['ID'],
  type: GlobalSettingType,
  value: Scalars['String'],
};

export enum SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecialUsage = {
  __typename?: 'SpecialUsage',
  bySaturday?: Maybe<Scalars['Boolean']>,
  bySunday?: Maybe<Scalars['Boolean']>,
  byNight?: Maybe<Scalars['Boolean']>,
};

export type SpecialUsageInputType = {
  bySaturday?: Maybe<Scalars['Boolean']>,
  bySunday?: Maybe<Scalars['Boolean']>,
  byNight?: Maybe<Scalars['Boolean']>,
};

export type SpecialUsageObjectFilterType = {
  bySaturday?: Maybe<BooleanFilter>,
  bySunday?: Maybe<BooleanFilter>,
  byNight?: Maybe<BooleanFilter>,
  opr?: Maybe<OprExists>,
};

export type SpecialUsageSortType = {
  bySaturday?: Maybe<SortType>,
  bySunday?: Maybe<SortType>,
  byNight?: Maybe<SortType>,
};

/** Filter type for String scalar */
export type StringFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['String']>,
  /** $gt */
  GT?: Maybe<Scalars['String']>,
  /** $gte */
  GTE?: Maybe<Scalars['String']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** $lt */
  LT?: Maybe<Scalars['String']>,
  /** $lte */
  LTE?: Maybe<Scalars['String']>,
  /** $ne */
  NE?: Maybe<Scalars['String']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** $regex */
  REGEX?: Maybe<Scalars['String']>,
  /** $options. Modifiers for the $regex expression. Field is ignored on its own */
  OPTIONS?: Maybe<Scalars['String']>,
  /** $not */
  NOT?: Maybe<StringNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<Scalars['String']>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<Scalars['String']>,
};

/** Filter type for $not of String scalar */
export type StringNotFilter = {
  /** $eq */
  EQ?: Maybe<Scalars['String']>,
  /** $gt */
  GT?: Maybe<Scalars['String']>,
  /** $gte */
  GTE?: Maybe<Scalars['String']>,
  /** $in */
  IN?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** $lt */
  LT?: Maybe<Scalars['String']>,
  /** $lte */
  LTE?: Maybe<Scalars['String']>,
  /** $ne */
  NE?: Maybe<Scalars['String']>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** $regex */
  REGEX?: Maybe<Scalars['String']>,
  /** $options. Modifiers for the $regex expression. Field is ignored on its own */
  OPTIONS?: Maybe<Scalars['String']>,
};

/** Object Type */
export type SupportNeeds = {
  __typename?: 'SupportNeeds',
  ewg: Scalars['Boolean'],
  ewi: Scalars['Boolean'],
  evd: Scalars['Boolean'],
  hv: Scalars['Boolean'],
  noSupport: Scalars['Boolean'],
};

/** Input Type for Insertion */
export type SupportNeedsInsertType = {
  ewg?: Maybe<Scalars['Boolean']>,
  ewi?: Maybe<Scalars['Boolean']>,
  evd?: Maybe<Scalars['Boolean']>,
  hv?: Maybe<Scalars['Boolean']>,
  noSupport?: Maybe<Scalars['Boolean']>,
};

/** Input Type for Update */
export type SupportNeedsUpdateType = {
  ewg?: Maybe<Scalars['Boolean']>,
  ewi?: Maybe<Scalars['Boolean']>,
  evd?: Maybe<Scalars['Boolean']>,
  hv?: Maybe<Scalars['Boolean']>,
  noSupport?: Maybe<Scalars['Boolean']>,
};

export type TestTrack = {
  __typename?: 'TestTrack',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
  usages: Array<TestTrackUsage>,
};

export type TestTrackUsage = {
  __typename?: 'TestTrackUsage',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId: Scalars['String'],
  parent: TestTrack,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};

export type TrackHotel = {
  __typename?: 'TrackHotel',
  _id?: Maybe<Scalars['String']>,
  index?: Maybe<Scalars['Int']>,
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
  hotel?: Maybe<Lodging>,
  note?: Maybe<Scalars['String']>,
  bookingStatus?: Maybe<BookingStatus>,
};

export type TrackHotels = {
  __typename?: 'TrackHotels',
  outward?: Maybe<Array<TrackHotel>>,
  return?: Maybe<Array<TrackHotel>>,
};

export type TrackHotelsObjectFilterType = {
  opr?: Maybe<OprExists>,
};

export type Transport = {
  __typename?: 'Transport',
  transportType?: Maybe<TransportType>,
  bookingStatus?: Maybe<BookingStatus>,
  outboundTransportSender?: Maybe<SenderRecipient>,
  outboundTransportSenderTime?: Maybe<Scalars['String']>,
  outboundTransportSenderDate?: Maybe<Scalars['Date']>,
  outboundTransportSenderContact?: Maybe<Scalars['String']>,
  outboundTransportRecipient?: Maybe<SenderRecipient>,
  outboundTransportRecipientTime?: Maybe<Scalars['String']>,
  outboundTransportRecipientDate?: Maybe<Scalars['Date']>,
  outboundTransportRecipientContact?: Maybe<Scalars['String']>,
  returnTransportSender?: Maybe<SenderRecipient>,
  returnTransportSenderTime?: Maybe<Scalars['String']>,
  returnTransportSenderDate?: Maybe<Scalars['Date']>,
  returnTransportSenderContact?: Maybe<Scalars['String']>,
  returnTransportRecipient?: Maybe<SenderRecipient>,
  returnTransportRecipientTime?: Maybe<Scalars['String']>,
  returnTransportRecipientDate?: Maybe<Scalars['Date']>,
  returnTransportRecipientContact?: Maybe<Scalars['String']>,
};

export type TransportInsertInput = {
  transportType?: Maybe<TransportType>,
  bookingStatus?: Maybe<BookingStatus>,
  outboundTransportSender?: Maybe<Scalars['ObjectId']>,
  outboundTransportSenderTime?: Maybe<Scalars['String']>,
  outboundTransportSenderDate?: Maybe<Scalars['Date']>,
  outboundTransportSenderContact?: Maybe<Scalars['String']>,
  outboundTransportRecipient?: Maybe<Scalars['ObjectId']>,
  outboundTransportRecipientTime?: Maybe<Scalars['String']>,
  outboundTransportRecipientDate?: Maybe<Scalars['Date']>,
  outboundTransportRecipientContact?: Maybe<Scalars['String']>,
  returnTransportSender?: Maybe<Scalars['ObjectId']>,
  returnTransportSenderTime?: Maybe<Scalars['String']>,
  returnTransportSenderDate?: Maybe<Scalars['Date']>,
  returnTransportSenderContact?: Maybe<Scalars['String']>,
  returnTransportRecipient?: Maybe<Scalars['ObjectId']>,
  returnTransportRecipientTime?: Maybe<Scalars['String']>,
  returnTransportRecipientDate?: Maybe<Scalars['Date']>,
  returnTransportRecipientContact?: Maybe<Scalars['String']>,
};

export type TransportObjectFilterType = {
  transportType?: Maybe<TransportTypeFilter>,
  bookingStatus?: Maybe<BookingStatusFilter>,
  outboundTransportSenderTime?: Maybe<StringFilter>,
  outboundTransportSenderDate?: Maybe<DateFilter>,
  outboundTransportSenderContact?: Maybe<StringFilter>,
  outboundTransportRecipientTime?: Maybe<StringFilter>,
  outboundTransportRecipientDate?: Maybe<DateFilter>,
  outboundTransportRecipientContact?: Maybe<StringFilter>,
  returnTransportSenderTime?: Maybe<StringFilter>,
  returnTransportSenderDate?: Maybe<DateFilter>,
  returnTransportSenderContact?: Maybe<StringFilter>,
  returnTransportRecipientTime?: Maybe<StringFilter>,
  returnTransportRecipientDate?: Maybe<DateFilter>,
  returnTransportRecipientContact?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export enum TransportType {
  OutboundAndReturnTransport = 'outboundAndReturnTransport',
  OutboundTransport = 'outboundTransport',
  ReturnTransport = 'returnTransport',
  NoTransport = 'noTransport'
}

/** Filter type for TransportType scalar */
export type TransportTypeFilter = {
  /** $eq */
  EQ?: Maybe<TransportType>,
  /** $gt */
  GT?: Maybe<TransportType>,
  /** $gte */
  GTE?: Maybe<TransportType>,
  /** $in */
  IN?: Maybe<Array<Maybe<TransportType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<TransportType>>>,
  /** $lt */
  LT?: Maybe<TransportType>,
  /** $lte */
  LTE?: Maybe<TransportType>,
  /** $ne */
  NE?: Maybe<TransportType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<TransportType>>>,
  /** $not */
  NOT?: Maybe<TransportTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<TransportType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<TransportType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<TransportType>,
};

/** Filter type for $not of TransportType scalar */
export type TransportTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<TransportType>,
  /** $gt */
  GT?: Maybe<TransportType>,
  /** $gte */
  GTE?: Maybe<TransportType>,
  /** $in */
  IN?: Maybe<Array<Maybe<TransportType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<TransportType>>>,
  /** $lt */
  LT?: Maybe<TransportType>,
  /** $lte */
  LTE?: Maybe<TransportType>,
  /** $ne */
  NE?: Maybe<TransportType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<TransportType>>>,
};

export type UnionVehicle = InternalVehicle | ExternalVehicle;

export type UnknownPerson = {
  __typename?: 'UnknownPerson',
  isUnknown: Scalars['Boolean'],
  personType: PersonType,
  department?: Maybe<Scalars['String']>,
  supplier?: Maybe<Scalars['String']>,
  employee?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  surName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type UnknownPersonInput = {
  isUnknown?: Maybe<Scalars['Boolean']>,
  personType: PersonType,
  department?: Maybe<Scalars['String']>,
  supplier?: Maybe<Scalars['String']>,
  employee?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  surName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
};

export type UnknownPersonObjectFilterType = {
  isUnknown?: Maybe<BooleanFilter>,
  personType?: Maybe<PersonTypeFilter>,
  department?: Maybe<StringFilter>,
  supplier?: Maybe<StringFilter>,
  employee?: Maybe<StringFilter>,
  firstName?: Maybe<StringFilter>,
  surName?: Maybe<StringFilter>,
  email?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export type UpdateOptions = {
  differentOutputType?: Maybe<Scalars['Boolean']>,
  validateUpdateArgs?: Maybe<Scalars['Boolean']>,
  overwrite?: Maybe<Scalars['Boolean']>,
};


export type UsageTimeSpan = {
  __typename?: 'UsageTimeSpan',
  dateFrom: Scalars['Date'],
  dateTo: Scalars['Date'],
};

export type UsageTimeSpanInsertType = {
  dateFrom: Scalars['Date'],
  dateTo: Scalars['Date'],
};

export type UsageTimeSpanObjectFilterType = {
  dateFrom?: Maybe<DateFilter>,
  dateTo?: Maybe<DateFilter>,
  opr?: Maybe<OprExists>,
};

export type UsageTimeSpanSetListObjectType = {
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
};

export type UsageTimeSpanSetOnInsertType = {
  dateFrom?: Maybe<Scalars['Date']>,
  dateTo?: Maybe<Scalars['Date']>,
};

export type User = Node & Person & {
  __typename?: 'User',
  _id: Scalars['ID'],
  type: PersonType,
  upn: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  name: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  mobilePhone?: Maybe<Scalars['String']>,
  roles?: Maybe<Array<UserRole>>,
  avatarUrl?: Maybe<Scalars['String']>,
  participation?: Maybe<Array<Participant>>,
  calendarLink?: Maybe<Scalars['String']>,
  companyName?: Maybe<Scalars['String']>,
  userType: UserType,
  employeeId?: Maybe<Scalars['String']>,
  signature?: Maybe<Scalars['String']>,
  external: Scalars['Boolean'],
  extension?: Maybe<Scalars['String']>,
};


export type UserAvatarUrlArgs = {
  size?: Maybe<Scalars['Int']>
};

export type UserIncType = {
  /** 
 * IGNORE. Due to limitations of the package, objects with no incrementable
   * fields cannot be ommited. All input object types must have at least one field
 **/
  _FICTIVE_INC?: Maybe<Scalars['Int']>,
};

export type UserInsertType = {
  _id: Scalars['ID'],
  type: PersonType,
  upn: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  mobilePhone?: Maybe<Scalars['String']>,
  roles?: Maybe<Array<UserRole>>,
  companyName?: Maybe<Scalars['String']>,
  userType: UserType,
  employeeId?: Maybe<Scalars['String']>,
  signature?: Maybe<Scalars['String']>,
  extension?: Maybe<Scalars['String']>,
};

export type UserObjectFilterType = {
  _id?: Maybe<IdFilter>,
  type?: Maybe<PersonTypeFilter>,
  upn?: Maybe<StringFilter>,
  firstName?: Maybe<StringFilter>,
  lastName?: Maybe<StringFilter>,
  email?: Maybe<StringFilter>,
  department?: Maybe<StringFilter>,
  mobilePhone?: Maybe<StringFilter>,
  roles?: Maybe<UserRoleFilter>,
  companyName?: Maybe<StringFilter>,
  userType?: Maybe<UserTypeFilter>,
  employeeId?: Maybe<StringFilter>,
  signature?: Maybe<StringFilter>,
  extension?: Maybe<StringFilter>,
  opr?: Maybe<OprExists>,
};

export enum UserRole {
  None = 'NONE',
  ResourceManager = 'RESOURCE_MANAGER',
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR',
  User = 'USER',
  ProvingCreator = 'PROVING_CREATOR',
  Reader = 'READER',
  Hrg = 'HRG',
  ProvingOrganisation = 'PROVING_ORGANISATION',
  ServiceTeam = 'SERVICE_TEAM',
  Maintenancehead = 'MAINTENANCEHEAD'
}

/** Filter type for UserRole scalar */
export type UserRoleFilter = {
  /** $eq */
  EQ?: Maybe<UserRole>,
  /** $gt */
  GT?: Maybe<UserRole>,
  /** $gte */
  GTE?: Maybe<UserRole>,
  /** $in */
  IN?: Maybe<Array<Maybe<UserRole>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<UserRole>>>,
  /** $lt */
  LT?: Maybe<UserRole>,
  /** $lte */
  LTE?: Maybe<UserRole>,
  /** $ne */
  NE?: Maybe<UserRole>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<UserRole>>>,
  /** $not */
  NOT?: Maybe<UserRoleNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<UserRole>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<UserRole>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<UserRole>,
};

/** Filter type for $not of UserRole scalar */
export type UserRoleNotFilter = {
  /** $eq */
  EQ?: Maybe<UserRole>,
  /** $gt */
  GT?: Maybe<UserRole>,
  /** $gte */
  GTE?: Maybe<UserRole>,
  /** $in */
  IN?: Maybe<Array<Maybe<UserRole>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<UserRole>>>,
  /** $lt */
  LT?: Maybe<UserRole>,
  /** $lte */
  LTE?: Maybe<UserRole>,
  /** $ne */
  NE?: Maybe<UserRole>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<UserRole>>>,
};

export type UserSetObjectType = {
  _id?: Maybe<Scalars['ID']>,
  type?: Maybe<PersonType>,
  upn?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  mobilePhone?: Maybe<Scalars['String']>,
  roles?: Maybe<Array<Maybe<UserRole>>>,
  companyName?: Maybe<Scalars['String']>,
  userType?: Maybe<UserType>,
  employeeId?: Maybe<Scalars['String']>,
  signature?: Maybe<Scalars['String']>,
  extension?: Maybe<Scalars['String']>,
  /** 
 * If set to true, the object would be overwriten entirely, including fields that
   * are not specified. Non-null validation rules will apply. Once set to true, any
   * child object will overwriten invariably of the value set to this field.
 **/
  _OVERWRITE?: Maybe<Scalars['Boolean']>,
};

export type UserSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  type?: Maybe<PersonType>,
  upn?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  mobilePhone?: Maybe<Scalars['String']>,
  roles?: Maybe<Array<Maybe<UserRole>>>,
  companyName?: Maybe<Scalars['String']>,
  userType?: Maybe<UserType>,
  employeeId?: Maybe<Scalars['String']>,
  signature?: Maybe<Scalars['String']>,
  extension?: Maybe<Scalars['String']>,
};

export type UserSortType = {
  _id?: Maybe<SortType>,
  type?: Maybe<SortType>,
  upn?: Maybe<SortType>,
  firstName?: Maybe<SortType>,
  lastName?: Maybe<SortType>,
  email?: Maybe<SortType>,
  department?: Maybe<SortType>,
  mobilePhone?: Maybe<SortType>,
  companyName?: Maybe<SortType>,
  userType?: Maybe<SortType>,
  employeeId?: Maybe<SortType>,
  signature?: Maybe<SortType>,
  extension?: Maybe<SortType>,
};

export enum UserType {
  Guest = 'GUEST',
  Member = 'MEMBER'
}

/** Filter type for UserType scalar */
export type UserTypeFilter = {
  /** $eq */
  EQ?: Maybe<UserType>,
  /** $gt */
  GT?: Maybe<UserType>,
  /** $gte */
  GTE?: Maybe<UserType>,
  /** $in */
  IN?: Maybe<Array<Maybe<UserType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<UserType>>>,
  /** $lt */
  LT?: Maybe<UserType>,
  /** $lte */
  LTE?: Maybe<UserType>,
  /** $ne */
  NE?: Maybe<UserType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<UserType>>>,
  /** $not */
  NOT?: Maybe<UserTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<UserType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<UserType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<UserType>,
};

/** Filter type for $not of UserType scalar */
export type UserTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<UserType>,
  /** $gt */
  GT?: Maybe<UserType>,
  /** $gte */
  GTE?: Maybe<UserType>,
  /** $in */
  IN?: Maybe<Array<Maybe<UserType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<UserType>>>,
  /** $lt */
  LT?: Maybe<UserType>,
  /** $lte */
  LTE?: Maybe<UserType>,
  /** $ne */
  NE?: Maybe<UserType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<UserType>>>,
};

export type UserWikiCheck = Node & {
  __typename?: 'UserWikiCheck',
  _id: Scalars['ID'],
  user: Scalars['String'],
  modifiedWiki?: Maybe<Scalars['DateTime']>,
  modifiedNews?: Maybe<Scalars['DateTime']>,
};

export type Vehicle = {
  _id: Scalars['ID'],
  type: VehicleType,
  unknown: Scalars['Boolean'],
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  transport?: Maybe<Transport>,
  model?: Maybe<Scalars['String']>,
  group?: Maybe<Scalars['String']>,
  licensePlate?: Maybe<Scalars['String']>,
  licensePlateType?: Maybe<LicensePlateType>,
  vin?: Maybe<Scalars['String']>,
  exportedToSAP?: Maybe<Scalars['Boolean']>,
};

export type VehicleBatchInput = {
  _id: Scalars['ID'],
  update: VehicleUpdateInput,
};

export type VehicleInsertInput = {
  unknown?: Maybe<Scalars['Boolean']>,
  type?: Maybe<VehicleType>,
  model?: Maybe<Scalars['String']>,
  eqVehicle?: Maybe<Scalars['ObjectId']>,
  internalNumberUnknown?: Maybe<Scalars['Boolean']>,
  label?: Maybe<Scalars['String']>,
  licensePlateType?: Maybe<LicensePlateType>,
  licensePlate?: Maybe<Scalars['String']>,
  vin?: Maybe<Scalars['String']>,
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  transport?: Maybe<TransportInsertInput>,
  labelExternal?: Maybe<Scalars['String']>,
};

export type VehicleObjectFilterType = {
  _id?: Maybe<IdFilter>,
  type?: Maybe<VehicleTypeFilter>,
  unknown?: Maybe<BooleanFilter>,
  dateTo?: Maybe<DateFilter>,
  dateFrom?: Maybe<DateFilter>,
  orderId?: Maybe<StringFilter>,
  transport?: Maybe<TransportObjectFilterType>,
  model?: Maybe<StringFilter>,
  group?: Maybe<StringFilter>,
  licensePlate?: Maybe<StringFilter>,
  licensePlateType?: Maybe<LicensePlateTypeFilter>,
  vin?: Maybe<StringFilter>,
  exportedToSAP?: Maybe<BooleanFilter>,
  opr?: Maybe<OprExists>,
};

export enum VehicleType {
  Internal = 'internal',
  External = 'external'
}

/** Filter type for VehicleType scalar */
export type VehicleTypeFilter = {
  /** $eq */
  EQ?: Maybe<VehicleType>,
  /** $gt */
  GT?: Maybe<VehicleType>,
  /** $gte */
  GTE?: Maybe<VehicleType>,
  /** $in */
  IN?: Maybe<Array<Maybe<VehicleType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<VehicleType>>>,
  /** $lt */
  LT?: Maybe<VehicleType>,
  /** $lte */
  LTE?: Maybe<VehicleType>,
  /** $ne */
  NE?: Maybe<VehicleType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<VehicleType>>>,
  /** $not */
  NOT?: Maybe<VehicleTypeNotFilter>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  opr?: Maybe<Opr>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  value?: Maybe<VehicleType>,
  /** DEPRECATED: Switched to the more intuitive operator fields */
  values?: Maybe<Array<Maybe<VehicleType>>>,
  /** DEPRECATED: use NE */
  NEQ?: Maybe<VehicleType>,
};

/** Filter type for $not of VehicleType scalar */
export type VehicleTypeNotFilter = {
  /** $eq */
  EQ?: Maybe<VehicleType>,
  /** $gt */
  GT?: Maybe<VehicleType>,
  /** $gte */
  GTE?: Maybe<VehicleType>,
  /** $in */
  IN?: Maybe<Array<Maybe<VehicleType>>>,
  /** $all */
  ALL?: Maybe<Array<Maybe<VehicleType>>>,
  /** $lt */
  LT?: Maybe<VehicleType>,
  /** $lte */
  LTE?: Maybe<VehicleType>,
  /** $ne */
  NE?: Maybe<VehicleType>,
  /** $nin */
  NIN?: Maybe<Array<Maybe<VehicleType>>>,
};

export type VehicleUpdateInput = {
  unknown?: Maybe<Scalars['Boolean']>,
  type?: Maybe<VehicleType>,
  model?: Maybe<Scalars['String']>,
  eqVehicle?: Maybe<Scalars['ObjectId']>,
  internalNumberUnknown?: Maybe<Scalars['Boolean']>,
  label?: Maybe<Scalars['String']>,
  group?: Maybe<Scalars['String']>,
  licensePlateType?: Maybe<LicensePlateType>,
  licensePlate?: Maybe<Scalars['String']>,
  vin?: Maybe<Scalars['String']>,
  dateTo?: Maybe<Scalars['Date']>,
  dateFrom?: Maybe<Scalars['Date']>,
  orderId?: Maybe<Scalars['String']>,
  transport?: Maybe<TransportInsertInput>,
  labelExternal?: Maybe<Scalars['String']>,
};

export type Wiki = Node & {
  __typename?: 'Wiki',
  _id: Scalars['ID'],
  topic: Scalars['String'],
  provingGround?: Maybe<ProvingGround>,
  inactive?: Maybe<Scalars['Boolean']>,
  tag?: Maybe<Scalars['String']>,
  created?: Maybe<Scalars['DateTime']>,
  createdBy?: Maybe<User>,
  modified?: Maybe<Scalars['DateTime']>,
  modifiedBy?: Maybe<User>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  files?: Maybe<Array<Scalars['String']>>,
  filePreview?: Maybe<Scalars['String']>,
};

export type WikiCheckUpdate = {
  user: Scalars['String'],
  type: CheckType,
};

export type WikiCreateInput = {
  topic: Scalars['String'],
  provingGround?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  tag?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  deletionPeriod?: Maybe<Scalars['Float']>,
  deletionRule?: Maybe<Scalars['String']>,
  uploadFiles?: Maybe<Array<Maybe<Scalars['Upload']>>>,
  uploadPreview?: Maybe<Scalars['Upload']>,
};

export type WikiFilterType = {
  _id?: Maybe<IdFilter>,
  topic?: Maybe<StringFilter>,
  provingGround?: Maybe<ProvingGroundObjectFilterType>,
  inactive?: Maybe<BooleanFilter>,
  tag?: Maybe<StringFilter>,
  created?: Maybe<DateTimeFilter>,
  createdBy?: Maybe<UserObjectFilterType>,
  modified?: Maybe<DateTimeFilter>,
  modifiedBy?: Maybe<UserObjectFilterType>,
  deletionPeriod?: Maybe<FloatFilter>,
  deletionRule?: Maybe<StringFilter>,
  body?: Maybe<StringFilter>,
  files?: Maybe<StringFilter>,
  filePreview?: Maybe<StringFilter>,
  OR?: Maybe<Array<Maybe<WikiFilterType>>>,
  AND?: Maybe<Array<Maybe<WikiFilterType>>>,
  NOR?: Maybe<Array<Maybe<WikiFilterType>>>,
};

export type WikiSortType = {
  _id?: Maybe<SortType>,
  topic?: Maybe<SortType>,
  provingGround?: Maybe<ProvingGroundSortType>,
  inactive?: Maybe<SortType>,
  tag?: Maybe<SortType>,
  created?: Maybe<SortType>,
  createdBy?: Maybe<UserSortType>,
  modified?: Maybe<SortType>,
  modifiedBy?: Maybe<UserSortType>,
  deletionPeriod?: Maybe<SortType>,
  deletionRule?: Maybe<SortType>,
  body?: Maybe<SortType>,
  filePreview?: Maybe<SortType>,
};

export type WikiUpdateInput = {
  topic: Scalars['String'],
  provingGround?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
  tag?: Maybe<Scalars['String']>,
  body?: Maybe<Scalars['String']>,
  uploadFiles?: Maybe<Array<Maybe<Scalars['Upload']>>>,
  uploadPreview?: Maybe<Scalars['Upload']>,
  files?: Maybe<Array<Scalars['String']>>,
  filePreview?: Maybe<Scalars['String']>,
};

export type Worker = Node & Person & {
  __typename?: 'Worker',
  _id: Scalars['ID'],
  type: PersonType,
  _deleted?: Maybe<Scalars['Boolean']>,
  name: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  avatarUrl?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  company: Scalars['String'],
  /** pid: String! is now ID */
  annotation?: Maybe<Scalars['String']>,
  qBasic: Scalars['Boolean'],
  qTurbo: Scalars['Boolean'],
  qSupersport: Scalars['Boolean'],
  qNordschleife: Scalars['Boolean'],
  qMuLow: Scalars['Boolean'],
  qOffroad: Scalars['Boolean'],
  participation?: Maybe<Array<Participant>>,
  employeeId?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};


export type WorkerAvatarUrlArgs = {
  size?: Maybe<Scalars['Int']>
};

export type WorkerFilterType = {
  _id?: Maybe<IdFilter>,
  type?: Maybe<PersonTypeFilter>,
  _deleted?: Maybe<BooleanFilter>,
  email?: Maybe<StringFilter>,
  firstName?: Maybe<StringFilter>,
  lastName?: Maybe<StringFilter>,
  avatarUrl?: Maybe<StringFilter>,
  department?: Maybe<StringFilter>,
  company?: Maybe<StringFilter>,
  annotation?: Maybe<StringFilter>,
  qBasic?: Maybe<BooleanFilter>,
  qTurbo?: Maybe<BooleanFilter>,
  qSupersport?: Maybe<BooleanFilter>,
  qNordschleife?: Maybe<BooleanFilter>,
  qMuLow?: Maybe<BooleanFilter>,
  qOffroad?: Maybe<BooleanFilter>,
  employeeId?: Maybe<StringFilter>,
  inactive?: Maybe<BooleanFilter>,
  OR?: Maybe<Array<Maybe<WorkerFilterType>>>,
  AND?: Maybe<Array<Maybe<WorkerFilterType>>>,
  NOR?: Maybe<Array<Maybe<WorkerFilterType>>>,
};

export type WorkerIncType = {
  /** 
 * IGNORE. Due to limitations of the package, objects with no incrementable
   * fields cannot be ommited. All input object types must have at least one field
 **/
  _FICTIVE_INC?: Maybe<Scalars['Int']>,
};

export type WorkerInsertType = {
  _id?: Maybe<Scalars['ID']>,
  _deleted?: Maybe<Scalars['Boolean']>,
  email?: Maybe<Scalars['String']>,
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  avatarUrl?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  company: Scalars['String'],
  annotation?: Maybe<Scalars['String']>,
  qBasic: Scalars['Boolean'],
  qTurbo: Scalars['Boolean'],
  qSupersport: Scalars['Boolean'],
  qNordschleife: Scalars['Boolean'],
  qMuLow: Scalars['Boolean'],
  qOffroad: Scalars['Boolean'],
  employeeId?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type WorkerSetOnInsertType = {
  _id?: Maybe<Scalars['ID']>,
  type?: Maybe<PersonType>,
  _deleted?: Maybe<Scalars['Boolean']>,
  email?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  company?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  qBasic?: Maybe<Scalars['Boolean']>,
  qTurbo?: Maybe<Scalars['Boolean']>,
  qSupersport?: Maybe<Scalars['Boolean']>,
  qNordschleife?: Maybe<Scalars['Boolean']>,
  qMuLow?: Maybe<Scalars['Boolean']>,
  qOffroad?: Maybe<Scalars['Boolean']>,
  employeeId?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type WorkerSetType = {
  _id?: Maybe<Scalars['ID']>,
  type?: Maybe<PersonType>,
  _deleted?: Maybe<Scalars['Boolean']>,
  email?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
  department?: Maybe<Scalars['String']>,
  company?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  qBasic?: Maybe<Scalars['Boolean']>,
  qTurbo?: Maybe<Scalars['Boolean']>,
  qSupersport?: Maybe<Scalars['Boolean']>,
  qNordschleife?: Maybe<Scalars['Boolean']>,
  qMuLow?: Maybe<Scalars['Boolean']>,
  qOffroad?: Maybe<Scalars['Boolean']>,
  employeeId?: Maybe<Scalars['String']>,
  inactive?: Maybe<Scalars['Boolean']>,
};

export type WorkerSortType = {
  _id?: Maybe<SortType>,
  type?: Maybe<SortType>,
  _deleted?: Maybe<SortType>,
  email?: Maybe<SortType>,
  firstName?: Maybe<SortType>,
  lastName?: Maybe<SortType>,
  avatarUrl?: Maybe<SortType>,
  department?: Maybe<SortType>,
  company?: Maybe<SortType>,
  annotation?: Maybe<SortType>,
  qBasic?: Maybe<SortType>,
  qTurbo?: Maybe<SortType>,
  qSupersport?: Maybe<SortType>,
  qNordschleife?: Maybe<SortType>,
  qMuLow?: Maybe<SortType>,
  qOffroad?: Maybe<SortType>,
  employeeId?: Maybe<SortType>,
  inactive?: Maybe<SortType>,
};

export type WorkerUpdateType = {
  setOnInsert?: Maybe<WorkerSetOnInsertType>,
  set?: Maybe<WorkerSetType>,
  inc?: Maybe<WorkerIncType>,
};

export type Workstation = {
  __typename?: 'Workstation',
  _id: Scalars['String'],
  title: Scalars['String'],
  inactive: Scalars['Boolean'],
  parentId?: Maybe<Scalars['String']>,
  parent?: Maybe<Office>,
  abbr?: Maybe<Scalars['String']>,
  annotation?: Maybe<Scalars['String']>,
  unit?: Maybe<Scalars['String']>,
  costPerUnit?: Maybe<Scalars['Float']>,
};
